import _classCallCheck from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import t from "react";
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;

var e = {
  exports: {}
},
    i = {
  exports: {}
},
    s = {},
    r = "function" == typeof Symbol && Symbol.for,
    a = r ? Symbol.for("react.element") : 60103,
    n = r ? Symbol.for("react.portal") : 60106,
    o = r ? Symbol.for("react.fragment") : 60107,
    h = r ? Symbol.for("react.strict_mode") : 60108,
    p = r ? Symbol.for("react.profiler") : 60114,
    l = r ? Symbol.for("react.provider") : 60109,
    f = r ? Symbol.for("react.context") : 60110,
    c = r ? Symbol.for("react.async_mode") : 60111,
    u = r ? Symbol.for("react.concurrent_mode") : 60111,
    m = r ? Symbol.for("react.forward_ref") : 60112,
    d = r ? Symbol.for("react.suspense") : 60113,
    g = r ? Symbol.for("react.suspense_list") : 60120,
    y = r ? Symbol.for("react.memo") : 60115,
    v = r ? Symbol.for("react.lazy") : 60116,
    b = r ? Symbol.for("react.block") : 60121,
    _ = r ? Symbol.for("react.fundamental") : 60117,
    P = r ? Symbol.for("react.responder") : 60118,
    k = r ? Symbol.for("react.scope") : 60119;

function S(t) {
  if ("object" == typeof t && null !== t) {
    var e = t.$$typeof;

    switch (e) {
      case a:
        switch (t = t.type) {
          case c:
          case u:
          case o:
          case p:
          case h:
          case d:
            return t;

          default:
            switch (t = t && t.$$typeof) {
              case f:
              case m:
              case v:
              case y:
              case l:
                return t;

              default:
                return e;
            }

        }

      case n:
        return e;
    }
  }
}

function x(t) {
  return S(t) === u;
}

s.AsyncMode = c, s.ConcurrentMode = u, s.ContextConsumer = f, s.ContextProvider = l, s.Element = a, s.ForwardRef = m, s.Fragment = o, s.Lazy = v, s.Memo = y, s.Portal = n, s.Profiler = p, s.StrictMode = h, s.Suspense = d, s.isAsyncMode = function (t) {
  return x(t) || S(t) === c;
}, s.isConcurrentMode = x, s.isContextConsumer = function (t) {
  return S(t) === f;
}, s.isContextProvider = function (t) {
  return S(t) === l;
}, s.isElement = function (t) {
  return "object" == typeof t && null !== t && t.$$typeof === a;
}, s.isForwardRef = function (t) {
  return S(t) === m;
}, s.isFragment = function (t) {
  return S(t) === o;
}, s.isLazy = function (t) {
  return S(t) === v;
}, s.isMemo = function (t) {
  return S(t) === y;
}, s.isPortal = function (t) {
  return S(t) === n;
}, s.isProfiler = function (t) {
  return S(t) === p;
}, s.isStrictMode = function (t) {
  return S(t) === h;
}, s.isSuspense = function (t) {
  return S(t) === d;
}, s.isValidElementType = function (t) {
  return "string" == typeof t || "function" == typeof t || t === o || t === u || t === p || t === h || t === d || t === g || "object" == typeof t && null !== t && (t.$$typeof === v || t.$$typeof === y || t.$$typeof === l || t.$$typeof === f || t.$$typeof === m || t.$$typeof === _ || t.$$typeof === P || t.$$typeof === k || t.$$typeof === b);
}, s.typeOf = S;
var A = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

"production" !== process.env.NODE_ENV && function () {
  var t = "function" == typeof Symbol && Symbol.for,
      e = t ? Symbol.for("react.element") : 60103,
      i = t ? Symbol.for("react.portal") : 60106,
      s = t ? Symbol.for("react.fragment") : 60107,
      r = t ? Symbol.for("react.strict_mode") : 60108,
      a = t ? Symbol.for("react.profiler") : 60114,
      n = t ? Symbol.for("react.provider") : 60109,
      o = t ? Symbol.for("react.context") : 60110,
      h = t ? Symbol.for("react.async_mode") : 60111,
      p = t ? Symbol.for("react.concurrent_mode") : 60111,
      l = t ? Symbol.for("react.forward_ref") : 60112,
      f = t ? Symbol.for("react.suspense") : 60113,
      c = t ? Symbol.for("react.suspense_list") : 60120,
      u = t ? Symbol.for("react.memo") : 60115,
      m = t ? Symbol.for("react.lazy") : 60116,
      d = t ? Symbol.for("react.block") : 60121,
      g = t ? Symbol.for("react.fundamental") : 60117,
      y = t ? Symbol.for("react.responder") : 60118,
      v = t ? Symbol.for("react.scope") : 60119;

  function b(t) {
    if ("object" == typeof t && null !== t) {
      var c = t.$$typeof;

      switch (c) {
        case e:
          var d = t.type;

          switch (d) {
            case h:
            case p:
            case s:
            case a:
            case r:
            case f:
              return d;

            default:
              var g = d && d.$$typeof;

              switch (g) {
                case o:
                case l:
                case m:
                case u:
                case n:
                  return g;

                default:
                  return c;
              }

          }

        case i:
          return c;
      }
    }
  }

  var _ = h,
      P = p,
      k = o,
      S = n,
      x = e,
      w = l,
      D = s,
      C = m,
      E = u,
      T = i,
      F = a,
      M = r,
      I = f,
      L = !1;

  function O(t) {
    return b(t) === p;
  }

  A.AsyncMode = _, A.ConcurrentMode = P, A.ContextConsumer = k, A.ContextProvider = S, A.Element = x, A.ForwardRef = w, A.Fragment = D, A.Lazy = C, A.Memo = E, A.Portal = T, A.Profiler = F, A.StrictMode = M, A.Suspense = I, A.isAsyncMode = function (t) {
    return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(t) || b(t) === h;
  }, A.isConcurrentMode = O, A.isContextConsumer = function (t) {
    return b(t) === o;
  }, A.isContextProvider = function (t) {
    return b(t) === n;
  }, A.isElement = function (t) {
    return "object" == typeof t && null !== t && t.$$typeof === e;
  }, A.isForwardRef = function (t) {
    return b(t) === l;
  }, A.isFragment = function (t) {
    return b(t) === s;
  }, A.isLazy = function (t) {
    return b(t) === m;
  }, A.isMemo = function (t) {
    return b(t) === u;
  }, A.isPortal = function (t) {
    return b(t) === i;
  }, A.isProfiler = function (t) {
    return b(t) === a;
  }, A.isStrictMode = function (t) {
    return b(t) === r;
  }, A.isSuspense = function (t) {
    return b(t) === f;
  }, A.isValidElementType = function (t) {
    return "string" == typeof t || "function" == typeof t || t === s || t === p || t === a || t === r || t === f || t === c || "object" == typeof t && null !== t && (t.$$typeof === m || t.$$typeof === u || t.$$typeof === n || t.$$typeof === o || t.$$typeof === l || t.$$typeof === g || t.$$typeof === y || t.$$typeof === v || t.$$typeof === d);
  }, A.typeOf = b;
}(), "production" === process.env.NODE_ENV ? i.exports = s : i.exports = A
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
;
var w = Object.getOwnPropertySymbols,
    D = Object.prototype.hasOwnProperty,
    C = Object.prototype.propertyIsEnumerable;

function E(t) {
  if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}

var T = function () {
  try {
    if (!Object.assign) return !1;
    var t = new String("abc");
    if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

    for (var e = {}, i = 0; i < 10; i++) {
      e["_" + String.fromCharCode(i)] = i;
    }

    var s = Object.getOwnPropertyNames(e).map(function (t) {
      return e[t];
    });
    if ("0123456789" !== s.join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (t) {
      r[t] = t;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (t) {
    return !1;
  }
}() ? Object.assign : function (t, e) {
  for (var i, s, r = E(t), a = 1; a < arguments.length; a++) {
    for (var n in i = Object(arguments[a])) {
      D.call(i, n) && (r[n] = i[n]);
    }

    if (w) {
      s = w(i);

      for (var o = 0; o < s.length; o++) {
        C.call(i, s[o]) && (r[s[o]] = i[s[o]]);
      }
    }
  }

  return r;
},
    F = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    M = Function.call.bind(Object.prototype.hasOwnProperty),
    I = function I() {};

if ("production" !== process.env.NODE_ENV) {
  var L = F,
      O = {},
      R = M;

  I = function I(t) {
    var e = "Warning: " + t;
    "undefined" != typeof console && console.error(e);

    try {
      throw new Error(e);
    } catch (t) {}
  };
}

function V(t, e, i, s, r) {
  if ("production" !== process.env.NODE_ENV) for (var a in t) {
    if (R(t, a)) {
      var n;

      try {
        if ("function" != typeof t[a]) {
          var o = Error((s || "React class") + ": " + i + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[a] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
          throw o.name = "Invariant Violation", o;
        }

        n = t[a](e, a, s, i, null, L);
      } catch (t) {
        n = t;
      }

      if (!n || n instanceof Error || I((s || "React class") + ": type specification of " + i + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof n + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), n instanceof Error && !(n.message in O)) {
        O[n.message] = !0;
        var h = r ? r() : "";
        I("Failed " + i + " type: " + n.message + (null != h ? h : ""));
      }
    }
  }
}

V.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (O = {});
};

var j = V,
    z = i.exports,
    N = T,
    B = F,
    G = M,
    q = j,
    W = function W() {};

function $() {
  return null;
}

"production" !== process.env.NODE_ENV && (W = function W(t) {
  var e = "Warning: " + t;
  "undefined" != typeof console && console.error(e);

  try {
    throw new Error(e);
  } catch (t) {}
});

function Y() {}

function H() {}

H.resetWarningCache = Y;

if ("production" !== process.env.NODE_ENV) {
  var X = i.exports;

  e.exports = function (t, e) {
    var i = "function" == typeof Symbol && Symbol.iterator,
        s = "<<anonymous>>",
        r = {
      array: h("array"),
      bigint: h("bigint"),
      bool: h("boolean"),
      func: h("function"),
      number: h("number"),
      object: h("object"),
      string: h("string"),
      symbol: h("symbol"),
      any: o($),
      arrayOf: function arrayOf(t) {
        return o(function (e, i, s, r, a) {
          if ("function" != typeof t) return new n("Property `" + a + "` of component `" + s + "` has invalid PropType notation inside arrayOf.");
          var o = e[i];
          if (!Array.isArray(o)) return new n("Invalid " + r + " `" + a + "` of type `" + f(o) + "` supplied to `" + s + "`, expected an array.");

          for (var h = 0; h < o.length; h++) {
            var p = t(o, h, s, r, a + "[" + h + "]", B);
            if (p instanceof Error) return p;
          }

          return null;
        });
      },
      element: o(function (e, i, s, r, a) {
        var o = e[i];
        return t(o) ? null : new n("Invalid " + r + " `" + a + "` of type `" + f(o) + "` supplied to `" + s + "`, expected a single ReactElement.");
      }),
      elementType: o(function (t, e, i, s, r) {
        var a = t[e];
        return z.isValidElementType(a) ? null : new n("Invalid " + s + " `" + r + "` of type `" + f(a) + "` supplied to `" + i + "`, expected a single ReactElement type.");
      }),
      instanceOf: function instanceOf(t) {
        return o(function (e, i, r, a, o) {
          if (!(e[i] instanceof t)) {
            var h = t.name || s;
            return new n("Invalid " + a + " `" + o + "` of type `" + ((p = e[i]).constructor && p.constructor.name ? p.constructor.name : s) + "` supplied to `" + r + "`, expected instance of `" + h + "`.");
          }

          var p;
          return null;
        });
      },
      node: o(function (t, e, i, s, r) {
        return l(t[e]) ? null : new n("Invalid " + s + " `" + r + "` supplied to `" + i + "`, expected a ReactNode.");
      }),
      objectOf: function objectOf(t) {
        return o(function (e, i, s, r, a) {
          if ("function" != typeof t) return new n("Property `" + a + "` of component `" + s + "` has invalid PropType notation inside objectOf.");
          var o = e[i],
              h = f(o);
          if ("object" !== h) return new n("Invalid " + r + " `" + a + "` of type `" + h + "` supplied to `" + s + "`, expected an object.");

          for (var p in o) {
            if (G(o, p)) {
              var l = t(o, p, s, r, a + "." + p, B);
              if (l instanceof Error) return l;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(t) {
        if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && W(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), $;

        function e(e, i, s, r, o) {
          for (var h = e[i], p = 0; p < t.length; p++) {
            if (a(h, t[p])) return null;
          }

          var l = JSON.stringify(t, function (t, e) {
            return "symbol" === c(e) ? String(e) : e;
          });
          return new n("Invalid " + r + " `" + o + "` of value `" + String(h) + "` supplied to `" + s + "`, expected one of " + l + ".");
        }

        return o(e);
      },
      oneOfType: function oneOfType(t) {
        if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && W("Invalid argument supplied to oneOfType, expected an instance of array."), $;

        for (var e = 0; e < t.length; e++) {
          var i = t[e];
          if ("function" != typeof i) return W("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + u(i) + " at index " + e + "."), $;
        }

        return o(function (e, i, s, r, a) {
          for (var o = [], h = 0; h < t.length; h++) {
            var p = (0, t[h])(e, i, s, r, a, B);
            if (null == p) return null;
            p.data && G(p.data, "expectedType") && o.push(p.data.expectedType);
          }

          return new n("Invalid " + r + " `" + a + "` supplied to `" + s + "`" + (o.length > 0 ? ", expected one of type [" + o.join(", ") + "]" : "") + ".");
        });
      },
      shape: function shape(t) {
        return o(function (e, i, s, r, a) {
          var o = e[i],
              h = f(o);
          if ("object" !== h) return new n("Invalid " + r + " `" + a + "` of type `" + h + "` supplied to `" + s + "`, expected `object`.");

          for (var l in t) {
            var u = t[l];
            if ("function" != typeof u) return p(s, r, a, l, c(u));
            var m = u(o, l, s, r, a + "." + l, B);
            if (m) return m;
          }

          return null;
        });
      },
      exact: function exact(t) {
        return o(function (e, i, s, r, a) {
          var o = e[i],
              h = f(o);
          if ("object" !== h) return new n("Invalid " + r + " `" + a + "` of type `" + h + "` supplied to `" + s + "`, expected `object`.");
          var l = N({}, e[i], t);

          for (var u in l) {
            var m = t[u];
            if (G(t, u) && "function" != typeof m) return p(s, r, a, u, c(m));
            if (!m) return new n("Invalid " + r + " `" + a + "` key `" + u + "` supplied to `" + s + "`.\nBad object: " + JSON.stringify(e[i], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(t), null, "  "));
            var d = m(o, u, s, r, a + "." + u, B);
            if (d) return d;
          }

          return null;
        });
      }
    };

    function a(t, e) {
      return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
    }

    function n(t, e) {
      this.message = t, this.data = e && "object" == typeof e ? e : {}, this.stack = "";
    }

    function o(t) {
      if ("production" !== process.env.NODE_ENV) var i = {},
          r = 0;

      function a(a, o, h, p, l, f, c) {
        if (p = p || s, f = f || h, c !== B) {
          if (e) {
            var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw u.name = "Invariant Violation", u;
          }

          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var m = p + ":" + h;
            !i[m] && r < 3 && (W("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + p + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), i[m] = !0, r++);
          }
        }

        return null == o[h] ? a ? null === o[h] ? new n("The " + l + " `" + f + "` is marked as required in `" + p + "`, but its value is `null`.") : new n("The " + l + " `" + f + "` is marked as required in `" + p + "`, but its value is `undefined`.") : null : t(o, h, p, l, f);
      }

      var o = a.bind(null, !1);
      return o.isRequired = a.bind(null, !0), o;
    }

    function h(t) {
      return o(function (e, i, s, r, a, o) {
        var h = e[i];
        return f(h) !== t ? new n("Invalid " + r + " `" + a + "` of type `" + c(h) + "` supplied to `" + s + "`, expected `" + t + "`.", {
          expectedType: t
        }) : null;
      });
    }

    function p(t, e, i, s, r) {
      return new n((t || "React class") + ": " + e + " type `" + i + "." + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + r + "`.");
    }

    function l(e) {
      switch (typeof e) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !e;

        case "object":
          if (Array.isArray(e)) return e.every(l);
          if (null === e || t(e)) return !0;

          var s = function (t) {
            var e = t && (i && t[i] || t["@@iterator"]);
            if ("function" == typeof e) return e;
          }(e);

          if (!s) return !1;
          var r,
              a = s.call(e);

          if (s !== e.entries) {
            for (; !(r = a.next()).done;) {
              if (!l(r.value)) return !1;
            }
          } else for (; !(r = a.next()).done;) {
            var n = r.value;
            if (n && !l(n[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function f(t) {
      var e = typeof t;
      return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : function (t, e) {
        return "symbol" === t || !!e && ("Symbol" === e["@@toStringTag"] || "function" == typeof Symbol && e instanceof Symbol);
      }(e, t) ? "symbol" : e;
    }

    function c(t) {
      if (null == t) return "" + t;
      var e = f(t);

      if ("object" === e) {
        if (t instanceof Date) return "date";
        if (t instanceof RegExp) return "regexp";
      }

      return e;
    }

    function u(t) {
      var e = c(t);

      switch (e) {
        case "array":
        case "object":
          return "an " + e;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + e;

        default:
          return e;
      }
    }

    return n.prototype = Error.prototype, r.checkPropTypes = q, r.resetWarningCache = q.resetWarningCache, r.PropTypes = r, r;
  }(X.isElement, !0);
} else e.exports = function () {
  function t(t, e, i, s, r, a) {
    if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== a) {
      var n = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw n.name = "Invariant Violation", n;
    }
  }

  function e() {
    return t;
  }

  t.isRequired = t;
  var i = {
    array: t,
    bigint: t,
    bool: t,
    func: t,
    number: t,
    object: t,
    string: t,
    symbol: t,
    any: t,
    arrayOf: e,
    element: t,
    elementType: t,
    instanceOf: e,
    node: t,
    objectOf: e,
    oneOf: e,
    oneOfType: e,
    shape: e,
    exact: e,
    checkPropTypes: H,
    resetWarningCache: Y
  };
  return i.PropTypes = i, i;
}();

var U,
    J = e.exports,
    K = {
  exports: {}
};
U = K.exports, "undefined" != typeof navigator && (K.exports = function () {
  var t = "",
      e = !1,
      i = -999999,
      s = function s() {
    return t;
  };

  function r(t) {
    return document.createElement(t);
  }

  function a(t, e) {
    var i,
        s,
        r = t.length;

    for (i = 0; i < r; i += 1) {
      for (var a in s = t[i].prototype) {
        Object.prototype.hasOwnProperty.call(s, a) && (e.prototype[a] = s[a]);
      }
    }
  }

  function n(t, e) {
    return Object.getOwnPropertyDescriptor(t, e);
  }

  function o(t) {
    function e() {}

    return e.prototype = t, e;
  }

  var h = function () {
    function t(t) {
      this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
    }

    return t.prototype = {
      addAudio: function addAudio(t) {
        this.audios.push(t);
      },
      pause: function pause() {
        var t,
            e = this.audios.length;

        for (t = 0; t < e; t += 1) {
          this.audios[t].pause();
        }
      },
      resume: function resume() {
        var t,
            e = this.audios.length;

        for (t = 0; t < e; t += 1) {
          this.audios[t].resume();
        }
      },
      setRate: function setRate(t) {
        var e,
            i = this.audios.length;

        for (e = 0; e < i; e += 1) {
          this.audios[e].setRate(t);
        }
      },
      createAudio: function createAudio(t) {
        return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
          src: [t]
        }) : {
          isPlaying: !1,
          play: function play() {
            this.isPlaying = !0;
          },
          seek: function seek() {
            this.isPlaying = !1;
          },
          playing: function playing() {},
          rate: function rate() {},
          setVolume: function setVolume() {}
        };
      },
      setAudioFactory: function setAudioFactory(t) {
        this.audioFactory = t;
      },
      setVolume: function setVolume(t) {
        this._volume = t, this._updateVolume();
      },
      mute: function mute() {
        this._isMuted = !0, this._updateVolume();
      },
      unmute: function unmute() {
        this._isMuted = !1, this._updateVolume();
      },
      getVolume: function getVolume() {
        return this._volume;
      },
      _updateVolume: function _updateVolume() {
        var t,
            e = this.audios.length;

        for (t = 0; t < e; t += 1) {
          this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }
    }, function () {
      return new t();
    };
  }(),
      p = function () {
    function t(t, e) {
      var i,
          s = 0,
          r = [];

      switch (t) {
        case "int16":
        case "uint8c":
          i = 1;
          break;

        default:
          i = 1.1;
      }

      for (s = 0; s < e; s += 1) {
        r.push(i);
      }

      return r;
    }

    return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function (e, i) {
      return "float32" === e ? new Float32Array(i) : "int16" === e ? new Int16Array(i) : "uint8c" === e ? new Uint8ClampedArray(i) : t(e, i);
    } : t;
  }();

  function l(t) {
    return Array.apply(null, {
      length: t
    });
  }

  function f(t) {
    return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, f(t);
  }

  var c = !0,
      u = null,
      m = "",
      d = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      g = Math.pow,
      y = Math.sqrt,
      v = Math.floor,
      b = Math.min,
      _ = {};
  !function () {
    var t,
        e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"],
        i = e.length;

    for (t = 0; t < i; t += 1) {
      _[e[t]] = Math[e[t]];
    }
  }(), _.random = Math.random, _.abs = function (t) {
    if ("object" === f(t) && t.length) {
      var e,
          i = l(t.length),
          s = t.length;

      for (e = 0; e < s; e += 1) {
        i[e] = Math.abs(t[e]);
      }

      return i;
    }

    return Math.abs(t);
  };
  var P = 150,
      k = Math.PI / 180,
      S = .5519;

  function x(t, e, i, s) {
    this.type = t, this.currentTime = e, this.totalTime = i, this.direction = s < 0 ? -1 : 1;
  }

  function A(t, e) {
    this.type = t, this.direction = e < 0 ? -1 : 1;
  }

  function w(t, e, i, s) {
    this.type = t, this.currentLoop = i, this.totalLoops = e, this.direction = s < 0 ? -1 : 1;
  }

  function D(t, e, i) {
    this.type = t, this.firstFrame = e, this.totalFrames = i;
  }

  function C(t, e) {
    this.type = t, this.target = e;
  }

  function E(t, e) {
    this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
  }

  function T(t) {
    this.type = "configError", this.nativeError = t;
  }

  var F,
      M = (F = 0, function () {
    return m + "__lottie_element_" + (F += 1);
  });

  function I(t, e, i) {
    var s, r, a, n, o, h, p, l;

    switch (h = i * (1 - e), p = i * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e), l = i * (1 - (1 - o) * e), n % 6) {
      case 0:
        s = i, r = l, a = h;
        break;

      case 1:
        s = p, r = i, a = h;
        break;

      case 2:
        s = h, r = i, a = l;
        break;

      case 3:
        s = h, r = p, a = i;
        break;

      case 4:
        s = l, r = h, a = i;
        break;

      case 5:
        s = i, r = h, a = p;
    }

    return [s, r, a];
  }

  function L(t, e, i) {
    var s,
        r = Math.max(t, e, i),
        a = Math.min(t, e, i),
        n = r - a,
        o = 0 === r ? 0 : n / r,
        h = r / 255;

    switch (r) {
      case a:
        s = 0;
        break;

      case t:
        s = e - i + n * (e < i ? 6 : 0), s /= 6 * n;
        break;

      case e:
        s = i - t + 2 * n, s /= 6 * n;
        break;

      case i:
        s = t - e + 4 * n, s /= 6 * n;
    }

    return [s, o, h];
  }

  function O(t, e) {
    var i = L(255 * t[0], 255 * t[1], 255 * t[2]);
    return i[1] += e, i[1] > 1 ? i[1] = 1 : i[1] <= 0 && (i[1] = 0), I(i[0], i[1], i[2]);
  }

  function R(t, e) {
    var i = L(255 * t[0], 255 * t[1], 255 * t[2]);
    return i[2] += e, i[2] > 1 ? i[2] = 1 : i[2] < 0 && (i[2] = 0), I(i[0], i[1], i[2]);
  }

  function V(t, e) {
    var i = L(255 * t[0], 255 * t[1], 255 * t[2]);
    return i[0] += e / 360, i[0] > 1 ? i[0] -= 1 : i[0] < 0 && (i[0] += 1), I(i[0], i[1], i[2]);
  }

  !function () {
    var t,
        e,
        i = [];

    for (t = 0; t < 256; t += 1) {
      e = t.toString(16), i[t] = 1 === e.length ? "0" + e : e;
    }
  }();

  var j = function j() {
    return u;
  },
      z = function z(t) {
    P = t;
  },
      N = function N() {
    return P;
  };

  function B(t) {
    return document.createElementNS("http://www.w3.org/2000/svg", t);
  }

  function G(t) {
    return G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, G(t);
  }

  var q = function () {
    var t,
        i,
        s = 1,
        r = [],
        a = {
      onmessage: function onmessage() {},
      postMessage: function postMessage(e) {
        t({
          data: e
        });
      }
    },
        n = {
      postMessage: function postMessage(t) {
        a.onmessage({
          data: t
        });
      }
    };

    function o(i) {
      if (window.Worker && window.Blob && e) {
        var s = new Blob(["var _workerSelf = self; self.onmessage = ", i.toString()], {
          type: "text/javascript"
        }),
            r = URL.createObjectURL(s);
        return new Worker(r);
      }

      return t = i, a;
    }

    function h() {
      i || (i = o(function (t) {
        if (n.dataManager || (n.dataManager = function () {
          function t(r, a) {
            var n,
                o,
                h,
                p,
                l,
                c,
                u = r.length;

            for (o = 0; o < u; o += 1) {
              if ("ks" in (n = r[o]) && !n.completed) {
                if (n.completed = !0, n.tt && (r[o - 1].td = n.tt), n.hasMask) {
                  var m = n.masksProperties;

                  for (p = m.length, h = 0; h < p; h += 1) {
                    if (m[h].pt.k.i) s(m[h].pt.k);else for (c = m[h].pt.k.length, l = 0; l < c; l += 1) {
                      m[h].pt.k[l].s && s(m[h].pt.k[l].s[0]), m[h].pt.k[l].e && s(m[h].pt.k[l].e[0]);
                    }
                  }
                }

                0 === n.ty ? (n.layers = e(n.refId, a), t(n.layers, a)) : 4 === n.ty ? i(n.shapes) : 5 === n.ty && f(n);
              }
            }
          }

          function e(t, e) {
            var i = function (t, e) {
              for (var i = 0, s = e.length; i < s;) {
                if (e[i].id === t) return e[i];
                i += 1;
              }

              return null;
            }(t, e);

            return i ? i.layers.__used ? JSON.parse(JSON.stringify(i.layers)) : (i.layers.__used = !0, i.layers) : null;
          }

          function i(t) {
            var e, r, a;

            for (e = t.length - 1; e >= 0; e -= 1) {
              if ("sh" === t[e].ty) {
                if (t[e].ks.k.i) s(t[e].ks.k);else for (a = t[e].ks.k.length, r = 0; r < a; r += 1) {
                  t[e].ks.k[r].s && s(t[e].ks.k[r].s[0]), t[e].ks.k[r].e && s(t[e].ks.k[r].e[0]);
                }
              } else "gr" === t[e].ty && i(t[e].it);
            }
          }

          function s(t) {
            var e,
                i = t.i.length;

            for (e = 0; e < i; e += 1) {
              t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
            }
          }

          function r(t, e) {
            var i = e ? e.split(".") : [100, 100, 100];
            return t[0] > i[0] || !(i[0] > t[0]) && (t[1] > i[1] || !(i[1] > t[1]) && (t[2] > i[2] || !(i[2] > t[2]) && null));
          }

          var a,
              n = function () {
            var t = [4, 4, 14];

            function e(t) {
              var e,
                  i,
                  s,
                  r = t.length;

              for (e = 0; e < r; e += 1) {
                5 === t[e].ty && (s = void 0, s = (i = t[e]).t.d, i.t.d = {
                  k: [{
                    s: s,
                    t: 0
                  }]
                });
              }
            }

            return function (i) {
              if (r(t, i.v) && (e(i.layers), i.assets)) {
                var s,
                    a = i.assets.length;

                for (s = 0; s < a; s += 1) {
                  i.assets[s].layers && e(i.assets[s].layers);
                }
              }
            };
          }(),
              o = (a = [4, 7, 99], function (t) {
            if (t.chars && !r(a, t.v)) {
              var e,
                  s = t.chars.length;

              for (e = 0; e < s; e += 1) {
                var n = t.chars[e];
                n.data && n.data.shapes && (i(n.data.shapes), n.data.ip = 0, n.data.op = 99999, n.data.st = 0, n.data.sr = 1, n.data.ks = {
                  p: {
                    k: [0, 0],
                    a: 0
                  },
                  s: {
                    k: [100, 100],
                    a: 0
                  },
                  a: {
                    k: [0, 0],
                    a: 0
                  },
                  r: {
                    k: 0,
                    a: 0
                  },
                  o: {
                    k: 100,
                    a: 0
                  }
                }, t.chars[e].t || (n.data.shapes.push({
                  ty: "no"
                }), n.data.shapes[0].it.push({
                  p: {
                    k: [0, 0],
                    a: 0
                  },
                  s: {
                    k: [100, 100],
                    a: 0
                  },
                  a: {
                    k: [0, 0],
                    a: 0
                  },
                  r: {
                    k: 0,
                    a: 0
                  },
                  o: {
                    k: 100,
                    a: 0
                  },
                  sk: {
                    k: 0,
                    a: 0
                  },
                  sa: {
                    k: 0,
                    a: 0
                  },
                  ty: "tr"
                })));
              }
            }
          }),
              h = function () {
            var t = [5, 7, 15];

            function e(t) {
              var e,
                  i,
                  s = t.length;

              for (e = 0; e < s; e += 1) {
                5 === t[e].ty && (i = void 0, "number" == typeof (i = t[e].t.p).a && (i.a = {
                  a: 0,
                  k: i.a
                }), "number" == typeof i.p && (i.p = {
                  a: 0,
                  k: i.p
                }), "number" == typeof i.r && (i.r = {
                  a: 0,
                  k: i.r
                }));
              }
            }

            return function (i) {
              if (r(t, i.v) && (e(i.layers), i.assets)) {
                var s,
                    a = i.assets.length;

                for (s = 0; s < a; s += 1) {
                  i.assets[s].layers && e(i.assets[s].layers);
                }
              }
            };
          }(),
              p = function () {
            var t = [4, 1, 9];

            function e(t) {
              var i,
                  s,
                  r,
                  a = t.length;

              for (i = 0; i < a; i += 1) {
                if ("gr" === t[i].ty) e(t[i].it);else if ("fl" === t[i].ty || "st" === t[i].ty) if (t[i].c.k && t[i].c.k[0].i) for (r = t[i].c.k.length, s = 0; s < r; s += 1) {
                  t[i].c.k[s].s && (t[i].c.k[s].s[0] /= 255, t[i].c.k[s].s[1] /= 255, t[i].c.k[s].s[2] /= 255, t[i].c.k[s].s[3] /= 255), t[i].c.k[s].e && (t[i].c.k[s].e[0] /= 255, t[i].c.k[s].e[1] /= 255, t[i].c.k[s].e[2] /= 255, t[i].c.k[s].e[3] /= 255);
                } else t[i].c.k[0] /= 255, t[i].c.k[1] /= 255, t[i].c.k[2] /= 255, t[i].c.k[3] /= 255;
              }
            }

            function i(t) {
              var i,
                  s = t.length;

              for (i = 0; i < s; i += 1) {
                4 === t[i].ty && e(t[i].shapes);
              }
            }

            return function (e) {
              if (r(t, e.v) && (i(e.layers), e.assets)) {
                var s,
                    a = e.assets.length;

                for (s = 0; s < a; s += 1) {
                  e.assets[s].layers && i(e.assets[s].layers);
                }
              }
            };
          }(),
              l = function () {
            var t = [4, 4, 18];

            function e(t) {
              var i, s, r;

              for (i = t.length - 1; i >= 0; i -= 1) {
                if ("sh" === t[i].ty) {
                  if (t[i].ks.k.i) t[i].ks.k.c = t[i].closed;else for (r = t[i].ks.k.length, s = 0; s < r; s += 1) {
                    t[i].ks.k[s].s && (t[i].ks.k[s].s[0].c = t[i].closed), t[i].ks.k[s].e && (t[i].ks.k[s].e[0].c = t[i].closed);
                  }
                } else "gr" === t[i].ty && e(t[i].it);
              }
            }

            function i(t) {
              var i,
                  s,
                  r,
                  a,
                  n,
                  o,
                  h = t.length;

              for (s = 0; s < h; s += 1) {
                if ((i = t[s]).hasMask) {
                  var p = i.masksProperties;

                  for (a = p.length, r = 0; r < a; r += 1) {
                    if (p[r].pt.k.i) p[r].pt.k.c = p[r].cl;else for (o = p[r].pt.k.length, n = 0; n < o; n += 1) {
                      p[r].pt.k[n].s && (p[r].pt.k[n].s[0].c = p[r].cl), p[r].pt.k[n].e && (p[r].pt.k[n].e[0].c = p[r].cl);
                    }
                  }
                }

                4 === i.ty && e(i.shapes);
              }
            }

            return function (e) {
              if (r(t, e.v) && (i(e.layers), e.assets)) {
                var s,
                    a = e.assets.length;

                for (s = 0; s < a; s += 1) {
                  e.assets[s].layers && i(e.assets[s].layers);
                }
              }
            };
          }();

          function f(t) {
            0 === t.t.a.length && t.t.p;
          }

          var c = {
            completeData: function completeData(i) {
              i.__complete || (p(i), n(i), o(i), h(i), l(i), t(i.layers, i.assets), function (i, s) {
                if (i) {
                  var r = 0,
                      a = i.length;

                  for (r = 0; r < a; r += 1) {
                    1 === i[r].t && (i[r].data.layers = e(i[r].data.refId, s), t(i[r].data.layers, s));
                  }
                }
              }(i.chars, i.assets), i.__complete = !0);
            }
          };
          return c.checkColors = p, c.checkChars = o, c.checkPathProperties = h, c.checkShapes = l, c.completeLayers = t, c;
        }()), n.assetLoader || (n.assetLoader = function () {
          function t(t) {
            var e = t.getResponseHeader("content-type");
            return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === G(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
          }

          return {
            load: function load(e, i, s, r) {
              var a,
                  n = new XMLHttpRequest();

              try {
                n.responseType = "json";
              } catch (t) {}

              n.onreadystatechange = function () {
                if (4 === n.readyState) if (200 === n.status) a = t(n), s(a);else try {
                  a = t(n), s(a);
                } catch (t) {
                  r && r(t);
                }
              };

              try {
                n.open("GET", e, !0);
              } catch (t) {
                n.open("GET", i + "/" + e, !0);
              }

              n.send();
            }
          };
        }()), "loadAnimation" === t.data.type) n.assetLoader.load(t.data.path, t.data.fullPath, function (e) {
          n.dataManager.completeData(e), n.postMessage({
            id: t.data.id,
            payload: e,
            status: "success"
          });
        }, function () {
          n.postMessage({
            id: t.data.id,
            status: "error"
          });
        });else if ("complete" === t.data.type) {
          var e = t.data.animation;
          n.dataManager.completeData(e), n.postMessage({
            id: t.data.id,
            payload: e,
            status: "success"
          });
        } else "loadData" === t.data.type && n.assetLoader.load(t.data.path, t.data.fullPath, function (e) {
          n.postMessage({
            id: t.data.id,
            payload: e,
            status: "success"
          });
        }, function () {
          n.postMessage({
            id: t.data.id,
            status: "error"
          });
        });
      }), i.onmessage = function (t) {
        var e = t.data,
            i = e.id,
            s = r[i];
        r[i] = null, "success" === e.status ? s.onComplete(e.payload) : s.onError && s.onError();
      });
    }

    function p(t, e) {
      var i = "processId_" + (s += 1);
      return r[i] = {
        onComplete: t,
        onError: e
      }, i;
    }

    return {
      loadAnimation: function loadAnimation(t, e, s) {
        h();
        var r = p(e, s);
        i.postMessage({
          type: "loadAnimation",
          path: t,
          fullPath: window.location.origin + window.location.pathname,
          id: r
        });
      },
      loadData: function loadData(t, e, s) {
        h();
        var r = p(e, s);
        i.postMessage({
          type: "loadData",
          path: t,
          fullPath: window.location.origin + window.location.pathname,
          id: r
        });
      },
      completeAnimation: function completeAnimation(t, e, s) {
        h();
        var r = p(e, s);
        i.postMessage({
          type: "complete",
          animation: t,
          id: r
        });
      }
    };
  }(),
      W = function () {
    var t = function () {
      var t = r("canvas");
      t.width = 1, t.height = 1;
      var e = t.getContext("2d");
      return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t;
    }();

    function e() {
      this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
    }

    function i() {
      this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
    }

    function s(t, e, i) {
      var s = "";
      if (t.e) s = t.p;else if (e) {
        var r = t.p;
        -1 !== r.indexOf("images/") && (r = r.split("/")[1]), s = e + r;
      } else s = i, s += t.u ? t.u : "", s += t.p;
      return s;
    }

    function a(t) {
      var e = 0,
          i = setInterval(function () {
        (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(i)), e += 1;
      }.bind(this), 50);
    }

    function n(t) {
      var e = {
        assetData: t
      },
          i = s(t, this.assetsPath, this.path);
      return q.loadData(i, function (t) {
        e.img = t, this._footageLoaded();
      }.bind(this), function () {
        e.img = {}, this._footageLoaded();
      }.bind(this)), e;
    }

    function o() {
      this._imageLoaded = e.bind(this), this._footageLoaded = i.bind(this), this.testImageLoaded = a.bind(this), this.createFootageData = n.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
    }

    return o.prototype = {
      loadAssets: function loadAssets(t, e) {
        var i;
        this.imagesLoadedCb = e;
        var s = t.length;

        for (i = 0; i < s; i += 1) {
          t[i].layers || (t[i].t && "seq" !== t[i].t ? 3 === t[i].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[i]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[i]))));
        }
      },
      setAssetsPath: function setAssetsPath(t) {
        this.assetsPath = t || "";
      },
      setPath: function setPath(t) {
        this.path = t || "";
      },
      loadedImages: function loadedImages() {
        return this.totalImages === this.loadedAssets;
      },
      loadedFootages: function loadedFootages() {
        return this.totalFootages === this.loadedFootagesCount;
      },
      destroy: function destroy() {
        this.imagesLoadedCb = null, this.images.length = 0;
      },
      getAsset: function getAsset(t) {
        for (var e = 0, i = this.images.length; e < i;) {
          if (this.images[e].assetData === t) return this.images[e].img;
          e += 1;
        }

        return null;
      },
      createImgData: function createImgData(e) {
        var i = s(e, this.assetsPath, this.path),
            a = r("img");
        a.crossOrigin = "anonymous", a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", function () {
          n.img = t, this._imageLoaded();
        }.bind(this), !1), a.src = i;
        var n = {
          img: a,
          assetData: e
        };
        return n;
      },
      createImageData: function createImageData(e) {
        var i = s(e, this.assetsPath, this.path),
            r = B("image");
        d ? this.testImageLoaded(r) : r.addEventListener("load", this._imageLoaded, !1), r.addEventListener("error", function () {
          a.img = t, this._imageLoaded();
        }.bind(this), !1), r.setAttributeNS("http://www.w3.org/1999/xlink", "href", i), this._elementHelper.append ? this._elementHelper.append(r) : this._elementHelper.appendChild(r);
        var a = {
          img: r,
          assetData: e
        };
        return a;
      },
      imageLoaded: e,
      footageLoaded: i,
      setCacheType: function setCacheType(t, e) {
        "svg" === t ? (this._elementHelper = e, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
    }, o;
  }();

  function $() {}

  $.prototype = {
    triggerEvent: function triggerEvent(t, e) {
      if (this._cbs[t]) for (var i = this._cbs[t], s = 0; s < i.length; s += 1) {
        i[s](e);
      }
    },
    addEventListener: function addEventListener(t, e) {
      return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), function () {
        this.removeEventListener(t, e);
      }.bind(this);
    },
    removeEventListener: function removeEventListener(t, e) {
      if (e) {
        if (this._cbs[t]) {
          for (var i = 0, s = this._cbs[t].length; i < s;) {
            this._cbs[t][i] === e && (this._cbs[t].splice(i, 1), i -= 1, s -= 1), i += 1;
          }

          this._cbs[t].length || (this._cbs[t] = null);
        }
      } else this._cbs[t] = null;
    }
  };

  var Y = function () {
    function t(t) {
      for (var e, i = t.split("\r\n"), s = {}, r = 0, a = 0; a < i.length; a += 1) {
        2 === (e = i[a].split(":")).length && (s[e[0]] = e[1].trim(), r += 1);
      }

      if (0 === r) throw new Error();
      return s;
    }

    return function (e) {
      for (var i = [], s = 0; s < e.length; s += 1) {
        var r = e[s],
            a = {
          time: r.tm,
          duration: r.dr
        };

        try {
          a.payload = JSON.parse(e[s].cm);
        } catch (i) {
          try {
            a.payload = t(e[s].cm);
          } catch (t) {
            a.payload = {
              name: e[s].cm
            };
          }
        }

        i.push(a);
      }

      return i;
    };
  }(),
      H = function () {
    function t(t) {
      this.compositions.push(t);
    }

    return function () {
      function e(t) {
        for (var e = 0, i = this.compositions.length; e < i;) {
          if (this.compositions[e].data && this.compositions[e].data.nm === t) return this.compositions[e].prepareFrame && this.compositions[e].data.xt && this.compositions[e].prepareFrame(this.currentFrame), this.compositions[e].compInterface;
          e += 1;
        }

        return null;
      }

      return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e;
    };
  }(),
      X = {};

  function J(t) {
    return J = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, J(t);
  }

  var K = function K() {
    this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = M(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = c, this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = H(), this.imagePreloader = new W(), this.audioController = h(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new x("drawnFrame", 0, 0, 0);
  };

  a([$], K), K.prototype.setParams = function (t) {
    (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
    var e = "svg";
    t.animType ? e = t.animType : t.renderer && (e = t.renderer);
    var i = X[e];
    this.renderer = new i(this, t.rendererSettings), this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), q.loadAnimation(t.path, this.configAnimation, this.onSetupError));
  }, K.prototype.onSetupError = function () {
    this.trigger("data_failed");
  }, K.prototype.setupAnimation = function (t) {
    q.completeAnimation(t, this.configAnimation);
  }, K.prototype.setData = function (t, e) {
    e && "object" !== J(e) && (e = JSON.parse(e));
    var i = {
      wrapper: t,
      animationData: e
    },
        s = t.attributes;
    i.path = s.getNamedItem("data-animation-path") ? s.getNamedItem("data-animation-path").value : s.getNamedItem("data-bm-path") ? s.getNamedItem("data-bm-path").value : s.getNamedItem("bm-path") ? s.getNamedItem("bm-path").value : "", i.animType = s.getNamedItem("data-anim-type") ? s.getNamedItem("data-anim-type").value : s.getNamedItem("data-bm-type") ? s.getNamedItem("data-bm-type").value : s.getNamedItem("bm-type") ? s.getNamedItem("bm-type").value : s.getNamedItem("data-bm-renderer") ? s.getNamedItem("data-bm-renderer").value : s.getNamedItem("bm-renderer") ? s.getNamedItem("bm-renderer").value : "canvas";
    var r = s.getNamedItem("data-anim-loop") ? s.getNamedItem("data-anim-loop").value : s.getNamedItem("data-bm-loop") ? s.getNamedItem("data-bm-loop").value : s.getNamedItem("bm-loop") ? s.getNamedItem("bm-loop").value : "";
    "false" === r ? i.loop = !1 : "true" === r ? i.loop = !0 : "" !== r && (i.loop = parseInt(r, 10));
    var a = s.getNamedItem("data-anim-autoplay") ? s.getNamedItem("data-anim-autoplay").value : s.getNamedItem("data-bm-autoplay") ? s.getNamedItem("data-bm-autoplay").value : !s.getNamedItem("bm-autoplay") || s.getNamedItem("bm-autoplay").value;
    i.autoplay = "false" !== a, i.name = s.getNamedItem("data-name") ? s.getNamedItem("data-name").value : s.getNamedItem("data-bm-name") ? s.getNamedItem("data-bm-name").value : s.getNamedItem("bm-name") ? s.getNamedItem("bm-name").value : "", "false" === (s.getNamedItem("data-anim-prerender") ? s.getNamedItem("data-anim-prerender").value : s.getNamedItem("data-bm-prerender") ? s.getNamedItem("data-bm-prerender").value : s.getNamedItem("bm-prerender") ? s.getNamedItem("bm-prerender").value : "") && (i.prerender = !1), this.setParams(i);
  }, K.prototype.includeLayers = function (t) {
    t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
    var e,
        i,
        s = this.animationData.layers,
        r = s.length,
        a = t.layers,
        n = a.length;

    for (i = 0; i < n; i += 1) {
      for (e = 0; e < r;) {
        if (s[e].id === a[i].id) {
          s[e] = a[i];
          break;
        }

        e += 1;
      }
    }

    if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for (r = t.assets.length, e = 0; e < r; e += 1) {
      this.animationData.assets.push(t.assets[e]);
    }
    this.animationData.__complete = !1, q.completeAnimation(this.animationData, this.onSegmentComplete);
  }, K.prototype.onSegmentComplete = function (t) {
    this.animationData = t;
    var e = j();
    e && e.initExpressions(this), this.loadNextSegment();
  }, K.prototype.loadNextSegment = function () {
    var t = this.animationData.segments;
    if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
    var e = t.shift();
    this.timeCompleted = e.time * this.frameRate;
    var i = this.path + this.fileName + "_" + this.segmentPos + ".json";
    this.segmentPos += 1, q.loadData(i, this.includeLayers.bind(this), function () {
      this.trigger("data_failed");
    }.bind(this));
  }, K.prototype.loadSegments = function () {
    this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
  }, K.prototype.imagesLoaded = function () {
    this.trigger("loaded_images"), this.checkLoaded();
  }, K.prototype.preloadImages = function () {
    this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
  }, K.prototype.configAnimation = function (t) {
    if (this.renderer) try {
      this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = Y(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
    } catch (t) {
      this.triggerConfigError(t);
    }
  }, K.prototype.waitForFontsLoaded = function () {
    this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
  }, K.prototype.checkLoaded = function () {
    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
      this.isLoaded = !0;
      var t = j();
      t && t.initExpressions(this), this.renderer.initItems(), setTimeout(function () {
        this.trigger("DOMLoaded");
      }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
    }
  }, K.prototype.resize = function () {
    this.renderer.updateContainerSize();
  }, K.prototype.setSubframe = function (t) {
    this.isSubframeEnabled = !!t;
  }, K.prototype.gotoFrame = function () {
    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
  }, K.prototype.renderFrame = function () {
    if (!1 !== this.isLoaded && this.renderer) try {
      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
    } catch (t) {
      this.triggerRenderFrameError(t);
    }
  }, K.prototype.play = function (t) {
    t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
  }, K.prototype.pause = function (t) {
    t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
  }, K.prototype.togglePause = function (t) {
    t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause());
  }, K.prototype.stop = function (t) {
    t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
  }, K.prototype.getMarkerData = function (t) {
    for (var e, i = 0; i < this.markers.length; i += 1) {
      if ((e = this.markers[i]).payload && e.payload.name === t) return e;
    }

    return null;
  }, K.prototype.goToAndStop = function (t, e, i) {
    if (!i || this.name === i) {
      var s = Number(t);

      if (isNaN(s)) {
        var r = this.getMarkerData(t);
        r && this.goToAndStop(r.time, !0);
      } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);

      this.pause();
    }
  }, K.prototype.goToAndPlay = function (t, e, i) {
    if (!i || this.name === i) {
      var s = Number(t);

      if (isNaN(s)) {
        var r = this.getMarkerData(t);
        r && (r.duration ? this.playSegments([r.time, r.time + r.duration], !0) : this.goToAndStop(r.time, !0));
      } else this.goToAndStop(s, e, i);

      this.play();
    }
  }, K.prototype.advanceTime = function (t) {
    if (!0 !== this.isPaused && !1 !== this.isLoaded) {
      var e = this.currentRawFrame + t * this.frameModifier,
          i = !1;
      e >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (i = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (i = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), i && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
    }
  }, K.prototype.adjustSegment = function (t, e) {
    this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart");
  }, K.prototype.setSegment = function (t, e) {
    var i = -1;
    this.isPaused && (this.currentRawFrame + this.firstFrame < t ? i = t : this.currentRawFrame + this.firstFrame > e && (i = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== i && this.goToAndStop(i, !0);
  }, K.prototype.playSegments = function (t, e) {
    if (e && (this.segments.length = 0), "object" === J(t[0])) {
      var i,
          s = t.length;

      for (i = 0; i < s; i += 1) {
        this.segments.push(t[i]);
      }
    } else this.segments.push(t);

    this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
  }, K.prototype.resetSegments = function (t) {
    this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0);
  }, K.prototype.checkSegments = function (t) {
    return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
  }, K.prototype.destroy = function (t) {
    t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
  }, K.prototype.setCurrentRawFrameValue = function (t) {
    this.currentRawFrame = t, this.gotoFrame();
  }, K.prototype.setSpeed = function (t) {
    this.playSpeed = t, this.updaFrameModifier();
  }, K.prototype.setDirection = function (t) {
    this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
  }, K.prototype.setVolume = function (t, e) {
    e && this.name !== e || this.audioController.setVolume(t);
  }, K.prototype.getVolume = function () {
    return this.audioController.getVolume();
  }, K.prototype.mute = function (t) {
    t && this.name !== t || this.audioController.mute();
  }, K.prototype.unmute = function (t) {
    t && this.name !== t || this.audioController.unmute();
  }, K.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
  }, K.prototype.getPath = function () {
    return this.path;
  }, K.prototype.getAssetsPath = function (t) {
    var e = "";
    if (t.e) e = t.p;else if (this.assetsPath) {
      var i = t.p;
      -1 !== i.indexOf("images/") && (i = i.split("/")[1]), e = this.assetsPath + i;
    } else e = this.path, e += t.u ? t.u : "", e += t.p;
    return e;
  }, K.prototype.getAssetData = function (t) {
    for (var e = 0, i = this.assets.length; e < i;) {
      if (t === this.assets[e].id) return this.assets[e];
      e += 1;
    }

    return null;
  }, K.prototype.hide = function () {
    this.renderer.hide();
  }, K.prototype.show = function () {
    this.renderer.show();
  }, K.prototype.getDuration = function (t) {
    return t ? this.totalFrames : this.totalFrames / this.frameRate;
  }, K.prototype.updateDocumentData = function (t, e, i) {
    try {
      this.renderer.getElementByPath(t).updateDocumentData(e, i);
    } catch (t) {}
  }, K.prototype.trigger = function (t) {
    if (this._cbs && this._cbs[t]) switch (t) {
      case "enterFrame":
        this.triggerEvent(t, new x(t, this.currentFrame, this.totalFrames, this.frameModifier));
        break;

      case "drawnFrame":
        this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
        break;

      case "loopComplete":
        this.triggerEvent(t, new w(t, this.loop, this.playCount, this.frameMult));
        break;

      case "complete":
        this.triggerEvent(t, new A(t, this.frameMult));
        break;

      case "segmentStart":
        this.triggerEvent(t, new D(t, this.firstFrame, this.totalFrames));
        break;

      case "destroy":
        this.triggerEvent(t, new C(t, this));
        break;

      default:
        this.triggerEvent(t);
    }
    "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new x(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new w(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new A(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new D(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new C(t, this));
  }, K.prototype.triggerRenderFrameError = function (t) {
    var e = new E(t, this.currentFrame);
    this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
  }, K.prototype.triggerConfigError = function (t) {
    var e = new T(t, this.currentFrame);
    this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
  };

  var Z = function () {
    var t = {},
        e = [],
        i = 0,
        s = 0,
        a = 0,
        n = !0,
        o = !1;

    function h(t) {
      for (var i = 0, r = t.target; i < s;) {
        e[i].animation === r && (e.splice(i, 1), i -= 1, s -= 1, r.isPaused || f()), i += 1;
      }
    }

    function p(t, i) {
      if (!t) return null;

      for (var r = 0; r < s;) {
        if (e[r].elem === t && null !== e[r].elem) return e[r].animation;
        r += 1;
      }

      var a = new K();
      return c(a, t), a.setData(t, i), a;
    }

    function l() {
      a += 1, d();
    }

    function f() {
      a -= 1;
    }

    function c(t, i) {
      t.addEventListener("destroy", h), t.addEventListener("_active", l), t.addEventListener("_idle", f), e.push({
        elem: i,
        animation: t
      }), s += 1;
    }

    function u(t) {
      var r,
          h = t - i;

      for (r = 0; r < s; r += 1) {
        e[r].animation.advanceTime(h);
      }

      i = t, a && !o ? window.requestAnimationFrame(u) : n = !0;
    }

    function m(t) {
      i = t, window.requestAnimationFrame(u);
    }

    function d() {
      !o && a && n && (window.requestAnimationFrame(m), n = !1);
    }

    return t.registerAnimation = p, t.loadAnimation = function (t) {
      var e = new K();
      return c(e, null), e.setParams(t), e;
    }, t.setSpeed = function (t, i) {
      var r;

      for (r = 0; r < s; r += 1) {
        e[r].animation.setSpeed(t, i);
      }
    }, t.setDirection = function (t, i) {
      var r;

      for (r = 0; r < s; r += 1) {
        e[r].animation.setDirection(t, i);
      }
    }, t.play = function (t) {
      var i;

      for (i = 0; i < s; i += 1) {
        e[i].animation.play(t);
      }
    }, t.pause = function (t) {
      var i;

      for (i = 0; i < s; i += 1) {
        e[i].animation.pause(t);
      }
    }, t.stop = function (t) {
      var i;

      for (i = 0; i < s; i += 1) {
        e[i].animation.stop(t);
      }
    }, t.togglePause = function (t) {
      var i;

      for (i = 0; i < s; i += 1) {
        e[i].animation.togglePause(t);
      }
    }, t.searchAnimations = function (t, e, i) {
      var s,
          a = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))),
          n = a.length;

      for (s = 0; s < n; s += 1) {
        i && a[s].setAttribute("data-bm-type", i), p(a[s], t);
      }

      if (e && 0 === n) {
        i || (i = "svg");
        var o = document.getElementsByTagName("body")[0];
        o.innerText = "";
        var h = r("div");
        h.style.width = "100%", h.style.height = "100%", h.setAttribute("data-bm-type", i), o.appendChild(h), p(h, t);
      }
    }, t.resize = function () {
      var t;

      for (t = 0; t < s; t += 1) {
        e[t].animation.resize();
      }
    }, t.goToAndStop = function (t, i, r) {
      var a;

      for (a = 0; a < s; a += 1) {
        e[a].animation.goToAndStop(t, i, r);
      }
    }, t.destroy = function (t) {
      var i;

      for (i = s - 1; i >= 0; i -= 1) {
        e[i].animation.destroy(t);
      }
    }, t.freeze = function () {
      o = !0;
    }, t.unfreeze = function () {
      o = !1, d();
    }, t.setVolume = function (t, i) {
      var r;

      for (r = 0; r < s; r += 1) {
        e[r].animation.setVolume(t, i);
      }
    }, t.mute = function (t) {
      var i;

      for (i = 0; i < s; i += 1) {
        e[i].animation.mute(t);
      }
    }, t.unmute = function (t) {
      var i;

      for (i = 0; i < s; i += 1) {
        e[i].animation.unmute(t);
      }
    }, t.getRegisteredAnimations = function () {
      var t,
          i = e.length,
          s = [];

      for (t = 0; t < i; t += 1) {
        s.push(e[t].animation);
      }

      return s;
    }, t;
  }(),
      Q = function () {
    var t = {
      getBezierEasing: function getBezierEasing(t, i, s, r, a) {
        var n = a || ("bez_" + t + "_" + i + "_" + s + "_" + r).replace(/\./g, "p");
        if (e[n]) return e[n];
        var o = new p([t, i, s, r]);
        return e[n] = o, o;
      }
    },
        e = {},
        i = .1,
        s = "function" == typeof Float32Array;

    function r(t, e) {
      return 1 - 3 * e + 3 * t;
    }

    function a(t, e) {
      return 3 * e - 6 * t;
    }

    function n(t) {
      return 3 * t;
    }

    function o(t, e, i) {
      return ((r(e, i) * t + a(e, i)) * t + n(e)) * t;
    }

    function h(t, e, i) {
      return 3 * r(e, i) * t * t + 2 * a(e, i) * t + n(e);
    }

    function p(t) {
      this._p = t, this._mSampleValues = s ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
    }

    return p.prototype = {
      get: function get(t) {
        var e = this._p[0],
            i = this._p[1],
            s = this._p[2],
            r = this._p[3];
        return this._precomputed || this._precompute(), e === i && s === r ? t : 0 === t ? 0 : 1 === t ? 1 : o(this._getTForX(t), i, r);
      },
      _precompute: function _precompute() {
        var t = this._p[0],
            e = this._p[1],
            i = this._p[2],
            s = this._p[3];
        this._precomputed = !0, t === e && i === s || this._calcSampleValues();
      },
      _calcSampleValues: function _calcSampleValues() {
        for (var t = this._p[0], e = this._p[2], s = 0; s < 11; ++s) {
          this._mSampleValues[s] = o(s * i, t, e);
        }
      },
      _getTForX: function _getTForX(t) {
        for (var e = this._p[0], s = this._p[2], r = this._mSampleValues, a = 0, n = 1; 10 !== n && r[n] <= t; ++n) {
          a += i;
        }

        var p = a + (t - r[--n]) / (r[n + 1] - r[n]) * i,
            l = h(p, e, s);
        return l >= .001 ? function (t, e, i, s) {
          for (var r = 0; r < 4; ++r) {
            var a = h(e, i, s);
            if (0 === a) return e;
            e -= (o(e, i, s) - t) / a;
          }

          return e;
        }(t, p, e, s) : 0 === l ? p : function (t, e, i, s, r) {
          var a,
              n,
              h = 0;

          do {
            (a = o(n = e + (i - e) / 2, s, r) - t) > 0 ? i = n : e = n;
          } while (Math.abs(a) > 1e-7 && ++h < 10);

          return n;
        }(t, a, a + i, e, s);
      }
    }, t;
  }(),
      tt = {
    double: function double(t) {
      return t.concat(l(t.length));
    }
  },
      et = function et(t, e, i) {
    var s = 0,
        r = t,
        a = l(r);
    return {
      newElement: function newElement() {
        return s ? a[s -= 1] : e();
      },
      release: function release(t) {
        s === r && (a = tt.double(a), r *= 2), i && i(t), a[s] = t, s += 1;
      }
    };
  },
      it = et(8, function () {
    return {
      addedLength: 0,
      percents: p("float32", N()),
      lengths: p("float32", N())
    };
  }),
      st = et(8, function () {
    return {
      lengths: [],
      totalLength: 0
    };
  }, function (t) {
    var e,
        i = t.lengths.length;

    for (e = 0; e < i; e += 1) {
      it.release(t.lengths[e]);
    }

    t.lengths.length = 0;
  }),
      rt = function () {
    var t = Math;

    function e(t, e, i, s, r, a) {
      var n = t * s + e * r + i * a - r * s - a * t - i * e;
      return n > -.001 && n < .001;
    }

    var i = function i(t, e, _i, s) {
      var r,
          a,
          n,
          o,
          h,
          p,
          l = N(),
          f = 0,
          c = [],
          u = [],
          m = it.newElement();

      for (n = _i.length, r = 0; r < l; r += 1) {
        for (h = r / (l - 1), p = 0, a = 0; a < n; a += 1) {
          o = g(1 - h, 3) * t[a] + 3 * g(1 - h, 2) * h * _i[a] + 3 * (1 - h) * g(h, 2) * s[a] + g(h, 3) * e[a], c[a] = o, null !== u[a] && (p += g(c[a] - u[a], 2)), u[a] = c[a];
        }

        p && (f += p = y(p)), m.percents[r] = h, m.lengths[r] = f;
      }

      return m.addedLength = f, m;
    };

    function s(t) {
      this.segmentLength = 0, this.points = new Array(t);
    }

    function r(t, e) {
      this.partialLength = t, this.point = e;
    }

    var a,
        n = (a = {}, function (t, i, n, o) {
      var h = (t[0] + "_" + t[1] + "_" + i[0] + "_" + i[1] + "_" + n[0] + "_" + n[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");

      if (!a[h]) {
        var p,
            f,
            c,
            u,
            m,
            d,
            v,
            b = N(),
            _ = 0,
            P = null;
        2 === t.length && (t[0] !== i[0] || t[1] !== i[1]) && e(t[0], t[1], i[0], i[1], t[0] + n[0], t[1] + n[1]) && e(t[0], t[1], i[0], i[1], i[0] + o[0], i[1] + o[1]) && (b = 2);
        var k = new s(b);

        for (c = n.length, p = 0; p < b; p += 1) {
          for (v = l(c), m = p / (b - 1), d = 0, f = 0; f < c; f += 1) {
            u = g(1 - m, 3) * t[f] + 3 * g(1 - m, 2) * m * (t[f] + n[f]) + 3 * (1 - m) * g(m, 2) * (i[f] + o[f]) + g(m, 3) * i[f], v[f] = u, null !== P && (d += g(v[f] - P[f], 2));
          }

          _ += d = y(d), k.points[p] = new r(d, v), P = v;
        }

        k.segmentLength = _, a[h] = k;
      }

      return a[h];
    });

    function o(t, e) {
      var i = e.percents,
          s = e.lengths,
          r = i.length,
          a = v((r - 1) * t),
          n = t * e.addedLength,
          o = 0;
      if (a === r - 1 || 0 === a || n === s[a]) return i[a];

      for (var h = s[a] > n ? -1 : 1, p = !0; p;) {
        if (s[a] <= n && s[a + 1] > n ? (o = (n - s[a]) / (s[a + 1] - s[a]), p = !1) : a += h, a < 0 || a >= r - 1) {
          if (a === r - 1) return i[a];
          p = !1;
        }
      }

      return i[a] + (i[a + 1] - i[a]) * o;
    }

    var h = p("float32", 8);
    return {
      getSegmentsLength: function getSegmentsLength(t) {
        var e,
            s = st.newElement(),
            r = t.c,
            a = t.v,
            n = t.o,
            o = t.i,
            h = t._length,
            p = s.lengths,
            l = 0;

        for (e = 0; e < h - 1; e += 1) {
          p[e] = i(a[e], a[e + 1], n[e], o[e + 1]), l += p[e].addedLength;
        }

        return r && h && (p[e] = i(a[e], a[0], n[e], o[0]), l += p[e].addedLength), s.totalLength = l, s;
      },
      getNewSegment: function getNewSegment(e, i, s, r, a, n, p) {
        a < 0 ? a = 0 : a > 1 && (a = 1);

        var l,
            f = o(a, p),
            c = o(n = n > 1 ? 1 : n, p),
            u = e.length,
            m = 1 - f,
            d = 1 - c,
            g = m * m * m,
            y = f * m * m * 3,
            v = f * f * m * 3,
            b = f * f * f,
            _ = m * m * d,
            P = f * m * d + m * f * d + m * m * c,
            k = f * f * d + m * f * c + f * m * c,
            S = f * f * c,
            x = m * d * d,
            A = f * d * d + m * c * d + m * d * c,
            w = f * c * d + m * c * c + f * d * c,
            D = f * c * c,
            C = d * d * d,
            E = c * d * d + d * c * d + d * d * c,
            T = c * c * d + d * c * c + c * d * c,
            F = c * c * c;

        for (l = 0; l < u; l += 1) {
          h[4 * l] = t.round(1e3 * (g * e[l] + y * s[l] + v * r[l] + b * i[l])) / 1e3, h[4 * l + 1] = t.round(1e3 * (_ * e[l] + P * s[l] + k * r[l] + S * i[l])) / 1e3, h[4 * l + 2] = t.round(1e3 * (x * e[l] + A * s[l] + w * r[l] + D * i[l])) / 1e3, h[4 * l + 3] = t.round(1e3 * (C * e[l] + E * s[l] + T * r[l] + F * i[l])) / 1e3;
        }

        return h;
      },
      getPointInSegment: function getPointInSegment(e, i, s, r, a, n) {
        var h = o(a, n),
            p = 1 - h;
        return [t.round(1e3 * (p * p * p * e[0] + (h * p * p + p * h * p + p * p * h) * s[0] + (h * h * p + p * h * h + h * p * h) * r[0] + h * h * h * i[0])) / 1e3, t.round(1e3 * (p * p * p * e[1] + (h * p * p + p * h * p + p * p * h) * s[1] + (h * h * p + p * h * h + h * p * h) * r[1] + h * h * h * i[1])) / 1e3];
      },
      buildBezierData: n,
      pointOnLine2D: e,
      pointOnLine3D: function pointOnLine3D(i, s, r, a, n, o, h, p, l) {
        if (0 === r && 0 === o && 0 === l) return e(i, s, a, n, h, p);
        var f,
            c = t.sqrt(t.pow(a - i, 2) + t.pow(n - s, 2) + t.pow(o - r, 2)),
            u = t.sqrt(t.pow(h - i, 2) + t.pow(p - s, 2) + t.pow(l - r, 2)),
            m = t.sqrt(t.pow(h - a, 2) + t.pow(p - n, 2) + t.pow(l - o, 2));
        return (f = c > u ? c > m ? c - u - m : m - u - c : m > u ? m - u - c : u - c - m) > -1e-4 && f < 1e-4;
      }
    };
  }(),
      at = function () {
    var t = i,
        e = Math.abs;

    function s(t, e) {
      var i,
          s = this.offsetTime;
      "multidimensional" === this.propType && (i = p("float32", this.pv.length));

      for (var a, n, o, h, l, f, c, u, m, d = e.lastIndex, g = d, y = this.keyframes.length - 1, v = !0; v;) {
        if (a = this.keyframes[g], n = this.keyframes[g + 1], g === y - 1 && t >= n.t - s) {
          a.h && (a = n), d = 0;
          break;
        }

        if (n.t - s > t) {
          d = g;
          break;
        }

        g < y - 1 ? g += 1 : (d = 0, v = !1);
      }

      o = this.keyframesMetadata[g] || {};

      var b,
          _,
          P,
          S,
          x,
          A,
          w,
          D,
          C,
          E,
          T = n.t - s,
          F = a.t - s;

      if (a.to) {
        o.bezierData || (o.bezierData = rt.buildBezierData(a.s, n.s || a.e, a.to, a.ti));
        var M = o.bezierData;

        if (t >= T || t < F) {
          var I = t >= T ? M.points.length - 1 : 0;

          for (l = M.points[I].point.length, h = 0; h < l; h += 1) {
            i[h] = M.points[I].point[h];
          }
        } else {
          o.__fnct ? m = o.__fnct : (m = Q.getBezierEasing(a.o.x, a.o.y, a.i.x, a.i.y, a.n).get, o.__fnct = m), f = m((t - F) / (T - F));
          var L,
              O = M.segmentLength * f,
              R = e.lastFrame < t && e._lastKeyframeIndex === g ? e._lastAddedLength : 0;

          for (u = e.lastFrame < t && e._lastKeyframeIndex === g ? e._lastPoint : 0, v = !0, c = M.points.length; v;) {
            if (R += M.points[u].partialLength, 0 === O || 0 === f || u === M.points.length - 1) {
              for (l = M.points[u].point.length, h = 0; h < l; h += 1) {
                i[h] = M.points[u].point[h];
              }

              break;
            }

            if (O >= R && O < R + M.points[u + 1].partialLength) {
              for (L = (O - R) / M.points[u + 1].partialLength, l = M.points[u].point.length, h = 0; h < l; h += 1) {
                i[h] = M.points[u].point[h] + (M.points[u + 1].point[h] - M.points[u].point[h]) * L;
              }

              break;
            }

            u < c - 1 ? u += 1 : v = !1;
          }

          e._lastPoint = u, e._lastAddedLength = R - M.points[u].partialLength, e._lastKeyframeIndex = g;
        }
      } else {
        var V, j, z, N, B;
        if (y = a.s.length, b = n.s || a.e, this.sh && 1 !== a.h) t >= T ? (i[0] = b[0], i[1] = b[1], i[2] = b[2]) : t <= F ? (i[0] = a.s[0], i[1] = a.s[1], i[2] = a.s[2]) : (_ = i, P = function (t, e, i) {
          var s,
              r,
              a,
              n,
              o,
              h = [],
              p = t[0],
              l = t[1],
              f = t[2],
              c = t[3],
              u = e[0],
              m = e[1],
              d = e[2],
              g = e[3];
          return (r = p * u + l * m + f * d + c * g) < 0 && (r = -r, u = -u, m = -m, d = -d, g = -g), 1 - r > 1e-6 ? (s = Math.acos(r), a = Math.sin(s), n = Math.sin((1 - i) * s) / a, o = Math.sin(i * s) / a) : (n = 1 - i, o = i), h[0] = n * p + o * u, h[1] = n * l + o * m, h[2] = n * f + o * d, h[3] = n * c + o * g, h;
        }(r(a.s), r(b), (t - F) / (T - F)), S = P[0], x = P[1], A = P[2], w = P[3], D = Math.atan2(2 * x * w - 2 * S * A, 1 - 2 * x * x - 2 * A * A), C = Math.asin(2 * S * x + 2 * A * w), E = Math.atan2(2 * S * w - 2 * x * A, 1 - 2 * S * S - 2 * A * A), _[0] = D / k, _[1] = C / k, _[2] = E / k);else for (g = 0; g < y; g += 1) {
          1 !== a.h && (t >= T ? f = 1 : t < F ? f = 0 : (a.o.x.constructor === Array ? (o.__fnct || (o.__fnct = []), o.__fnct[g] ? m = o.__fnct[g] : (V = void 0 === a.o.x[g] ? a.o.x[0] : a.o.x[g], j = void 0 === a.o.y[g] ? a.o.y[0] : a.o.y[g], z = void 0 === a.i.x[g] ? a.i.x[0] : a.i.x[g], N = void 0 === a.i.y[g] ? a.i.y[0] : a.i.y[g], m = Q.getBezierEasing(V, j, z, N).get, o.__fnct[g] = m)) : o.__fnct ? m = o.__fnct : (V = a.o.x, j = a.o.y, z = a.i.x, N = a.i.y, m = Q.getBezierEasing(V, j, z, N).get, a.keyframeMetadata = m), f = m((t - F) / (T - F)))), b = n.s || a.e, B = 1 === a.h ? a.s[g] : a.s[g] + (b[g] - a.s[g]) * f, "multidimensional" === this.propType ? i[g] = B : i = B;
        }
      }

      return e.lastIndex = d, i;
    }

    function r(t) {
      var e = t[0] * k,
          i = t[1] * k,
          s = t[2] * k,
          r = Math.cos(e / 2),
          a = Math.cos(i / 2),
          n = Math.cos(s / 2),
          o = Math.sin(e / 2),
          h = Math.sin(i / 2),
          p = Math.sin(s / 2);
      return [o * h * n + r * a * p, o * a * n + r * h * p, r * h * n - o * a * p, r * a * n - o * h * p];
    }

    function a() {
      var e = this.comp.renderedFrame - this.offsetTime,
          i = this.keyframes[0].t - this.offsetTime,
          s = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;

      if (!(e === this._caching.lastFrame || this._caching.lastFrame !== t && (this._caching.lastFrame >= s && e >= s || this._caching.lastFrame < i && e < i))) {
        this._caching.lastFrame >= e && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var r = this.interpolateValue(e, this._caching);
        this.pv = r;
      }

      return this._caching.lastFrame = e, this.pv;
    }

    function n(t) {
      var i;
      if ("unidimensional" === this.propType) i = t * this.mult, e(this.v - i) > 1e-5 && (this.v = i, this._mdf = !0);else for (var s = 0, r = this.v.length; s < r;) {
        i = t[s] * this.mult, e(this.v[s] - i) > 1e-5 && (this.v[s] = i, this._mdf = !0), s += 1;
      }
    }

    function o() {
      if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) if (this.lock) this.setVValue(this.pv);else {
        var t;
        this.lock = !0, this._mdf = this._isFirstFrame;
        var e = this.effectsSequence.length,
            i = this.kf ? this.pv : this.data.k;

        for (t = 0; t < e; t += 1) {
          i = this.effectsSequence[t](i);
        }

        this.setVValue(i), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }

    function h(t) {
      this.effectsSequence.push(t), this.container.addDynamicProperty(this);
    }

    function l(t, e, i, s) {
      this.propType = "unidimensional", this.mult = i || 1, this.data = e, this.v = i ? e.k * i : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = s, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = o, this.setVValue = n, this.addEffect = h;
    }

    function f(t, e, i, s) {
      var r;
      this.propType = "multidimensional", this.mult = i || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = s, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var a = e.k.length;

      for (this.v = p("float32", a), this.pv = p("float32", a), this.vel = p("float32", a), r = 0; r < a; r += 1) {
        this.v[r] = e.k[r] * this.mult, this.pv[r] = e.k[r];
      }

      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = o, this.setVValue = n, this.addEffect = h;
    }

    function c(e, i, r, p) {
      this.propType = "unidimensional", this.keyframes = i.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.frameId = -1, this._caching = {
        lastFrame: t,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = i, this.mult = r || 1, this.elem = e, this.container = p, this.comp = e.comp, this.v = t, this.pv = t, this._isFirstFrame = !0, this.getValue = o, this.setVValue = n, this.interpolateValue = s, this.effectsSequence = [a.bind(this)], this.addEffect = h;
    }

    function u(e, i, r, l) {
      var f;
      this.propType = "multidimensional";
      var c,
          u,
          m,
          d,
          g = i.k.length;

      for (f = 0; f < g - 1; f += 1) {
        i.k[f].to && i.k[f].s && i.k[f + 1] && i.k[f + 1].s && (c = i.k[f].s, u = i.k[f + 1].s, m = i.k[f].to, d = i.k[f].ti, (2 === c.length && (c[0] !== u[0] || c[1] !== u[1]) && rt.pointOnLine2D(c[0], c[1], u[0], u[1], c[0] + m[0], c[1] + m[1]) && rt.pointOnLine2D(c[0], c[1], u[0], u[1], u[0] + d[0], u[1] + d[1]) || 3 === c.length && (c[0] !== u[0] || c[1] !== u[1] || c[2] !== u[2]) && rt.pointOnLine3D(c[0], c[1], c[2], u[0], u[1], u[2], c[0] + m[0], c[1] + m[1], c[2] + m[2]) && rt.pointOnLine3D(c[0], c[1], c[2], u[0], u[1], u[2], u[0] + d[0], u[1] + d[1], u[2] + d[2])) && (i.k[f].to = null, i.k[f].ti = null), c[0] === u[0] && c[1] === u[1] && 0 === m[0] && 0 === m[1] && 0 === d[0] && 0 === d[1] && (2 === c.length || c[2] === u[2] && 0 === m[2] && 0 === d[2]) && (i.k[f].to = null, i.k[f].ti = null));
      }

      this.effectsSequence = [a.bind(this)], this.data = i, this.keyframes = i.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r || 1, this.elem = e, this.container = l, this.comp = e.comp, this.getValue = o, this.setVValue = n, this.interpolateValue = s, this.frameId = -1;
      var y = i.k[0].s.length;

      for (this.v = p("float32", y), this.pv = p("float32", y), f = 0; f < y; f += 1) {
        this.v[f] = t, this.pv[f] = t;
      }

      this._caching = {
        lastFrame: t,
        lastIndex: 0,
        value: p("float32", y)
      }, this.addEffect = h;
    }

    return {
      getProp: function getProp(t, e, i, s, r) {
        var a;
        if (e.k.length) {
          if ("number" == typeof e.k[0]) a = new f(t, e, s, r);else switch (i) {
            case 0:
              a = new c(t, e, s, r);
              break;

            case 1:
              a = new u(t, e, s, r);
          }
        } else a = new l(t, e, s, r);
        return a.effectsSequence.length && r.addDynamicProperty(a), a;
      }
    };
  }();

  function nt() {}

  nt.prototype = {
    addDynamicProperty: function addDynamicProperty(t) {
      -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
    },
    iterateDynamicProperties: function iterateDynamicProperties() {
      var t;
      this._mdf = !1;
      var e = this.dynamicProperties.length;

      for (t = 0; t < e; t += 1) {
        this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
      }
    },
    initDynamicPropertyContainer: function initDynamicPropertyContainer(t) {
      this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
    }
  };
  var ot = et(8, function () {
    return p("float32", 2);
  });

  function ht() {
    this.c = !1, this._length = 0, this._maxLength = 8, this.v = l(this._maxLength), this.o = l(this._maxLength), this.i = l(this._maxLength);
  }

  ht.prototype.setPathData = function (t, e) {
    this.c = t, this.setLength(e);

    for (var i = 0; i < e;) {
      this.v[i] = ot.newElement(), this.o[i] = ot.newElement(), this.i[i] = ot.newElement(), i += 1;
    }
  }, ht.prototype.setLength = function (t) {
    for (; this._maxLength < t;) {
      this.doubleArrayLength();
    }

    this._length = t;
  }, ht.prototype.doubleArrayLength = function () {
    this.v = this.v.concat(l(this._maxLength)), this.i = this.i.concat(l(this._maxLength)), this.o = this.o.concat(l(this._maxLength)), this._maxLength *= 2;
  }, ht.prototype.setXYAt = function (t, e, i, s, r) {
    var a;

    switch (this._length = Math.max(this._length, s + 1), this._length >= this._maxLength && this.doubleArrayLength(), i) {
      case "v":
        a = this.v;
        break;

      case "i":
        a = this.i;
        break;

      case "o":
        a = this.o;
        break;

      default:
        a = [];
    }

    (!a[s] || a[s] && !r) && (a[s] = ot.newElement()), a[s][0] = t, a[s][1] = e;
  }, ht.prototype.setTripleAt = function (t, e, i, s, r, a, n, o) {
    this.setXYAt(t, e, "v", n, o), this.setXYAt(i, s, "o", n, o), this.setXYAt(r, a, "i", n, o);
  }, ht.prototype.reverse = function () {
    var t = new ht();
    t.setPathData(this.c, this._length);
    var e = this.v,
        i = this.o,
        s = this.i,
        r = 0;
    this.c && (t.setTripleAt(e[0][0], e[0][1], s[0][0], s[0][1], i[0][0], i[0][1], 0, !1), r = 1);
    var a,
        n = this._length - 1,
        o = this._length;

    for (a = r; a < o; a += 1) {
      t.setTripleAt(e[n][0], e[n][1], s[n][0], s[n][1], i[n][0], i[n][1], a, !1), n -= 1;
    }

    return t;
  };
  var pt,
      lt = ((pt = et(4, function () {
    return new ht();
  }, function (t) {
    var e,
        i = t._length;

    for (e = 0; e < i; e += 1) {
      ot.release(t.v[e]), ot.release(t.i[e]), ot.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
    }

    t._length = 0, t.c = !1;
  })).clone = function (t) {
    var e,
        i = pt.newElement(),
        s = void 0 === t._length ? t.v.length : t._length;

    for (i.setLength(s), i.c = t.c, e = 0; e < s; e += 1) {
      i.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
    }

    return i;
  }, pt);

  function ft() {
    this._length = 0, this._maxLength = 4, this.shapes = l(this._maxLength);
  }

  ft.prototype.addShape = function (t) {
    this._length === this._maxLength && (this.shapes = this.shapes.concat(l(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
  }, ft.prototype.releaseShapes = function () {
    var t;

    for (t = 0; t < this._length; t += 1) {
      lt.release(this.shapes[t]);
    }

    this._length = 0;
  };

  var ct,
      ut,
      mt,
      dt,
      gt = (ct = {
    newShapeCollection: function newShapeCollection() {
      return ut ? dt[ut -= 1] : new ft();
    },
    release: function release(t) {
      var e,
          i = t._length;

      for (e = 0; e < i; e += 1) {
        lt.release(t.shapes[e]);
      }

      t._length = 0, ut === mt && (dt = tt.double(dt), mt *= 2), dt[ut] = t, ut += 1;
    }
  }, ut = 0, dt = l(mt = 4), ct),
      yt = function () {
    var t = -999999;

    function e(t, e, i) {
      var s,
          r,
          a,
          n,
          o,
          h,
          p,
          l,
          f,
          c = i.lastIndex,
          u = this.keyframes;
      if (t < u[0].t - this.offsetTime) s = u[0].s[0], a = !0, c = 0;else if (t >= u[u.length - 1].t - this.offsetTime) s = u[u.length - 1].s ? u[u.length - 1].s[0] : u[u.length - 2].e[0], a = !0;else {
        for (var m, d, g, y = c, v = u.length - 1, b = !0; b && (m = u[y], !((d = u[y + 1]).t - this.offsetTime > t));) {
          y < v - 1 ? y += 1 : b = !1;
        }

        if (g = this.keyframesMetadata[y] || {}, c = y, !(a = 1 === m.h)) {
          if (t >= d.t - this.offsetTime) l = 1;else if (t < m.t - this.offsetTime) l = 0;else {
            var _;

            g.__fnct ? _ = g.__fnct : (_ = Q.getBezierEasing(m.o.x, m.o.y, m.i.x, m.i.y).get, g.__fnct = _), l = _((t - (m.t - this.offsetTime)) / (d.t - this.offsetTime - (m.t - this.offsetTime)));
          }
          r = d.s ? d.s[0] : m.e[0];
        }

        s = m.s[0];
      }

      for (h = e._length, p = s.i[0].length, i.lastIndex = c, n = 0; n < h; n += 1) {
        for (o = 0; o < p; o += 1) {
          f = a ? s.i[n][o] : s.i[n][o] + (r.i[n][o] - s.i[n][o]) * l, e.i[n][o] = f, f = a ? s.o[n][o] : s.o[n][o] + (r.o[n][o] - s.o[n][o]) * l, e.o[n][o] = f, f = a ? s.v[n][o] : s.v[n][o] + (r.v[n][o] - s.v[n][o]) * l, e.v[n][o] = f;
        }
      }
    }

    function i() {
      var e = this.comp.renderedFrame - this.offsetTime,
          i = this.keyframes[0].t - this.offsetTime,
          s = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
          r = this._caching.lastFrame;
      return r !== t && (r < i && e < i || r > s && e > s) || (this._caching.lastIndex = r < e ? this._caching.lastIndex : 0, this.interpolateShape(e, this.pv, this._caching)), this._caching.lastFrame = e, this.pv;
    }

    function s() {
      this.paths = this.localShapeCollection;
    }

    function r(t) {
      (function (t, e) {
        if (t._length !== e._length || t.c !== e.c) return !1;
        var i,
            s = t._length;

        for (i = 0; i < s; i += 1) {
          if (t.v[i][0] !== e.v[i][0] || t.v[i][1] !== e.v[i][1] || t.o[i][0] !== e.o[i][0] || t.o[i][1] !== e.o[i][1] || t.i[i][0] !== e.i[i][0] || t.i[i][1] !== e.i[i][1]) return !1;
        }

        return !0;
      })(this.v, t) || (this.v = lt.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
    }

    function n() {
      if (this.elem.globalData.frameId !== this.frameId) if (this.effectsSequence.length) {
        if (this.lock) this.setVValue(this.pv);else {
          var t, e;
          this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
          var i = this.effectsSequence.length;

          for (e = 0; e < i; e += 1) {
            t = this.effectsSequence[e](t);
          }

          this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      } else this._mdf = !1;
    }

    function o(t, e, i) {
      this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
      var r = 3 === i ? e.pt.k : e.ks.k;
      this.v = lt.clone(r), this.pv = lt.clone(this.v), this.localShapeCollection = gt.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = s, this.effectsSequence = [];
    }

    function h(t) {
      this.effectsSequence.push(t), this.container.addDynamicProperty(this);
    }

    function p(e, r, a) {
      this.propType = "shape", this.comp = e.comp, this.elem = e, this.container = e, this.offsetTime = e.data.st, this.keyframes = 3 === a ? r.pt.k : r.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
      var n = this.keyframes[0].s[0].i.length;
      this.v = lt.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, n), this.pv = lt.clone(this.v), this.localShapeCollection = gt.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = t, this.reset = s, this._caching = {
        lastFrame: t,
        lastIndex: 0
      }, this.effectsSequence = [i.bind(this)];
    }

    o.prototype.interpolateShape = e, o.prototype.getValue = n, o.prototype.setVValue = r, o.prototype.addEffect = h, p.prototype.getValue = n, p.prototype.interpolateShape = e, p.prototype.setVValue = r, p.prototype.addEffect = h;

    var l = function () {
      var t = S;

      function e(t, e) {
        this.v = lt.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = gt.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = at.getProp(t, e.p, 1, 0, this), this.s = at.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
      }

      return e.prototype = {
        reset: s,
        getValue: function getValue() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
        },
        convertEllToPath: function convertEllToPath() {
          var e = this.p.v[0],
              i = this.p.v[1],
              s = this.s.v[0] / 2,
              r = this.s.v[1] / 2,
              a = 3 !== this.d,
              n = this.v;
          n.v[0][0] = e, n.v[0][1] = i - r, n.v[1][0] = a ? e + s : e - s, n.v[1][1] = i, n.v[2][0] = e, n.v[2][1] = i + r, n.v[3][0] = a ? e - s : e + s, n.v[3][1] = i, n.i[0][0] = a ? e - s * t : e + s * t, n.i[0][1] = i - r, n.i[1][0] = a ? e + s : e - s, n.i[1][1] = i - r * t, n.i[2][0] = a ? e + s * t : e - s * t, n.i[2][1] = i + r, n.i[3][0] = a ? e - s : e + s, n.i[3][1] = i + r * t, n.o[0][0] = a ? e + s * t : e - s * t, n.o[0][1] = i - r, n.o[1][0] = a ? e + s : e - s, n.o[1][1] = i + r * t, n.o[2][0] = a ? e - s * t : e + s * t, n.o[2][1] = i + r, n.o[3][0] = a ? e - s : e + s, n.o[3][1] = i - r * t;
        }
      }, a([nt], e), e;
    }(),
        f = function () {
      function t(t, e) {
        this.v = lt.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = at.getProp(t, e.ir, 0, 0, this), this.is = at.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = at.getProp(t, e.pt, 0, 0, this), this.p = at.getProp(t, e.p, 1, 0, this), this.r = at.getProp(t, e.r, 0, k, this), this.or = at.getProp(t, e.or, 0, 0, this), this.os = at.getProp(t, e.os, 0, .01, this), this.localShapeCollection = gt.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
      }

      return t.prototype = {
        reset: s,
        getValue: function getValue() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
        },
        convertStarToPath: function convertStarToPath() {
          var t,
              e,
              i,
              s,
              r = 2 * Math.floor(this.pt.v),
              a = 2 * Math.PI / r,
              n = !0,
              o = this.or.v,
              h = this.ir.v,
              p = this.os.v,
              l = this.is.v,
              f = 2 * Math.PI * o / (2 * r),
              c = 2 * Math.PI * h / (2 * r),
              u = -Math.PI / 2;
          u += this.r.v;
          var m = 3 === this.data.d ? -1 : 1;

          for (this.v._length = 0, t = 0; t < r; t += 1) {
            i = n ? p : l, s = n ? f : c;
            var d = (e = n ? o : h) * Math.cos(u),
                g = e * Math.sin(u),
                y = 0 === d && 0 === g ? 0 : g / Math.sqrt(d * d + g * g),
                v = 0 === d && 0 === g ? 0 : -d / Math.sqrt(d * d + g * g);
            d += +this.p.v[0], g += +this.p.v[1], this.v.setTripleAt(d, g, d - y * s * i * m, g - v * s * i * m, d + y * s * i * m, g + v * s * i * m, t, !0), n = !n, u += a * m;
          }
        },
        convertPolygonToPath: function convertPolygonToPath() {
          var t,
              e = Math.floor(this.pt.v),
              i = 2 * Math.PI / e,
              s = this.or.v,
              r = this.os.v,
              a = 2 * Math.PI * s / (4 * e),
              n = .5 * -Math.PI,
              o = 3 === this.data.d ? -1 : 1;

          for (n += this.r.v, this.v._length = 0, t = 0; t < e; t += 1) {
            var h = s * Math.cos(n),
                p = s * Math.sin(n),
                l = 0 === h && 0 === p ? 0 : p / Math.sqrt(h * h + p * p),
                f = 0 === h && 0 === p ? 0 : -h / Math.sqrt(h * h + p * p);
            h += +this.p.v[0], p += +this.p.v[1], this.v.setTripleAt(h, p, h - l * a * r * o, p - f * a * r * o, h + l * a * r * o, p + f * a * r * o, t, !0), n += i * o;
          }

          this.paths.length = 0, this.paths[0] = this.v;
        }
      }, a([nt], t), t;
    }(),
        c = function () {
      function t(t, e) {
        this.v = lt.newElement(), this.v.c = !0, this.localShapeCollection = gt.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = at.getProp(t, e.p, 1, 0, this), this.s = at.getProp(t, e.s, 1, 0, this), this.r = at.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
      }

      return t.prototype = {
        convertRectToPath: function convertRectToPath() {
          var t = this.p.v[0],
              e = this.p.v[1],
              i = this.s.v[0] / 2,
              s = this.s.v[1] / 2,
              r = b(i, s, this.r.v),
              a = r * (1 - S);
          this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t + i, e - s + r, t + i, e - s + r, t + i, e - s + a, 0, !0), this.v.setTripleAt(t + i, e + s - r, t + i, e + s - a, t + i, e + s - r, 1, !0), 0 !== r ? (this.v.setTripleAt(t + i - r, e + s, t + i - r, e + s, t + i - a, e + s, 2, !0), this.v.setTripleAt(t - i + r, e + s, t - i + a, e + s, t - i + r, e + s, 3, !0), this.v.setTripleAt(t - i, e + s - r, t - i, e + s - r, t - i, e + s - a, 4, !0), this.v.setTripleAt(t - i, e - s + r, t - i, e - s + a, t - i, e - s + r, 5, !0), this.v.setTripleAt(t - i + r, e - s, t - i + r, e - s, t - i + a, e - s, 6, !0), this.v.setTripleAt(t + i - r, e - s, t + i - a, e - s, t + i - r, e - s, 7, !0)) : (this.v.setTripleAt(t - i, e + s, t - i + a, e + s, t - i, e + s, 2), this.v.setTripleAt(t - i, e - s, t - i, e - s + a, t - i, e - s, 3))) : (this.v.setTripleAt(t + i, e - s + r, t + i, e - s + a, t + i, e - s + r, 0, !0), 0 !== r ? (this.v.setTripleAt(t + i - r, e - s, t + i - r, e - s, t + i - a, e - s, 1, !0), this.v.setTripleAt(t - i + r, e - s, t - i + a, e - s, t - i + r, e - s, 2, !0), this.v.setTripleAt(t - i, e - s + r, t - i, e - s + r, t - i, e - s + a, 3, !0), this.v.setTripleAt(t - i, e + s - r, t - i, e + s - a, t - i, e + s - r, 4, !0), this.v.setTripleAt(t - i + r, e + s, t - i + r, e + s, t - i + a, e + s, 5, !0), this.v.setTripleAt(t + i - r, e + s, t + i - a, e + s, t + i - r, e + s, 6, !0), this.v.setTripleAt(t + i, e + s - r, t + i, e + s - r, t + i, e + s - a, 7, !0)) : (this.v.setTripleAt(t - i, e - s, t - i + a, e - s, t - i, e - s, 1, !0), this.v.setTripleAt(t - i, e + s, t - i, e + s - a, t - i, e + s, 2, !0), this.v.setTripleAt(t + i, e + s, t + i - a, e + s, t + i, e + s, 3, !0)));
        },
        getValue: function getValue() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
        },
        reset: s
      }, a([nt], t), t;
    }(),
        u = {
      getShapeProp: function getShapeProp(t, e, i) {
        var s;
        return 3 === i || 4 === i ? s = (3 === i ? e.pt : e.ks).k.length ? new p(t, e, i) : new o(t, e, i) : 5 === i ? s = new c(t, e) : 6 === i ? s = new l(t, e) : 7 === i && (s = new f(t, e)), s.k && t.addDynamicProperty(s), s;
      },
      getConstructorFunction: function getConstructorFunction() {
        return o;
      },
      getKeyframedConstructorFunction: function getKeyframedConstructorFunction() {
        return p;
      }
    };

    return u;
  }(),
      vt = function () {
    var t = Math.cos,
        e = Math.sin,
        i = Math.tan,
        s = Math.round;

    function r() {
      return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
    }

    function a(i) {
      if (0 === i) return this;
      var s = t(i),
          r = e(i);
      return this._t(s, -r, 0, 0, r, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function n(i) {
      if (0 === i) return this;
      var s = t(i),
          r = e(i);
      return this._t(1, 0, 0, 0, 0, s, -r, 0, 0, r, s, 0, 0, 0, 0, 1);
    }

    function o(i) {
      if (0 === i) return this;
      var s = t(i),
          r = e(i);
      return this._t(s, 0, r, 0, 0, 1, 0, 0, -r, 0, s, 0, 0, 0, 0, 1);
    }

    function h(i) {
      if (0 === i) return this;
      var s = t(i),
          r = e(i);
      return this._t(s, -r, 0, 0, r, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function l(t, e) {
      return this._t(1, e, t, 1, 0, 0);
    }

    function f(t, e) {
      return this.shear(i(t), i(e));
    }

    function c(s, r) {
      var a = t(r),
          n = e(r);
      return this._t(a, n, 0, 0, -n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, i(s), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(a, -n, 0, 0, n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function u(t, e, i) {
      return i || 0 === i || (i = 1), 1 === t && 1 === e && 1 === i ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1);
    }

    function m(t, e, i, s, r, a, n, o, h, p, l, f, c, u, m, d) {
      return this.props[0] = t, this.props[1] = e, this.props[2] = i, this.props[3] = s, this.props[4] = r, this.props[5] = a, this.props[6] = n, this.props[7] = o, this.props[8] = h, this.props[9] = p, this.props[10] = l, this.props[11] = f, this.props[12] = c, this.props[13] = u, this.props[14] = m, this.props[15] = d, this;
    }

    function d(t, e, i) {
      return i = i || 0, 0 !== t || 0 !== e || 0 !== i ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, i, 1) : this;
    }

    function g(t, e, i, s, r, a, n, o, h, p, l, f, c, u, m, d) {
      var g = this.props;
      if (1 === t && 0 === e && 0 === i && 0 === s && 0 === r && 1 === a && 0 === n && 0 === o && 0 === h && 0 === p && 1 === l && 0 === f) return g[12] = g[12] * t + g[15] * c, g[13] = g[13] * a + g[15] * u, g[14] = g[14] * l + g[15] * m, g[15] *= d, this._identityCalculated = !1, this;
      var y = g[0],
          v = g[1],
          b = g[2],
          _ = g[3],
          P = g[4],
          k = g[5],
          S = g[6],
          x = g[7],
          A = g[8],
          w = g[9],
          D = g[10],
          C = g[11],
          E = g[12],
          T = g[13],
          F = g[14],
          M = g[15];
      return g[0] = y * t + v * r + b * h + _ * c, g[1] = y * e + v * a + b * p + _ * u, g[2] = y * i + v * n + b * l + _ * m, g[3] = y * s + v * o + b * f + _ * d, g[4] = P * t + k * r + S * h + x * c, g[5] = P * e + k * a + S * p + x * u, g[6] = P * i + k * n + S * l + x * m, g[7] = P * s + k * o + S * f + x * d, g[8] = A * t + w * r + D * h + C * c, g[9] = A * e + w * a + D * p + C * u, g[10] = A * i + w * n + D * l + C * m, g[11] = A * s + w * o + D * f + C * d, g[12] = E * t + T * r + F * h + M * c, g[13] = E * e + T * a + F * p + M * u, g[14] = E * i + T * n + F * l + M * m, g[15] = E * s + T * o + F * f + M * d, this._identityCalculated = !1, this;
    }

    function y() {
      return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
    }

    function v(t) {
      for (var e = 0; e < 16;) {
        if (t.props[e] !== this.props[e]) return !1;
        e += 1;
      }

      return !0;
    }

    function b(t) {
      var e;

      for (e = 0; e < 16; e += 1) {
        t.props[e] = this.props[e];
      }

      return t;
    }

    function _(t) {
      var e;

      for (e = 0; e < 16; e += 1) {
        this.props[e] = t[e];
      }
    }

    function P(t, e, i) {
      return {
        x: t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12],
        y: t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13],
        z: t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14]
      };
    }

    function k(t, e, i) {
      return t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12];
    }

    function S(t, e, i) {
      return t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13];
    }

    function x(t, e, i) {
      return t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14];
    }

    function A() {
      var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
          e = this.props[5] / t,
          i = -this.props[1] / t,
          s = -this.props[4] / t,
          r = this.props[0] / t,
          a = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t,
          n = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t,
          o = new vt();
      return o.props[0] = e, o.props[1] = i, o.props[4] = s, o.props[5] = r, o.props[12] = a, o.props[13] = n, o;
    }

    function w(t) {
      return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
    }

    function D(t) {
      var e,
          i = t.length,
          s = [];

      for (e = 0; e < i; e += 1) {
        s[e] = w(t[e]);
      }

      return s;
    }

    function C(t, e, i) {
      var s = p("float32", 6);
      if (this.isIdentity()) s[0] = t[0], s[1] = t[1], s[2] = e[0], s[3] = e[1], s[4] = i[0], s[5] = i[1];else {
        var r = this.props[0],
            a = this.props[1],
            n = this.props[4],
            o = this.props[5],
            h = this.props[12],
            l = this.props[13];
        s[0] = t[0] * r + t[1] * n + h, s[1] = t[0] * a + t[1] * o + l, s[2] = e[0] * r + e[1] * n + h, s[3] = e[0] * a + e[1] * o + l, s[4] = i[0] * r + i[1] * n + h, s[5] = i[0] * a + i[1] * o + l;
      }
      return s;
    }

    function E(t, e, i) {
      return this.isIdentity() ? [t, e, i] : [t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12], t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13], t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14]];
    }

    function T(t, e) {
      if (this.isIdentity()) return t + "," + e;
      var i = this.props;
      return Math.round(100 * (t * i[0] + e * i[4] + i[12])) / 100 + "," + Math.round(100 * (t * i[1] + e * i[5] + i[13])) / 100;
    }

    function F() {
      for (var t = 0, e = this.props, i = "matrix3d("; t < 16;) {
        i += s(1e4 * e[t]) / 1e4, i += 15 === t ? ")" : ",", t += 1;
      }

      return i;
    }

    function M(t) {
      return t < 1e-6 && t > 0 || t > -1e-6 && t < 0 ? s(1e4 * t) / 1e4 : t;
    }

    function I() {
      var t = this.props;
      return "matrix(" + M(t[0]) + "," + M(t[1]) + "," + M(t[4]) + "," + M(t[5]) + "," + M(t[12]) + "," + M(t[13]) + ")";
    }

    return function () {
      this.reset = r, this.rotate = a, this.rotateX = n, this.rotateY = o, this.rotateZ = h, this.skew = f, this.skewFromAxis = c, this.shear = l, this.scale = u, this.setTransform = m, this.translate = d, this.transform = g, this.applyToPoint = P, this.applyToX = k, this.applyToY = S, this.applyToZ = x, this.applyToPointArray = E, this.applyToTriplePoints = C, this.applyToPointStringified = T, this.toCSS = F, this.to2dCSS = I, this.clone = b, this.cloneFromProps = _, this.equals = v, this.inversePoints = D, this.inversePoint = w, this.getInverseMatrix = A, this._t = this.transform, this.isIdentity = y, this._identity = !0, this._identityCalculated = !1, this.props = p("float32", 16), this.reset();
    };
  }();

  function bt(t) {
    return bt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, bt(t);
  }

  var _t = {};

  function Pt() {
    Z.searchAnimations();
  }

  _t.play = Z.play, _t.pause = Z.pause, _t.setLocationHref = function (e) {
    t = e;
  }, _t.togglePause = Z.togglePause, _t.setSpeed = Z.setSpeed, _t.setDirection = Z.setDirection, _t.stop = Z.stop, _t.searchAnimations = Pt, _t.registerAnimation = Z.registerAnimation, _t.loadAnimation = function (t) {
    return Z.loadAnimation(t);
  }, _t.setSubframeRendering = function (t) {
    !function (t) {
      c = !!t;
    }(t);
  }, _t.resize = Z.resize, _t.goToAndStop = Z.goToAndStop, _t.destroy = Z.destroy, _t.setQuality = function (t) {
    if ("string" == typeof t) switch (t) {
      case "high":
        z(200);
        break;

      default:
      case "medium":
        z(50);
        break;

      case "low":
        z(10);
    } else !isNaN(t) && t > 1 && z(t);
  }, _t.inBrowser = function () {
    return "undefined" != typeof navigator;
  }, _t.installPlugin = function (t, e) {
    "expressions" === t && (u = e);
  }, _t.freeze = Z.freeze, _t.unfreeze = Z.unfreeze, _t.setVolume = Z.setVolume, _t.mute = Z.mute, _t.unmute = Z.unmute, _t.getRegisteredAnimations = Z.getRegisteredAnimations, _t.useWebWorker = function (t) {
    e = !!t;
  }, _t.setIDPrefix = function (t) {
    m = t;
  }, _t.__getFactory = function (t) {
    switch (t) {
      case "propertyFactory":
        return at;

      case "shapePropertyFactory":
        return yt;

      case "matrix":
        return vt;

      default:
        return null;
    }
  }, _t.version = "5.9.4";
  var kt = "",
      St = document.getElementsByTagName("script"),
      xt = St[St.length - 1] || {
    src: ""
  };
  kt = xt.src ? xt.src.replace(/^[^\?]+\??/, "") : "", function (t) {
    for (var e = kt.split("&"), i = 0; i < e.length; i += 1) {
      var s = e[i].split("=");
      if (decodeURIComponent(s[0]) == t) return decodeURIComponent(s[1]);
    }
  }("renderer");
  var At = setInterval(function () {
    "complete" === document.readyState && (clearInterval(At), Pt());
  }, 100);

  try {
    "object" === bt(U) || (window.bodymovin = _t);
  } catch (t) {}

  var wt = function () {
    var t = {},
        e = {};
    return t.registerModifier = function (t, i) {
      e[t] || (e[t] = i);
    }, t.getModifier = function (t, i, s) {
      return new e[t](i, s);
    }, t;
  }();

  function Dt() {}

  function Ct() {}

  function Et() {}

  Dt.prototype.initModifierProperties = function () {}, Dt.prototype.addShapeToModifier = function () {}, Dt.prototype.addShape = function (t) {
    if (!this.closed) {
      t.sh.container.addDynamicProperty(t.sh);
      var e = {
        shape: t.sh,
        data: t,
        localShapeCollection: gt.newShapeCollection()
      };
      this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
    }
  }, Dt.prototype.init = function (t, e) {
    this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = i, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
  }, Dt.prototype.processKeys = function () {
    this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
  }, a([nt], Dt), a([Dt], Ct), Ct.prototype.initModifierProperties = function (t, e) {
    this.s = at.getProp(t, e.s, 0, .01, this), this.e = at.getProp(t, e.e, 0, .01, this), this.o = at.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
  }, Ct.prototype.addShapeToModifier = function (t) {
    t.pathsData = [];
  }, Ct.prototype.calculateShapeEdges = function (t, e, i, s, r) {
    var a = [];
    e <= 1 ? a.push({
      s: t,
      e: e
    }) : t >= 1 ? a.push({
      s: t - 1,
      e: e - 1
    }) : (a.push({
      s: t,
      e: 1
    }), a.push({
      s: 0,
      e: e - 1
    }));
    var n,
        o,
        h = [],
        p = a.length;

    for (n = 0; n < p; n += 1) {
      var l, f;
      (o = a[n]).e * r < s || o.s * r > s + i || (l = o.s * r <= s ? 0 : (o.s * r - s) / i, f = o.e * r >= s + i ? 1 : (o.e * r - s) / i, h.push([l, f]));
    }

    return h.length || h.push([0, 0]), h;
  }, Ct.prototype.releasePathsData = function (t) {
    var e,
        i = t.length;

    for (e = 0; e < i; e += 1) {
      st.release(t[e]);
    }

    return t.length = 0, t;
  }, Ct.prototype.processShapes = function (t) {
    var e, i, s, r;

    if (this._mdf || t) {
      var a = this.o.v % 360 / 360;

      if (a < 0 && (a += 1), (e = this.s.v > 1 ? 1 + a : this.s.v < 0 ? 0 + a : this.s.v + a) > (i = this.e.v > 1 ? 1 + a : this.e.v < 0 ? 0 + a : this.e.v + a)) {
        var n = e;
        e = i, i = n;
      }

      e = 1e-4 * Math.round(1e4 * e), i = 1e-4 * Math.round(1e4 * i), this.sValue = e, this.eValue = i;
    } else e = this.sValue, i = this.eValue;

    var o,
        h,
        p,
        l,
        f,
        c = this.shapes.length,
        u = 0;
    if (i === e) for (r = 0; r < c; r += 1) {
      this.shapes[r].localShapeCollection.releaseShapes(), this.shapes[r].shape._mdf = !0, this.shapes[r].shape.paths = this.shapes[r].localShapeCollection, this._mdf && (this.shapes[r].pathsData.length = 0);
    } else if (1 === i && 0 === e || 0 === i && 1 === e) {
      if (this._mdf) for (r = 0; r < c; r += 1) {
        this.shapes[r].pathsData.length = 0, this.shapes[r].shape._mdf = !0;
      }
    } else {
      var m,
          d,
          g = [];

      for (r = 0; r < c; r += 1) {
        if ((m = this.shapes[r]).shape._mdf || this._mdf || t || 2 === this.m) {
          if (h = (s = m.shape.paths)._length, f = 0, !m.shape._mdf && m.pathsData.length) f = m.totalShapeLength;else {
            for (p = this.releasePathsData(m.pathsData), o = 0; o < h; o += 1) {
              l = rt.getSegmentsLength(s.shapes[o]), p.push(l), f += l.totalLength;
            }

            m.totalShapeLength = f, m.pathsData = p;
          }
          u += f, m.shape._mdf = !0;
        } else m.shape.paths = m.localShapeCollection;
      }

      var y,
          v = e,
          b = i,
          _ = 0;

      for (r = c - 1; r >= 0; r -= 1) {
        if ((m = this.shapes[r]).shape._mdf) {
          for ((d = m.localShapeCollection).releaseShapes(), 2 === this.m && c > 1 ? (y = this.calculateShapeEdges(e, i, m.totalShapeLength, _, u), _ += m.totalShapeLength) : y = [[v, b]], h = y.length, o = 0; o < h; o += 1) {
            v = y[o][0], b = y[o][1], g.length = 0, b <= 1 ? g.push({
              s: m.totalShapeLength * v,
              e: m.totalShapeLength * b
            }) : v >= 1 ? g.push({
              s: m.totalShapeLength * (v - 1),
              e: m.totalShapeLength * (b - 1)
            }) : (g.push({
              s: m.totalShapeLength * v,
              e: m.totalShapeLength
            }), g.push({
              s: 0,
              e: m.totalShapeLength * (b - 1)
            }));
            var P = this.addShapes(m, g[0]);

            if (g[0].s !== g[0].e) {
              if (g.length > 1) if (m.shape.paths.shapes[m.shape.paths._length - 1].c) {
                var k = P.pop();
                this.addPaths(P, d), P = this.addShapes(m, g[1], k);
              } else this.addPaths(P, d), P = this.addShapes(m, g[1]);
              this.addPaths(P, d);
            }
          }

          m.shape.paths = d;
        }
      }
    }
  }, Ct.prototype.addPaths = function (t, e) {
    var i,
        s = t.length;

    for (i = 0; i < s; i += 1) {
      e.addShape(t[i]);
    }
  }, Ct.prototype.addSegment = function (t, e, i, s, r, a, n) {
    r.setXYAt(e[0], e[1], "o", a), r.setXYAt(i[0], i[1], "i", a + 1), n && r.setXYAt(t[0], t[1], "v", a), r.setXYAt(s[0], s[1], "v", a + 1);
  }, Ct.prototype.addSegmentFromArray = function (t, e, i, s) {
    e.setXYAt(t[1], t[5], "o", i), e.setXYAt(t[2], t[6], "i", i + 1), s && e.setXYAt(t[0], t[4], "v", i), e.setXYAt(t[3], t[7], "v", i + 1);
  }, Ct.prototype.addShapes = function (t, e, i) {
    var s,
        r,
        a,
        n,
        o,
        h,
        p,
        l,
        f = t.pathsData,
        c = t.shape.paths.shapes,
        u = t.shape.paths._length,
        m = 0,
        d = [],
        g = !0;

    for (i ? (o = i._length, l = i._length) : (i = lt.newElement(), o = 0, l = 0), d.push(i), s = 0; s < u; s += 1) {
      for (h = f[s].lengths, i.c = c[s].c, a = c[s].c ? h.length : h.length + 1, r = 1; r < a; r += 1) {
        if (m + (n = h[r - 1]).addedLength < e.s) m += n.addedLength, i.c = !1;else {
          if (m > e.e) {
            i.c = !1;
            break;
          }

          e.s <= m && e.e >= m + n.addedLength ? (this.addSegment(c[s].v[r - 1], c[s].o[r - 1], c[s].i[r], c[s].v[r], i, o, g), g = !1) : (p = rt.getNewSegment(c[s].v[r - 1], c[s].v[r], c[s].o[r - 1], c[s].i[r], (e.s - m) / n.addedLength, (e.e - m) / n.addedLength, h[r - 1]), this.addSegmentFromArray(p, i, o, g), g = !1, i.c = !1), m += n.addedLength, o += 1;
        }
      }

      if (c[s].c && h.length) {
        if (n = h[r - 1], m <= e.e) {
          var y = h[r - 1].addedLength;
          e.s <= m && e.e >= m + y ? (this.addSegment(c[s].v[r - 1], c[s].o[r - 1], c[s].i[0], c[s].v[0], i, o, g), g = !1) : (p = rt.getNewSegment(c[s].v[r - 1], c[s].v[0], c[s].o[r - 1], c[s].i[0], (e.s - m) / y, (e.e - m) / y, h[r - 1]), this.addSegmentFromArray(p, i, o, g), g = !1, i.c = !1);
        } else i.c = !1;

        m += n.addedLength, o += 1;
      }

      if (i._length && (i.setXYAt(i.v[l][0], i.v[l][1], "i", l), i.setXYAt(i.v[i._length - 1][0], i.v[i._length - 1][1], "o", i._length - 1)), m > e.e) break;
      s < u - 1 && (i = lt.newElement(), g = !0, d.push(i), o = 0);
    }

    return d;
  }, a([Dt], Et), Et.prototype.initModifierProperties = function (t, e) {
    this.getValue = this.processKeys, this.amount = at.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
  }, Et.prototype.processPath = function (t, e) {
    var i = e / 100,
        s = [0, 0],
        r = t._length,
        a = 0;

    for (a = 0; a < r; a += 1) {
      s[0] += t.v[a][0], s[1] += t.v[a][1];
    }

    s[0] /= r, s[1] /= r;
    var n,
        o,
        h,
        p,
        l,
        f,
        c = lt.newElement();

    for (c.c = t.c, a = 0; a < r; a += 1) {
      n = t.v[a][0] + (s[0] - t.v[a][0]) * i, o = t.v[a][1] + (s[1] - t.v[a][1]) * i, h = t.o[a][0] + (s[0] - t.o[a][0]) * -i, p = t.o[a][1] + (s[1] - t.o[a][1]) * -i, l = t.i[a][0] + (s[0] - t.i[a][0]) * -i, f = t.i[a][1] + (s[1] - t.i[a][1]) * -i, c.setTripleAt(n, o, h, p, l, f, a);
    }

    return c;
  }, Et.prototype.processShapes = function (t) {
    var e,
        i,
        s,
        r,
        a,
        n,
        o = this.shapes.length,
        h = this.amount.v;
    if (0 !== h) for (i = 0; i < o; i += 1) {
      if (n = (a = this.shapes[i]).localShapeCollection, a.shape._mdf || this._mdf || t) for (n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, r = a.shape.paths._length, s = 0; s < r; s += 1) {
        n.addShape(this.processPath(e[s], h));
      }
      a.shape.paths = a.localShapeCollection;
    }
    this.dynamicProperties.length || (this._mdf = !1);
  };

  var Tt = function () {
    var t = [0, 0];

    function e(t, e, i) {
      if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new vt(), this.pre = new vt(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(i || t), e.p && e.p.s ? (this.px = at.getProp(t, e.p.x, 0, 0, this), this.py = at.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = at.getProp(t, e.p.z, 0, 0, this))) : this.p = at.getProp(t, e.p || {
        k: [0, 0, 0]
      }, 1, 0, this), e.rx) {
        if (this.rx = at.getProp(t, e.rx, 0, k, this), this.ry = at.getProp(t, e.ry, 0, k, this), this.rz = at.getProp(t, e.rz, 0, k, this), e.or.k[0].ti) {
          var s,
              r = e.or.k.length;

          for (s = 0; s < r; s += 1) {
            e.or.k[s].to = null, e.or.k[s].ti = null;
          }
        }

        this.or = at.getProp(t, e.or, 1, k, this), this.or.sh = !0;
      } else this.r = at.getProp(t, e.r || {
        k: 0
      }, 0, k, this);

      e.sk && (this.sk = at.getProp(t, e.sk, 0, k, this), this.sa = at.getProp(t, e.sa, 0, k, this)), this.a = at.getProp(t, e.a || {
        k: [0, 0, 0]
      }, 1, 0, this), this.s = at.getProp(t, e.s || {
        k: [100, 100, 100]
      }, 1, .01, this), e.o ? this.o = at.getProp(t, e.o, 0, .01, t) : this.o = {
        _mdf: !1,
        v: 1
      }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
    }

    return e.prototype = {
      applyToMatrix: function applyToMatrix(t) {
        var e = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      },
      getValue: function getValue(e) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e) {
            var i;

            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var s, r;
              if (i = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (s = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / i, 0), r = this.p.getValueAtTime(this.p.keyframes[0].t / i, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (s = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / i, 0), r = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / i, 0)) : (s = this.p.pv, r = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / i, this.p.offsetTime));else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                s = [], r = [];
                var a = this.px,
                    n = this.py;
                a._caching.lastFrame + a.offsetTime <= a.keyframes[0].t ? (s[0] = a.getValueAtTime((a.keyframes[0].t + .01) / i, 0), s[1] = n.getValueAtTime((n.keyframes[0].t + .01) / i, 0), r[0] = a.getValueAtTime(a.keyframes[0].t / i, 0), r[1] = n.getValueAtTime(n.keyframes[0].t / i, 0)) : a._caching.lastFrame + a.offsetTime >= a.keyframes[a.keyframes.length - 1].t ? (s[0] = a.getValueAtTime(a.keyframes[a.keyframes.length - 1].t / i, 0), s[1] = n.getValueAtTime(n.keyframes[n.keyframes.length - 1].t / i, 0), r[0] = a.getValueAtTime((a.keyframes[a.keyframes.length - 1].t - .01) / i, 0), r[1] = n.getValueAtTime((n.keyframes[n.keyframes.length - 1].t - .01) / i, 0)) : (s = [a.pv, n.pv], r[0] = a.getValueAtTime((a._caching.lastFrame + a.offsetTime - .01) / i, a.offsetTime), r[1] = n.getValueAtTime((n._caching.lastFrame + n.offsetTime - .01) / i, n.offsetTime));
              } else s = r = t;
              this.v.rotate(-Math.atan2(s[1] - r[1], s[0] - r[0]));
            }

            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }

          this.frameId = this.elem.globalData.frameId;
        }
      },
      precalculateMatrix: function precalculateMatrix() {
        if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
          if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          }

          this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
        }
      },
      autoOrient: function autoOrient() {}
    }, a([nt], e), e.prototype.addDynamicProperty = function (t) {
      this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0;
    }, e.prototype._addDynamicProperty = nt.prototype.addDynamicProperty, {
      getTransformProperty: function getTransformProperty(t, i, s) {
        return new e(t, i, s);
      }
    };
  }();

  function Ft() {}

  function Mt() {}

  function It(t) {
    for (var e = t.fStyle ? t.fStyle.split(" ") : [], i = "normal", s = "normal", r = e.length, a = 0; a < r; a += 1) {
      switch (e[a].toLowerCase()) {
        case "italic":
          s = "italic";
          break;

        case "bold":
          i = "700";
          break;

        case "black":
          i = "900";
          break;

        case "medium":
          i = "500";
          break;

        case "regular":
        case "normal":
          i = "400";
          break;

        case "light":
        case "thin":
          i = "200";
      }
    }

    return {
      style: s,
      weight: t.fWeight || i
    };
  }

  a([Dt], Ft), Ft.prototype.initModifierProperties = function (t, e) {
    this.getValue = this.processKeys, this.c = at.getProp(t, e.c, 0, null, this), this.o = at.getProp(t, e.o, 0, null, this), this.tr = Tt.getTransformProperty(t, e.tr, this), this.so = at.getProp(t, e.tr.so, 0, .01, this), this.eo = at.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new vt(), this.rMatrix = new vt(), this.sMatrix = new vt(), this.tMatrix = new vt(), this.matrix = new vt();
  }, Ft.prototype.applyTransforms = function (t, e, i, s, r, a) {
    var n = a ? -1 : 1,
        o = s.s.v[0] + (1 - s.s.v[0]) * (1 - r),
        h = s.s.v[1] + (1 - s.s.v[1]) * (1 - r);
    t.translate(s.p.v[0] * n * r, s.p.v[1] * n * r, s.p.v[2]), e.translate(-s.a.v[0], -s.a.v[1], s.a.v[2]), e.rotate(-s.r.v * n * r), e.translate(s.a.v[0], s.a.v[1], s.a.v[2]), i.translate(-s.a.v[0], -s.a.v[1], s.a.v[2]), i.scale(a ? 1 / o : o, a ? 1 / h : h), i.translate(s.a.v[0], s.a.v[1], s.a.v[2]);
  }, Ft.prototype.init = function (t, e, i, s) {
    for (this.elem = t, this.arr = e, this.pos = i, this.elemsData = s, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[i]); i > 0;) {
      i -= 1, this._elements.unshift(e[i]);
    }

    this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
  }, Ft.prototype.resetElements = function (t) {
    var e,
        i = t.length;

    for (e = 0; e < i; e += 1) {
      t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
    }
  }, Ft.prototype.cloneElements = function (t) {
    var e = JSON.parse(JSON.stringify(t));
    return this.resetElements(e), e;
  }, Ft.prototype.changeGroupRender = function (t, e) {
    var i,
        s = t.length;

    for (i = 0; i < s; i += 1) {
      t[i]._render = e, "gr" === t[i].ty && this.changeGroupRender(t[i].it, e);
    }
  }, Ft.prototype.processShapes = function (t) {
    var e,
        i,
        s,
        r,
        a,
        n = !1;

    if (this._mdf || t) {
      var o,
          h = Math.ceil(this.c.v);

      if (this._groups.length < h) {
        for (; this._groups.length < h;) {
          var p = {
            it: this.cloneElements(this._elements),
            ty: "gr"
          };
          p.it.push({
            a: {
              a: 0,
              ix: 1,
              k: [0, 0]
            },
            nm: "Transform",
            o: {
              a: 0,
              ix: 7,
              k: 100
            },
            p: {
              a: 0,
              ix: 2,
              k: [0, 0]
            },
            r: {
              a: 1,
              ix: 6,
              k: [{
                s: 0,
                e: 0,
                t: 0
              }, {
                s: 0,
                e: 0,
                t: 1
              }]
            },
            s: {
              a: 0,
              ix: 3,
              k: [100, 100]
            },
            sa: {
              a: 0,
              ix: 5,
              k: 0
            },
            sk: {
              a: 0,
              ix: 4,
              k: 0
            },
            ty: "tr"
          }), this.arr.splice(0, 0, p), this._groups.splice(0, 0, p), this._currentCopies += 1;
        }

        this.elem.reloadShapes(), n = !0;
      }

      for (a = 0, s = 0; s <= this._groups.length - 1; s += 1) {
        if (o = a < h, this._groups[s]._render = o, this.changeGroupRender(this._groups[s].it, o), !o) {
          var l = this.elemsData[s].it,
              f = l[l.length - 1];
          0 !== f.transform.op.v ? (f.transform.op._mdf = !0, f.transform.op.v = 0) : f.transform.op._mdf = !1;
        }

        a += 1;
      }

      this._currentCopies = h;
      var c = this.o.v,
          u = c % 1,
          m = c > 0 ? Math.floor(c) : Math.ceil(c),
          d = this.pMatrix.props,
          g = this.rMatrix.props,
          y = this.sMatrix.props;
      this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
      var v,
          b,
          _ = 0;

      if (c > 0) {
        for (; _ < m;) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), _ += 1;
        }

        u && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, u, !1), _ += u);
      } else if (c < 0) {
        for (; _ > m;) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), _ -= 1;
        }

        u && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -u, !0), _ -= u);
      }

      for (s = 1 === this.data.m ? 0 : this._currentCopies - 1, r = 1 === this.data.m ? 1 : -1, a = this._currentCopies; a;) {
        if (b = (i = (e = this.elemsData[s].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (s / (this._currentCopies - 1)), 0 !== _) {
          for ((0 !== s && 1 === r || s !== this._currentCopies - 1 && -1 === r) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), this.matrix.transform(d[0], d[1], d[2], d[3], d[4], d[5], d[6], d[7], d[8], d[9], d[10], d[11], d[12], d[13], d[14], d[15]), v = 0; v < b; v += 1) {
            i[v] = this.matrix.props[v];
          }

          this.matrix.reset();
        } else for (this.matrix.reset(), v = 0; v < b; v += 1) {
          i[v] = this.matrix.props[v];
        }

        _ += 1, a -= 1, s += r;
      }
    } else for (a = this._currentCopies, s = 0, r = 1; a;) {
      i = (e = this.elemsData[s].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, a -= 1, s += r;
    }

    return n;
  }, Ft.prototype.addShape = function () {}, a([Dt], Mt), Mt.prototype.initModifierProperties = function (t, e) {
    this.getValue = this.processKeys, this.rd = at.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
  }, Mt.prototype.processPath = function (t, e) {
    var i,
        s = lt.newElement();
    s.c = t.c;
    var r,
        a,
        n,
        o,
        h,
        p,
        l,
        f,
        c,
        u,
        m,
        d,
        g = t._length,
        y = 0;

    for (i = 0; i < g; i += 1) {
      r = t.v[i], n = t.o[i], a = t.i[i], r[0] === n[0] && r[1] === n[1] && r[0] === a[0] && r[1] === a[1] ? 0 !== i && i !== g - 1 || t.c ? (o = 0 === i ? t.v[g - 1] : t.v[i - 1], p = (h = Math.sqrt(Math.pow(r[0] - o[0], 2) + Math.pow(r[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, l = m = r[0] + (o[0] - r[0]) * p, f = d = r[1] - (r[1] - o[1]) * p, c = l - (l - r[0]) * S, u = f - (f - r[1]) * S, s.setTripleAt(l, f, c, u, m, d, y), y += 1, o = i === g - 1 ? t.v[0] : t.v[i + 1], p = (h = Math.sqrt(Math.pow(r[0] - o[0], 2) + Math.pow(r[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, l = c = r[0] + (o[0] - r[0]) * p, f = u = r[1] + (o[1] - r[1]) * p, m = l - (l - r[0]) * S, d = f - (f - r[1]) * S, s.setTripleAt(l, f, c, u, m, d, y), y += 1) : (s.setTripleAt(r[0], r[1], n[0], n[1], a[0], a[1], y), y += 1) : (s.setTripleAt(t.v[i][0], t.v[i][1], t.o[i][0], t.o[i][1], t.i[i][0], t.i[i][1], y), y += 1);
    }

    return s;
  }, Mt.prototype.processShapes = function (t) {
    var e,
        i,
        s,
        r,
        a,
        n,
        o = this.shapes.length,
        h = this.rd.v;
    if (0 !== h) for (i = 0; i < o; i += 1) {
      if (n = (a = this.shapes[i]).localShapeCollection, a.shape._mdf || this._mdf || t) for (n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, r = a.shape.paths._length, s = 0; s < r; s += 1) {
        n.addShape(this.processPath(e[s], h));
      }
      a.shape.paths = a.localShapeCollection;
    }
    this.dynamicProperties.length || (this._mdf = !1);
  };

  var Lt = function () {
    var t = {
      w: 0,
      size: 0,
      shapes: [],
      data: {
        shapes: []
      }
    },
        e = [];
    e = e.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
    var i = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"],
        s = [65039, 8205];

    function a(t, e) {
      var i = r("span");
      i.setAttribute("aria-hidden", !0), i.style.fontFamily = e;
      var s = r("span");
      s.innerText = "giItT1WQy@!-/#", i.style.position = "absolute", i.style.left = "-10000px", i.style.top = "-10000px", i.style.fontSize = "300px", i.style.fontVariant = "normal", i.style.fontStyle = "normal", i.style.fontWeight = "normal", i.style.letterSpacing = "0", i.appendChild(s), document.body.appendChild(i);
      var a = s.offsetWidth;
      return s.style.fontFamily = function (t) {
        var e,
            i = t.split(","),
            s = i.length,
            r = [];

        for (e = 0; e < s; e += 1) {
          "sans-serif" !== i[e] && "monospace" !== i[e] && r.push(i[e]);
        }

        return r.join(",");
      }(t) + ", " + e, {
        node: s,
        w: a,
        parent: i
      };
    }

    function n(t, e) {
      var i,
          s = document.body && e ? "svg" : "canvas",
          r = It(t);

      if ("svg" === s) {
        var a = B("text");
        a.style.fontSize = "100px", a.setAttribute("font-family", t.fFamily), a.setAttribute("font-style", r.style), a.setAttribute("font-weight", r.weight), a.textContent = "1", t.fClass ? (a.style.fontFamily = "inherit", a.setAttribute("class", t.fClass)) : a.style.fontFamily = t.fFamily, e.appendChild(a), i = a;
      } else {
        var n = new OffscreenCanvas(500, 500).getContext("2d");
        n.font = r.style + " " + r.weight + " 100px " + t.fFamily, i = n;
      }

      return {
        measureText: function measureText(t) {
          return "svg" === s ? (i.textContent = t, i.getComputedTextLength()) : i.measureText(t).width;
        }
      };
    }

    var o = function o() {
      this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
    };

    o.isModifier = function (t, e) {
      var s = t.toString(16) + e.toString(16);
      return -1 !== i.indexOf(s);
    }, o.isZeroWidthJoiner = function (t, e) {
      return e ? t === s[0] && e === s[1] : t === s[1];
    }, o.isCombinedCharacter = function (t) {
      return -1 !== e.indexOf(t);
    };
    var h = {
      addChars: function addChars(t) {
        if (t) {
          var e;
          this.chars || (this.chars = []);
          var i,
              s,
              r = t.length,
              a = this.chars.length;

          for (e = 0; e < r; e += 1) {
            for (i = 0, s = !1; i < a;) {
              this.chars[i].style === t[e].style && this.chars[i].fFamily === t[e].fFamily && this.chars[i].ch === t[e].ch && (s = !0), i += 1;
            }

            s || (this.chars.push(t[e]), a += 1);
          }
        }
      },
      addFonts: function addFonts(t, e) {
        if (t) {
          if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
          if (!document.body) return this.isLoaded = !0, t.list.forEach(function (t) {
            t.helper = n(t), t.cache = {};
          }), void (this.fonts = t.list);
          var i,
              s = t.list,
              o = s.length,
              h = o;

          for (i = 0; i < o; i += 1) {
            var p,
                l,
                f = !0;

            if (s[i].loaded = !1, s[i].monoCase = a(s[i].fFamily, "monospace"), s[i].sansCase = a(s[i].fFamily, "sans-serif"), s[i].fPath) {
              if ("p" === s[i].fOrigin || 3 === s[i].origin) {
                if ((p = document.querySelectorAll('style[f-forigin="p"][f-family="' + s[i].fFamily + '"], style[f-origin="3"][f-family="' + s[i].fFamily + '"]')).length > 0 && (f = !1), f) {
                  var c = r("style");
                  c.setAttribute("f-forigin", s[i].fOrigin), c.setAttribute("f-origin", s[i].origin), c.setAttribute("f-family", s[i].fFamily), c.type = "text/css", c.innerText = "@font-face {font-family: " + s[i].fFamily + "; font-style: normal; src: url('" + s[i].fPath + "');}", e.appendChild(c);
                }
              } else if ("g" === s[i].fOrigin || 1 === s[i].origin) {
                for (p = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l = 0; l < p.length; l += 1) {
                  -1 !== p[l].href.indexOf(s[i].fPath) && (f = !1);
                }

                if (f) {
                  var u = r("link");
                  u.setAttribute("f-forigin", s[i].fOrigin), u.setAttribute("f-origin", s[i].origin), u.type = "text/css", u.rel = "stylesheet", u.href = s[i].fPath, document.body.appendChild(u);
                }
              } else if ("t" === s[i].fOrigin || 2 === s[i].origin) {
                for (p = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l = 0; l < p.length; l += 1) {
                  s[i].fPath === p[l].src && (f = !1);
                }

                if (f) {
                  var m = r("link");
                  m.setAttribute("f-forigin", s[i].fOrigin), m.setAttribute("f-origin", s[i].origin), m.setAttribute("rel", "stylesheet"), m.setAttribute("href", s[i].fPath), e.appendChild(m);
                }
              }
            } else s[i].loaded = !0, h -= 1;

            s[i].helper = n(s[i], e), s[i].cache = {}, this.fonts.push(s[i]);
          }

          0 === h ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
        } else this.isLoaded = !0;
      },
      getCharData: function getCharData(e, i, s) {
        for (var r = 0, a = this.chars.length; r < a;) {
          if (this.chars[r].ch === e && this.chars[r].style === i && this.chars[r].fFamily === s) return this.chars[r];
          r += 1;
        }

        return ("string" == typeof e && 13 !== e.charCodeAt(0) || !e) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", e, i, s)), t;
      },
      getFontByName: function getFontByName(t) {
        for (var e = 0, i = this.fonts.length; e < i;) {
          if (this.fonts[e].fName === t) return this.fonts[e];
          e += 1;
        }

        return this.fonts[0];
      },
      measureText: function measureText(t, e, i) {
        var s = this.getFontByName(e),
            r = t.charCodeAt(0);

        if (!s.cache[r + 1]) {
          var a = s.helper;

          if (" " === t) {
            var n = a.measureText("|" + t + "|"),
                o = a.measureText("||");
            s.cache[r + 1] = (n - o) / 100;
          } else s.cache[r + 1] = a.measureText(t) / 100;
        }

        return s.cache[r + 1] * i;
      },
      checkLoadedFonts: function checkLoadedFonts() {
        var t,
            e,
            i,
            s = this.fonts.length,
            r = s;

        for (t = 0; t < s; t += 1) {
          this.fonts[t].loaded ? r -= 1 : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (e = this.fonts[t].monoCase.node, i = this.fonts[t].monoCase.w, e.offsetWidth !== i ? (r -= 1, this.fonts[t].loaded = !0) : (e = this.fonts[t].sansCase.node, i = this.fonts[t].sansCase.w, e.offsetWidth !== i && (r -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
        }

        0 !== r && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      },
      setIsLoaded: function setIsLoaded() {
        this.isLoaded = !0;
      }
    };
    return o.prototype = h, o;
  }();

  function Ot() {}

  Ot.prototype = {
    initRenderable: function initRenderable() {
      this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
    },
    addRenderableComponent: function addRenderableComponent(t) {
      -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
    },
    removeRenderableComponent: function removeRenderableComponent(t) {
      -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
    },
    prepareRenderableFrame: function prepareRenderableFrame(t) {
      this.checkLayerLimits(t);
    },
    checkTransparency: function checkTransparency() {
      this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
    },
    checkLayerLimits: function checkLayerLimits(t) {
      this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
    },
    renderRenderable: function renderRenderable() {
      var t,
          e = this.renderableComponents.length;

      for (t = 0; t < e; t += 1) {
        this.renderableComponents[t].renderFrame(this._isFirstFrame);
      }
    },
    sourceRectAtTime: function sourceRectAtTime() {
      return {
        top: 0,
        left: 0,
        width: 100,
        height: 100
      };
    },
    getLayerSize: function getLayerSize() {
      return 5 === this.data.ty ? {
        w: this.data.textData.width,
        h: this.data.textData.height
      } : {
        w: this.data.width,
        h: this.data.height
      };
    }
  };

  var Rt,
      Vt = function () {
    function t(t, e) {
      this._mask = t, this._data = e;
    }

    return Object.defineProperty(t.prototype, "maskPath", {
      get: function get() {
        return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
      }
    }), Object.defineProperty(t.prototype, "maskOpacity", {
      get: function get() {
        return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
      }
    }), function (e) {
      var i,
          s = l(e.viewData.length),
          r = e.viewData.length;

      for (i = 0; i < r; i += 1) {
        s[i] = new t(e.viewData[i], e.masksProperties[i]);
      }

      return function (t) {
        for (i = 0; i < r;) {
          if (e.masksProperties[i].nm === t) return s[i];
          i += 1;
        }

        return null;
      };
    };
  }(),
      jt = function () {
    var t = {
      pv: 0,
      v: 0,
      mult: 1
    },
        e = {
      pv: [0, 0, 0],
      v: [0, 0, 0],
      mult: 1
    };

    function i(t, e, i) {
      Object.defineProperty(t, "velocity", {
        get: function get() {
          return e.getVelocityAtTime(e.comp.currentFrame);
        }
      }), t.numKeys = e.keyframes ? e.keyframes.length : 0, t.key = function (s) {
        if (!t.numKeys) return 0;
        var r = "";
        r = "s" in e.keyframes[s - 1] ? e.keyframes[s - 1].s : "e" in e.keyframes[s - 2] ? e.keyframes[s - 2].e : e.keyframes[s - 2].s;
        var a = "unidimensional" === i ? new Number(r) : Object.assign({}, r);
        return a.time = e.keyframes[s - 1].t / e.elem.comp.globalData.frameRate, a.value = "unidimensional" === i ? r[0] : r, a;
      }, t.valueAtTime = e.getValueAtTime, t.speedAtTime = e.getSpeedAtTime, t.velocityAtTime = e.getVelocityAtTime, t.propertyGroup = e.propertyGroup;
    }

    function s() {
      return t;
    }

    return function (r) {
      return r ? "unidimensional" === r.propType ? function (e) {
        e && "pv" in e || (e = t);
        var s = 1 / e.mult,
            r = e.pv * s,
            a = new Number(r);
        return a.value = r, i(a, e, "unidimensional"), function () {
          return e.k && e.getValue(), r = e.v * s, a.value !== r && ((a = new Number(r)).value = r, i(a, e, "unidimensional")), a;
        };
      }(r) : function (t) {
        t && "pv" in t || (t = e);
        var s = 1 / t.mult,
            r = t.data && t.data.l || t.pv.length,
            a = p("float32", r),
            n = p("float32", r);
        return a.value = n, i(a, t, "multidimensional"), function () {
          t.k && t.getValue();

          for (var e = 0; e < r; e += 1) {
            n[e] = t.v[e] * s, a[e] = n[e];
          }

          return a;
        };
      }(r) : s;
    };
  }(),
      zt = function zt(t) {
    function e(t) {
      switch (t) {
        case "scale":
        case "Scale":
        case "ADBE Scale":
        case 6:
          return e.scale;

        case "rotation":
        case "Rotation":
        case "ADBE Rotation":
        case "ADBE Rotate Z":
        case 10:
          return e.rotation;

        case "ADBE Rotate X":
          return e.xRotation;

        case "ADBE Rotate Y":
          return e.yRotation;

        case "position":
        case "Position":
        case "ADBE Position":
        case 2:
          return e.position;

        case "ADBE Position_0":
          return e.xPosition;

        case "ADBE Position_1":
          return e.yPosition;

        case "ADBE Position_2":
          return e.zPosition;

        case "anchorPoint":
        case "AnchorPoint":
        case "Anchor Point":
        case "ADBE AnchorPoint":
        case 1:
          return e.anchorPoint;

        case "opacity":
        case "Opacity":
        case 11:
          return e.opacity;

        default:
          return null;
      }
    }

    var i, s, r, a;
    return Object.defineProperty(e, "rotation", {
      get: jt(t.r || t.rz)
    }), Object.defineProperty(e, "zRotation", {
      get: jt(t.rz || t.r)
    }), Object.defineProperty(e, "xRotation", {
      get: jt(t.rx)
    }), Object.defineProperty(e, "yRotation", {
      get: jt(t.ry)
    }), Object.defineProperty(e, "scale", {
      get: jt(t.s)
    }), t.p ? a = jt(t.p) : (i = jt(t.px), s = jt(t.py), t.pz && (r = jt(t.pz))), Object.defineProperty(e, "position", {
      get: function get() {
        return t.p ? a() : [i(), s(), r ? r() : 0];
      }
    }), Object.defineProperty(e, "xPosition", {
      get: jt(t.px)
    }), Object.defineProperty(e, "yPosition", {
      get: jt(t.py)
    }), Object.defineProperty(e, "zPosition", {
      get: jt(t.pz)
    }), Object.defineProperty(e, "anchorPoint", {
      get: jt(t.a)
    }), Object.defineProperty(e, "opacity", {
      get: jt(t.o)
    }), Object.defineProperty(e, "skew", {
      get: jt(t.sk)
    }), Object.defineProperty(e, "skewAxis", {
      get: jt(t.sa)
    }), Object.defineProperty(e, "orientation", {
      get: jt(t.or)
    }), e;
  },
      Nt = function () {
    function t(t) {
      var e = new vt();
      return void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e), e;
    }

    function e(t, e) {
      var i = this.getMatrix(e);
      return i.props[12] = 0, i.props[13] = 0, i.props[14] = 0, this.applyPoint(i, t);
    }

    function i(t, e) {
      var i = this.getMatrix(e);
      return this.applyPoint(i, t);
    }

    function s(t, e) {
      var i = this.getMatrix(e);
      return i.props[12] = 0, i.props[13] = 0, i.props[14] = 0, this.invertPoint(i, t);
    }

    function r(t, e) {
      var i = this.getMatrix(e);
      return this.invertPoint(i, t);
    }

    function a(t, e) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i,
            s = this._elem.hierarchy.length;

        for (i = 0; i < s; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(t);
        }
      }

      return t.applyToPointArray(e[0], e[1], e[2] || 0);
    }

    function o(t, e) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i,
            s = this._elem.hierarchy.length;

        for (i = 0; i < s; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(t);
        }
      }

      return t.inversePoint(e);
    }

    function h(t) {
      var e = new vt();

      if (e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length) {
        var i,
            s = this._elem.hierarchy.length;

        for (i = 0; i < s; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(e);
        }

        return e.inversePoint(t);
      }

      return e.inversePoint(t);
    }

    function p() {
      return [1, 1, 1, 1];
    }

    return function (l) {
      var f;

      function c(t) {
        switch (t) {
          case "ADBE Root Vectors Group":
          case "Contents":
          case 2:
            return c.shapeInterface;

          case 1:
          case 6:
          case "Transform":
          case "transform":
          case "ADBE Transform Group":
            return f;

          case 4:
          case "ADBE Effect Parade":
          case "effects":
          case "Effects":
            return c.effect;

          case "ADBE Text Properties":
            return c.textInterface;

          default:
            return null;
        }
      }

      c.getMatrix = t, c.invertPoint = o, c.applyPoint = a, c.toWorld = i, c.toWorldVec = e, c.fromWorld = r, c.fromWorldVec = s, c.toComp = i, c.fromComp = h, c.sampleImage = p, c.sourceRectAtTime = l.sourceRectAtTime.bind(l), c._elem = l;
      var u = n(f = zt(l.finalTransform.mProp), "anchorPoint");
      return Object.defineProperties(c, {
        hasParent: {
          get: function get() {
            return l.hierarchy.length;
          }
        },
        parent: {
          get: function get() {
            return l.hierarchy[0].layerInterface;
          }
        },
        rotation: n(f, "rotation"),
        scale: n(f, "scale"),
        position: n(f, "position"),
        opacity: n(f, "opacity"),
        anchorPoint: u,
        anchor_point: u,
        transform: {
          get: function get() {
            return f;
          }
        },
        active: {
          get: function get() {
            return l.isInRange;
          }
        }
      }), c.startTime = l.data.st, c.index = l.data.ind, c.source = l.data.refId, c.height = 0 === l.data.ty ? l.data.h : 100, c.width = 0 === l.data.ty ? l.data.w : 100, c.inPoint = l.data.ip / l.comp.globalData.frameRate, c.outPoint = l.data.op / l.comp.globalData.frameRate, c._name = l.data.nm, c.registerMaskInterface = function (t) {
        c.mask = new Vt(t, l);
      }, c.registerEffectsInterface = function (t) {
        c.effect = t;
      }, c;
    };
  }(),
      Bt = function Bt(t, e) {
    return function (i) {
      return (i = void 0 === i ? 1 : i) <= 0 ? t : e(i - 1);
    };
  },
      Gt = function Gt(t, e) {
    var i = {
      _name: t
    };
    return function (t) {
      return (t = void 0 === t ? 1 : t) <= 0 ? i : e(t - 1);
    };
  },
      qt = function () {
    function t(i, s, r, a) {
      function n(t) {
        for (var e = i.ef, s = 0, r = e.length; s < r;) {
          if (t === e[s].nm || t === e[s].mn || t === e[s].ix) return 5 === e[s].ty ? p[s] : p[s]();
          s += 1;
        }

        throw new Error();
      }

      var o,
          h = Bt(n, r),
          p = [],
          l = i.ef.length;

      for (o = 0; o < l; o += 1) {
        5 === i.ef[o].ty ? p.push(t(i.ef[o], s.effectElements[o], s.effectElements[o].propertyGroup, a)) : p.push(e(s.effectElements[o], i.ef[o].ty, a, h));
      }

      return "ADBE Color Control" === i.mn && Object.defineProperty(n, "color", {
        get: function get() {
          return p[0]();
        }
      }), Object.defineProperties(n, {
        numProperties: {
          get: function get() {
            return i.np;
          }
        },
        _name: {
          value: i.nm
        },
        propertyGroup: {
          value: h
        }
      }), n.enabled = 0 !== i.en, n.active = n.enabled, n;
    }

    function e(t, e, i, s) {
      var r = jt(t.p);
      return t.p.setGroupProperty && t.p.setGroupProperty(Gt("", s)), function () {
        return 10 === e ? i.comp.compInterface(t.p.v) : r();
      };
    }

    return {
      createEffectsInterface: function createEffectsInterface(e, i) {
        if (e.effectsManager) {
          var s,
              r = [],
              a = e.data.ef,
              n = e.effectsManager.effectElements.length;

          for (s = 0; s < n; s += 1) {
            r.push(t(a[s], e.effectsManager.effectElements[s], i, e));
          }

          var o = e.data.ef || [],
              h = function h(t) {
            for (s = 0, n = o.length; s < n;) {
              if (t === o[s].nm || t === o[s].mn || t === o[s].ix) return r[s];
              s += 1;
            }

            return null;
          };

          return Object.defineProperty(h, "numProperties", {
            get: function get() {
              return o.length;
            }
          }), h;
        }

        return null;
      }
    };
  }(),
      Wt = function Wt(t) {
    function e(e) {
      for (var i = 0, s = t.layers.length; i < s;) {
        if (t.layers[i].nm === e || t.layers[i].ind === e) return t.elements[i].layerInterface;
        i += 1;
      }

      return null;
    }

    return Object.defineProperty(e, "_name", {
      value: t.data.nm
    }), e.layer = e, e.pixelAspect = 1, e.height = t.data.h || t.globalData.compSize.h, e.width = t.data.w || t.globalData.compSize.w, e.pixelAspect = 1, e.frameDuration = 1 / t.globalData.frameRate, e.displayStartTime = 0, e.numLayers = t.layers.length, e;
  },
      $t = function $t(t, e, i) {
    var s = e.sh;

    function r(t) {
      return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? r.path : null;
    }

    var a = Bt(r, i);
    return s.setGroupProperty(Gt("Path", a)), Object.defineProperties(r, {
      path: {
        get: function get() {
          return s.k && s.getValue(), s;
        }
      },
      shape: {
        get: function get() {
          return s.k && s.getValue(), s;
        }
      },
      _name: {
        value: t.nm
      },
      ix: {
        value: t.ix
      },
      propertyIndex: {
        value: t.ix
      },
      mn: {
        value: t.mn
      },
      propertyGroup: {
        value: i
      }
    }), r;
  },
      Yt = function () {
    function t(t, o, u) {
      var m,
          d = [],
          g = t ? t.length : 0;

      for (m = 0; m < g; m += 1) {
        "gr" === t[m].ty ? d.push(e(t[m], o[m], u)) : "fl" === t[m].ty ? d.push(i(t[m], o[m], u)) : "st" === t[m].ty ? d.push(a(t[m], o[m], u)) : "tm" === t[m].ty ? d.push(n(t[m], o[m], u)) : "tr" === t[m].ty || ("el" === t[m].ty ? d.push(h(t[m], o[m], u)) : "sr" === t[m].ty ? d.push(p(t[m], o[m], u)) : "sh" === t[m].ty ? d.push($t(t[m], o[m], u)) : "rc" === t[m].ty ? d.push(l(t[m], o[m], u)) : "rd" === t[m].ty ? d.push(f(t[m], o[m], u)) : "rp" === t[m].ty ? d.push(c(t[m], o[m], u)) : "gf" === t[m].ty ? d.push(s(t[m], o[m], u)) : d.push(r(t[m], o[m])));
      }

      return d;
    }

    function e(e, i, s) {
      var r = function r(t) {
        switch (t) {
          case "ADBE Vectors Group":
          case "Contents":
          case 2:
            return r.content;

          default:
            return r.transform;
        }
      };

      r.propertyGroup = Bt(r, s);

      var a = function (e, i, s) {
        var r,
            a = function a(t) {
          for (var e = 0, i = r.length; e < i;) {
            if (r[e]._name === t || r[e].mn === t || r[e].propertyIndex === t || r[e].ix === t || r[e].ind === t) return r[e];
            e += 1;
          }

          return "number" == typeof t ? r[t - 1] : null;
        };

        a.propertyGroup = Bt(a, s), r = t(e.it, i.it, a.propertyGroup), a.numProperties = r.length;
        var n = o(e.it[e.it.length - 1], i.it[i.it.length - 1], a.propertyGroup);
        return a.transform = n, a.propertyIndex = e.cix, a._name = e.nm, a;
      }(e, i, r.propertyGroup),
          n = o(e.it[e.it.length - 1], i.it[i.it.length - 1], r.propertyGroup);

      return r.content = a, r.transform = n, Object.defineProperty(r, "_name", {
        get: function get() {
          return e.nm;
        }
      }), r.numProperties = e.np, r.propertyIndex = e.ix, r.nm = e.nm, r.mn = e.mn, r;
    }

    function i(t, e, i) {
      function s(t) {
        return "Color" === t || "color" === t ? s.color : "Opacity" === t || "opacity" === t ? s.opacity : null;
      }

      return Object.defineProperties(s, {
        color: {
          get: jt(e.c)
        },
        opacity: {
          get: jt(e.o)
        },
        _name: {
          value: t.nm
        },
        mn: {
          value: t.mn
        }
      }), e.c.setGroupProperty(Gt("Color", i)), e.o.setGroupProperty(Gt("Opacity", i)), s;
    }

    function s(t, e, i) {
      function s(t) {
        return "Start Point" === t || "start point" === t ? s.startPoint : "End Point" === t || "end point" === t ? s.endPoint : "Opacity" === t || "opacity" === t ? s.opacity : null;
      }

      return Object.defineProperties(s, {
        startPoint: {
          get: jt(e.s)
        },
        endPoint: {
          get: jt(e.e)
        },
        opacity: {
          get: jt(e.o)
        },
        type: {
          get: function get() {
            return "a";
          }
        },
        _name: {
          value: t.nm
        },
        mn: {
          value: t.mn
        }
      }), e.s.setGroupProperty(Gt("Start Point", i)), e.e.setGroupProperty(Gt("End Point", i)), e.o.setGroupProperty(Gt("Opacity", i)), s;
    }

    function r() {
      return function () {
        return null;
      };
    }

    function a(t, e, i) {
      var s,
          r = Bt(p, i),
          a = Bt(h, r);

      function n(i) {
        Object.defineProperty(h, t.d[i].nm, {
          get: jt(e.d.dataProps[i].p)
        });
      }

      var o = t.d ? t.d.length : 0,
          h = {};

      for (s = 0; s < o; s += 1) {
        n(s), e.d.dataProps[s].p.setGroupProperty(a);
      }

      function p(t) {
        return "Color" === t || "color" === t ? p.color : "Opacity" === t || "opacity" === t ? p.opacity : "Stroke Width" === t || "stroke width" === t ? p.strokeWidth : null;
      }

      return Object.defineProperties(p, {
        color: {
          get: jt(e.c)
        },
        opacity: {
          get: jt(e.o)
        },
        strokeWidth: {
          get: jt(e.w)
        },
        dash: {
          get: function get() {
            return h;
          }
        },
        _name: {
          value: t.nm
        },
        mn: {
          value: t.mn
        }
      }), e.c.setGroupProperty(Gt("Color", r)), e.o.setGroupProperty(Gt("Opacity", r)), e.w.setGroupProperty(Gt("Stroke Width", r)), p;
    }

    function n(t, e, i) {
      function s(e) {
        return e === t.e.ix || "End" === e || "end" === e ? s.end : e === t.s.ix ? s.start : e === t.o.ix ? s.offset : null;
      }

      var r = Bt(s, i);
      return s.propertyIndex = t.ix, e.s.setGroupProperty(Gt("Start", r)), e.e.setGroupProperty(Gt("End", r)), e.o.setGroupProperty(Gt("Offset", r)), s.propertyIndex = t.ix, s.propertyGroup = i, Object.defineProperties(s, {
        start: {
          get: jt(e.s)
        },
        end: {
          get: jt(e.e)
        },
        offset: {
          get: jt(e.o)
        },
        _name: {
          value: t.nm
        }
      }), s.mn = t.mn, s;
    }

    function o(t, e, i) {
      function s(e) {
        return t.a.ix === e || "Anchor Point" === e ? s.anchorPoint : t.o.ix === e || "Opacity" === e ? s.opacity : t.p.ix === e || "Position" === e ? s.position : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e ? s.rotation : t.s.ix === e || "Scale" === e ? s.scale : t.sk && t.sk.ix === e || "Skew" === e ? s.skew : t.sa && t.sa.ix === e || "Skew Axis" === e ? s.skewAxis : null;
      }

      var r = Bt(s, i);
      return e.transform.mProps.o.setGroupProperty(Gt("Opacity", r)), e.transform.mProps.p.setGroupProperty(Gt("Position", r)), e.transform.mProps.a.setGroupProperty(Gt("Anchor Point", r)), e.transform.mProps.s.setGroupProperty(Gt("Scale", r)), e.transform.mProps.r.setGroupProperty(Gt("Rotation", r)), e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(Gt("Skew", r)), e.transform.mProps.sa.setGroupProperty(Gt("Skew Angle", r))), e.transform.op.setGroupProperty(Gt("Opacity", r)), Object.defineProperties(s, {
        opacity: {
          get: jt(e.transform.mProps.o)
        },
        position: {
          get: jt(e.transform.mProps.p)
        },
        anchorPoint: {
          get: jt(e.transform.mProps.a)
        },
        scale: {
          get: jt(e.transform.mProps.s)
        },
        rotation: {
          get: jt(e.transform.mProps.r)
        },
        skew: {
          get: jt(e.transform.mProps.sk)
        },
        skewAxis: {
          get: jt(e.transform.mProps.sa)
        },
        _name: {
          value: t.nm
        }
      }), s.ty = "tr", s.mn = t.mn, s.propertyGroup = i, s;
    }

    function h(t, e, i) {
      function s(e) {
        return t.p.ix === e ? s.position : t.s.ix === e ? s.size : null;
      }

      var r = Bt(s, i);
      s.propertyIndex = t.ix;
      var a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
      return a.s.setGroupProperty(Gt("Size", r)), a.p.setGroupProperty(Gt("Position", r)), Object.defineProperties(s, {
        size: {
          get: jt(a.s)
        },
        position: {
          get: jt(a.p)
        },
        _name: {
          value: t.nm
        }
      }), s.mn = t.mn, s;
    }

    function p(t, e, i) {
      function s(e) {
        return t.p.ix === e ? s.position : t.r.ix === e ? s.rotation : t.pt.ix === e ? s.points : t.or.ix === e || "ADBE Vector Star Outer Radius" === e ? s.outerRadius : t.os.ix === e ? s.outerRoundness : !t.ir || t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e ? t.is && t.is.ix === e ? s.innerRoundness : null : s.innerRadius;
      }

      var r = Bt(s, i),
          a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
      return s.propertyIndex = t.ix, a.or.setGroupProperty(Gt("Outer Radius", r)), a.os.setGroupProperty(Gt("Outer Roundness", r)), a.pt.setGroupProperty(Gt("Points", r)), a.p.setGroupProperty(Gt("Position", r)), a.r.setGroupProperty(Gt("Rotation", r)), t.ir && (a.ir.setGroupProperty(Gt("Inner Radius", r)), a.is.setGroupProperty(Gt("Inner Roundness", r))), Object.defineProperties(s, {
        position: {
          get: jt(a.p)
        },
        rotation: {
          get: jt(a.r)
        },
        points: {
          get: jt(a.pt)
        },
        outerRadius: {
          get: jt(a.or)
        },
        outerRoundness: {
          get: jt(a.os)
        },
        innerRadius: {
          get: jt(a.ir)
        },
        innerRoundness: {
          get: jt(a.is)
        },
        _name: {
          value: t.nm
        }
      }), s.mn = t.mn, s;
    }

    function l(t, e, i) {
      function s(e) {
        return t.p.ix === e ? s.position : t.r.ix === e ? s.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? s.size : null;
      }

      var r = Bt(s, i),
          a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
      return s.propertyIndex = t.ix, a.p.setGroupProperty(Gt("Position", r)), a.s.setGroupProperty(Gt("Size", r)), a.r.setGroupProperty(Gt("Rotation", r)), Object.defineProperties(s, {
        position: {
          get: jt(a.p)
        },
        roundness: {
          get: jt(a.r)
        },
        size: {
          get: jt(a.s)
        },
        _name: {
          value: t.nm
        }
      }), s.mn = t.mn, s;
    }

    function f(t, e, i) {
      function s(e) {
        return t.r.ix === e || "Round Corners 1" === e ? s.radius : null;
      }

      var r = Bt(s, i),
          a = e;
      return s.propertyIndex = t.ix, a.rd.setGroupProperty(Gt("Radius", r)), Object.defineProperties(s, {
        radius: {
          get: jt(a.rd)
        },
        _name: {
          value: t.nm
        }
      }), s.mn = t.mn, s;
    }

    function c(t, e, i) {
      function s(e) {
        return t.c.ix === e || "Copies" === e ? s.copies : t.o.ix === e || "Offset" === e ? s.offset : null;
      }

      var r = Bt(s, i),
          a = e;
      return s.propertyIndex = t.ix, a.c.setGroupProperty(Gt("Copies", r)), a.o.setGroupProperty(Gt("Offset", r)), Object.defineProperties(s, {
        copies: {
          get: jt(a.c)
        },
        offset: {
          get: jt(a.o)
        },
        _name: {
          value: t.nm
        }
      }), s.mn = t.mn, s;
    }

    return function (e, i, s) {
      var r;

      function a(t) {
        if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? s : r[t - 1];

        for (var e = 0, i = r.length; e < i;) {
          if (r[e]._name === t) return r[e];
          e += 1;
        }

        return null;
      }

      return a.propertyGroup = Bt(a, function () {
        return s;
      }), r = t(e, i, a.propertyGroup), a.numProperties = r.length, a._name = "Contents", a;
    };
  }(),
      Ht = function Ht(t) {
    var e, i;

    function s(t) {
      return "ADBE Text Document" === t ? s.sourceText : null;
    }

    return Object.defineProperty(s, "sourceText", {
      get: function get() {
        t.textProperty.getValue();
        var s = t.textProperty.currentData.t;
        return s !== e && (t.textProperty.currentData.t = e, (i = new String(s)).value = s || new String(s)), i;
      }
    }), s;
  },
      Xt = (Rt = {
    0: "source-over",
    1: "multiply",
    2: "screen",
    3: "overlay",
    4: "darken",
    5: "lighten",
    6: "color-dodge",
    7: "color-burn",
    8: "hard-light",
    9: "soft-light",
    10: "difference",
    11: "exclusion",
    12: "hue",
    13: "saturation",
    14: "color",
    15: "luminosity"
  }, function (t) {
    return Rt[t] || "";
  });

  function Ut(t, e, i) {
    this.p = at.getProp(e, t.v, 0, 0, i);
  }

  function Jt(t, e, i) {
    this.p = at.getProp(e, t.v, 0, 0, i);
  }

  function Kt(t, e, i) {
    this.p = at.getProp(e, t.v, 1, 0, i);
  }

  function Zt(t, e, i) {
    this.p = at.getProp(e, t.v, 1, 0, i);
  }

  function Qt(t, e, i) {
    this.p = at.getProp(e, t.v, 0, 0, i);
  }

  function te(t, e, i) {
    this.p = at.getProp(e, t.v, 0, 0, i);
  }

  function ee(t, e, i) {
    this.p = at.getProp(e, t.v, 0, 0, i);
  }

  function ie() {
    this.p = {};
  }

  function se(t, e) {
    var i,
        s = t.ef || [];
    this.effectElements = [];
    var r,
        a = s.length;

    for (i = 0; i < a; i += 1) {
      r = new re(s[i], e), this.effectElements.push(r);
    }
  }

  function re(t, e) {
    this.init(t, e);
  }

  function ae() {}

  function ne() {}

  function oe(t) {
    return oe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, oe(t);
  }

  a([nt], re), re.prototype.getValue = re.prototype.iterateDynamicProperties, re.prototype.init = function (t, e) {
    var i;
    this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(e);
    var s,
        r = this.data.ef.length,
        a = this.data.ef;

    for (i = 0; i < r; i += 1) {
      switch (s = null, a[i].ty) {
        case 0:
          s = new Ut(a[i], e, this);
          break;

        case 1:
          s = new Jt(a[i], e, this);
          break;

        case 2:
          s = new Kt(a[i], e, this);
          break;

        case 3:
          s = new Zt(a[i], e, this);
          break;

        case 4:
        case 7:
          s = new ee(a[i], e, this);
          break;

        case 10:
          s = new Qt(a[i], e, this);
          break;

        case 11:
          s = new te(a[i], e, this);
          break;

        case 5:
          s = new se(a[i], e, this);
          break;

        default:
          s = new ie(a[i], e, this);
      }

      s && this.effectElements.push(s);
    }
  }, ae.prototype = {
    checkMasks: function checkMasks() {
      if (!this.data.hasMask) return !1;

      for (var t = 0, e = this.data.masksProperties.length; t < e;) {
        if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
        t += 1;
      }

      return !1;
    },
    initExpressions: function initExpressions() {
      this.layerInterface = Nt(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
      var t = qt.createEffectsInterface(this, this.layerInterface);
      this.layerInterface.registerEffectsInterface(t), 0 === this.data.ty || this.data.xt ? this.compInterface = Wt(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = Yt(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = Ht(this), this.layerInterface.text = this.layerInterface.textInterface);
    },
    setBlendMode: function setBlendMode() {
      var t = Xt(this.data.bm);
      (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
    },
    initBaseData: function initBaseData(t, e, i) {
      this.globalData = e, this.comp = i, this.data = t, this.layerId = M(), this.data.sr || (this.data.sr = 1), this.effectsManager = new se(this.data, this, this.dynamicProperties);
    },
    getType: function getType() {
      return this.type;
    },
    sourceRectAtTime: function sourceRectAtTime() {}
  }, ne.prototype = {
    initFrame: function initFrame() {
      this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
    },
    prepareProperties: function prepareProperties(t, e) {
      var i,
          s = this.dynamicProperties.length;

      for (i = 0; i < s; i += 1) {
        (e || this._isParent && "transform" === this.dynamicProperties[i].propType) && (this.dynamicProperties[i].getValue(), this.dynamicProperties[i]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      }
    },
    addDynamicProperty: function addDynamicProperty(t) {
      -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
    }
  };
  var he,
      pe = (he = function he(t) {
    function e(t) {
      return "Outline" === t ? e.outlineInterface() : null;
    }

    return e._name = "Outline", e.outlineInterface = function (t) {
      var e = "",
          i = t.getFootageData();

      function s(t) {
        if (i[t]) return e = t, "object" === oe(i = i[t]) ? s : i;
        var r = t.indexOf(e);

        if (-1 !== r) {
          var a = parseInt(t.substr(r + e.length), 10);
          return "object" === oe(i = i[a]) ? s : i;
        }

        return "";
      }

      return function () {
        return e = "", i = t.getFootageData(), s;
      };
    }(t), e;
  }, function (t) {
    function e(t) {
      return "Data" === t ? e.dataInterface : null;
    }

    return e._name = "Data", e.dataInterface = he(t), e;
  });

  function le(t, e, i) {
    this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.footageData = e.imageLoader.getAsset(this.assetData), this.initBaseData(t, e, i);
  }

  function fe(t, e, i) {
    this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, i), this._isPlaying = !1, this._canPlay = !1;
    var s = this.globalData.getAssetsPath(this.assetData);
    this.audio = this.globalData.audioController.createAudio(s), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? at.getProp(this, t.tm, 0, e.frameRate, this) : {
      _placeholder: !0
    }, this.lv = at.getProp(this, t.au && t.au.lv ? t.au.lv : {
      k: [100]
    }, 1, .01, this);
  }

  function ce() {}

  function ue() {}

  function me(t, e, i) {
    this.data = t, this.element = e, this.globalData = i, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
    var r,
        a,
        n = this.globalData.defs,
        o = this.masksProperties ? this.masksProperties.length : 0;
    this.viewData = l(o), this.solidPath = "";
    var h,
        p,
        f,
        c,
        u,
        m,
        d = this.masksProperties,
        g = 0,
        y = [],
        v = M(),
        b = "clipPath",
        _ = "clip-path";

    for (r = 0; r < o; r += 1) {
      if (("a" !== d[r].mode && "n" !== d[r].mode || d[r].inv || 100 !== d[r].o.k || d[r].o.x) && (b = "mask", _ = "mask"), "s" !== d[r].mode && "i" !== d[r].mode || 0 !== g ? f = null : ((f = B("rect")).setAttribute("fill", "#ffffff"), f.setAttribute("width", this.element.comp.data.w || 0), f.setAttribute("height", this.element.comp.data.h || 0), y.push(f)), a = B("path"), "n" === d[r].mode) this.viewData[r] = {
        op: at.getProp(this.element, d[r].o, 0, .01, this.element),
        prop: yt.getShapeProp(this.element, d[r], 3),
        elem: a,
        lastPath: ""
      }, n.appendChild(a);else {
        var P;

        if (g += 1, a.setAttribute("fill", "s" === d[r].mode ? "#000000" : "#ffffff"), a.setAttribute("clip-rule", "nonzero"), 0 !== d[r].x.k ? (b = "mask", _ = "mask", m = at.getProp(this.element, d[r].x, 0, null, this.element), P = M(), (c = B("filter")).setAttribute("id", P), (u = B("feMorphology")).setAttribute("operator", "erode"), u.setAttribute("in", "SourceGraphic"), u.setAttribute("radius", "0"), c.appendChild(u), n.appendChild(c), a.setAttribute("stroke", "s" === d[r].mode ? "#000000" : "#ffffff")) : (u = null, m = null), this.storedData[r] = {
          elem: a,
          x: m,
          expan: u,
          lastPath: "",
          lastOperator: "",
          filterId: P,
          lastRadius: 0
        }, "i" === d[r].mode) {
          p = y.length;
          var k = B("g");

          for (h = 0; h < p; h += 1) {
            k.appendChild(y[h]);
          }

          var S = B("mask");
          S.setAttribute("mask-type", "alpha"), S.setAttribute("id", v + "_" + g), S.appendChild(a), n.appendChild(S), k.setAttribute("mask", "url(" + s() + "#" + v + "_" + g + ")"), y.length = 0, y.push(k);
        } else y.push(a);

        d[r].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[r] = {
          elem: a,
          lastPath: "",
          op: at.getProp(this.element, d[r].o, 0, .01, this.element),
          prop: yt.getShapeProp(this.element, d[r], 3),
          invRect: f
        }, this.viewData[r].prop.k || this.drawPath(d[r], this.viewData[r].prop.v, this.viewData[r]);
      }
    }

    for (this.maskElement = B(b), o = y.length, r = 0; r < o; r += 1) {
      this.maskElement.appendChild(y[r]);
    }

    g > 0 && (this.maskElement.setAttribute("id", v), this.element.maskedElement.setAttribute(_, "url(" + s() + "#" + v + ")"), n.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
  }

  le.prototype.prepareFrame = function () {}, a([Ot, ae, ne], le), le.prototype.getBaseElement = function () {
    return null;
  }, le.prototype.renderFrame = function () {}, le.prototype.destroy = function () {}, le.prototype.initExpressions = function () {
    this.layerInterface = pe(this);
  }, le.prototype.getFootageData = function () {
    return this.footageData;
  }, fe.prototype.prepareFrame = function (t) {
    if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;else {
      var e = this.tm.v;
      this._currentTime = e;
    }
    this._volume = this.lv.v[0];
    var i = this._volume * this._volumeMultiplier;
    this._previousVolume !== i && (this._previousVolume = i, this.audio.volume(i));
  }, a([Ot, ae, ne], fe), fe.prototype.renderFrame = function () {
    this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
  }, fe.prototype.show = function () {}, fe.prototype.hide = function () {
    this.audio.pause(), this._isPlaying = !1;
  }, fe.prototype.pause = function () {
    this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
  }, fe.prototype.resume = function () {
    this._canPlay = !0;
  }, fe.prototype.setRate = function (t) {
    this.audio.rate(t);
  }, fe.prototype.volume = function (t) {
    this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
  }, fe.prototype.getBaseElement = function () {
    return null;
  }, fe.prototype.destroy = function () {}, fe.prototype.sourceRectAtTime = function () {}, fe.prototype.initExpressions = function () {}, ce.prototype.checkLayers = function (t) {
    var e,
        i,
        s = this.layers.length;

    for (this.completeLayers = !0, e = s - 1; e >= 0; e -= 1) {
      this.elements[e] || (i = this.layers[e]).ip - i.st <= t - this.layers[e].st && i.op - i.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
    }

    this.checkPendingElements();
  }, ce.prototype.createItem = function (t) {
    switch (t.ty) {
      case 2:
        return this.createImage(t);

      case 0:
        return this.createComp(t);

      case 1:
        return this.createSolid(t);

      case 3:
      default:
        return this.createNull(t);

      case 4:
        return this.createShape(t);

      case 5:
        return this.createText(t);

      case 6:
        return this.createAudio(t);

      case 13:
        return this.createCamera(t);

      case 15:
        return this.createFootage(t);
    }
  }, ce.prototype.createCamera = function () {
    throw new Error("You're using a 3d camera. Try the html renderer.");
  }, ce.prototype.createAudio = function (t) {
    return new fe(t, this.globalData, this);
  }, ce.prototype.createFootage = function (t) {
    return new le(t, this.globalData, this);
  }, ce.prototype.buildAllItems = function () {
    var t,
        e = this.layers.length;

    for (t = 0; t < e; t += 1) {
      this.buildItem(t);
    }

    this.checkPendingElements();
  }, ce.prototype.includeLayers = function (t) {
    var e;
    this.completeLayers = !1;
    var i,
        s = t.length,
        r = this.layers.length;

    for (e = 0; e < s; e += 1) {
      for (i = 0; i < r;) {
        if (this.layers[i].id === t[e].id) {
          this.layers[i] = t[e];
          break;
        }

        i += 1;
      }
    }
  }, ce.prototype.setProjectInterface = function (t) {
    this.globalData.projectInterface = t;
  }, ce.prototype.initItems = function () {
    this.globalData.progressiveLoad || this.buildAllItems();
  }, ce.prototype.buildElementParenting = function (t, e, i) {
    for (var s = this.elements, r = this.layers, a = 0, n = r.length; a < n;) {
      r[a].ind == e && (s[a] && !0 !== s[a] ? (i.push(s[a]), s[a].setAsParent(), void 0 !== r[a].parent ? this.buildElementParenting(t, r[a].parent, i) : t.setHierarchy(i)) : (this.buildItem(a), this.addPendingElement(t))), a += 1;
    }
  }, ce.prototype.addPendingElement = function (t) {
    this.pendingElements.push(t);
  }, ce.prototype.searchExtraCompositions = function (t) {
    var e,
        i = t.length;

    for (e = 0; e < i; e += 1) {
      if (t[e].xt) {
        var s = this.createComp(t[e]);
        s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
      }
    }
  }, ce.prototype.getElementByPath = function (t) {
    var e,
        i = t.shift();
    if ("number" == typeof i) e = this.elements[i];else {
      var s,
          r = this.elements.length;

      for (s = 0; s < r; s += 1) {
        if (this.elements[s].data.nm === i) {
          e = this.elements[s];
          break;
        }
      }
    }
    return 0 === t.length ? e : e.getElementByPath(t);
  }, ce.prototype.setupGlobalData = function (t, e) {
    this.globalData.fontManager = new Lt(), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
      w: t.w,
      h: t.h
    };
  }, ue.prototype = {
    initTransform: function initTransform() {
      this.finalTransform = {
        mProp: this.data.ks ? Tt.getTransformProperty(this, this.data.ks, this) : {
          o: 0
        },
        _matMdf: !1,
        _opMdf: !1,
        mat: new vt()
      }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
    },
    renderTransform: function renderTransform() {
      if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
        var t,
            e = this.finalTransform.mat,
            i = 0,
            s = this.hierarchy.length;
        if (!this.finalTransform._matMdf) for (; i < s;) {
          if (this.hierarchy[i].finalTransform.mProp._mdf) {
            this.finalTransform._matMdf = !0;
            break;
          }

          i += 1;
        }
        if (this.finalTransform._matMdf) for (t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), i = 0; i < s; i += 1) {
          t = this.hierarchy[i].finalTransform.mProp.v.props, e.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
        }
      }
    },
    globalToLocal: function globalToLocal(t) {
      var e = [];
      e.push(this.finalTransform);

      for (var i, s = !0, r = this.comp; s;) {
        r.finalTransform ? (r.data.hasMask && e.splice(0, 0, r.finalTransform), r = r.comp) : s = !1;
      }

      var a,
          n = e.length;

      for (i = 0; i < n; i += 1) {
        a = e[i].mat.applyToPointArray(0, 0, 0), t = [t[0] - a[0], t[1] - a[1], 0];
      }

      return t;
    },
    mHelper: new vt()
  }, me.prototype.getMaskProperty = function (t) {
    return this.viewData[t].prop;
  }, me.prototype.renderFrame = function (t) {
    var e,
        i = this.element.finalTransform.mat,
        r = this.masksProperties.length;

    for (e = 0; e < r; e += 1) {
      if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", i.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
        var a = this.storedData[e].expan;
        this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + s() + "#" + this.storedData[e].filterId + ")")), a.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
      }
    }
  }, me.prototype.getMaskelement = function () {
    return this.maskElement;
  }, me.prototype.createLayerSolidPath = function () {
    var t = "M0,0 ";
    return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, (t += " h-" + this.globalData.compSize.w) + " v-" + this.globalData.compSize.h + " ";
  }, me.prototype.drawPath = function (t, e, i) {
    var s,
        r,
        a = " M" + e.v[0][0] + "," + e.v[0][1];

    for (r = e._length, s = 1; s < r; s += 1) {
      a += " C" + e.o[s - 1][0] + "," + e.o[s - 1][1] + " " + e.i[s][0] + "," + e.i[s][1] + " " + e.v[s][0] + "," + e.v[s][1];
    }

    if (e.c && r > 1 && (a += " C" + e.o[s - 1][0] + "," + e.o[s - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), i.lastPath !== a) {
      var n = "";
      i.elem && (e.c && (n = t.inv ? this.solidPath + a : a), i.elem.setAttribute("d", n)), i.lastPath = a;
    }
  }, me.prototype.destroy = function () {
    this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
  };

  var de = function () {
    var t = {
      createFilter: function createFilter(t, e) {
        var i = B("filter");
        return i.setAttribute("id", t), !0 !== e && (i.setAttribute("filterUnits", "objectBoundingBox"), i.setAttribute("x", "0%"), i.setAttribute("y", "0%"), i.setAttribute("width", "100%"), i.setAttribute("height", "100%")), i;
      },
      createAlphaToLuminanceFilter: function createAlphaToLuminanceFilter() {
        var t = B("feColorMatrix");
        return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
      }
    };
    return t;
  }(),
      ge = function () {
    var t = {
      maskType: !0
    };
    return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), t;
  }(),
      ye = {},
      ve = "filter_result_";

  function be(t) {
    var e,
        i,
        r = "SourceGraphic",
        a = t.data.ef ? t.data.ef.length : 0,
        n = M(),
        o = de.createFilter(n, !0),
        h = 0;

    for (this.filters = [], e = 0; e < a; e += 1) {
      i = null;
      var p = t.data.ef[e].ty;
      ye[p] && (i = new ye[p].effect(o, t.effectsManager.effectElements[e], t, ve + h, r), r = ve + h, ye[p].countsAsEffect && (h += 1)), i && this.filters.push(i);
    }

    h && (t.globalData.defs.appendChild(o), t.layerElement.setAttribute("filter", "url(" + s() + "#" + n + ")")), this.filters.length && t.addRenderableComponent(this);
  }

  function _e() {}

  function Pe() {}

  function ke() {}

  function Se(t, e, i) {
    this.assetData = e.getAssetData(t.refId), this.initElement(t, e, i), this.sourceRect = {
      top: 0,
      left: 0,
      width: this.assetData.w,
      height: this.assetData.h
    };
  }

  function xe(t, e) {
    this.elem = t, this.pos = e;
  }

  function Ae() {}

  be.prototype.renderFrame = function (t) {
    var e,
        i = this.filters.length;

    for (e = 0; e < i; e += 1) {
      this.filters[e].renderFrame(t);
    }
  }, _e.prototype = {
    initRendererElement: function initRendererElement() {
      this.layerElement = B("g");
    },
    createContainerElements: function createContainerElements() {
      this.matteElement = B("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
      var t,
          e,
          i,
          r = null;

      if (this.data.td) {
        if (3 == this.data.td || 1 == this.data.td) {
          var a = B("mask");
          a.setAttribute("id", this.layerId), a.setAttribute("mask-type", 3 == this.data.td ? "luminance" : "alpha"), a.appendChild(this.layerElement), r = a, this.globalData.defs.appendChild(a), ge.maskType || 1 != this.data.td || (a.setAttribute("mask-type", "luminance"), t = M(), e = de.createFilter(t), this.globalData.defs.appendChild(e), e.appendChild(de.createAlphaToLuminanceFilter()), (i = B("g")).appendChild(this.layerElement), r = i, a.appendChild(i), i.setAttribute("filter", "url(" + s() + "#" + t + ")"));
        } else if (2 == this.data.td) {
          var n = B("mask");
          n.setAttribute("id", this.layerId), n.setAttribute("mask-type", "alpha");
          var o = B("g");
          n.appendChild(o), t = M(), e = de.createFilter(t);
          var h = B("feComponentTransfer");
          h.setAttribute("in", "SourceGraphic"), e.appendChild(h);
          var p = B("feFuncA");
          p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), h.appendChild(p), this.globalData.defs.appendChild(e);
          var l = B("rect");
          l.setAttribute("width", this.comp.data.w), l.setAttribute("height", this.comp.data.h), l.setAttribute("x", "0"), l.setAttribute("y", "0"), l.setAttribute("fill", "#ffffff"), l.setAttribute("opacity", "0"), o.setAttribute("filter", "url(" + s() + "#" + t + ")"), o.appendChild(l), o.appendChild(this.layerElement), r = o, ge.maskType || (n.setAttribute("mask-type", "luminance"), e.appendChild(de.createAlphaToLuminanceFilter()), i = B("g"), o.appendChild(l), i.appendChild(this.layerElement), r = i, o.appendChild(i)), this.globalData.defs.appendChild(n);
        }
      } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), r = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;

      if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
        var f = B("clipPath"),
            c = B("path");
        c.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
        var u = M();

        if (f.setAttribute("id", u), f.appendChild(c), this.globalData.defs.appendChild(f), this.checkMasks()) {
          var m = B("g");
          m.setAttribute("clip-path", "url(" + s() + "#" + u + ")"), m.appendChild(this.layerElement), this.transformedElement = m, r ? r.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
        } else this.layerElement.setAttribute("clip-path", "url(" + s() + "#" + u + ")");
      }

      0 !== this.data.bm && this.setBlendMode();
    },
    renderElement: function renderElement() {
      this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
    },
    destroyBaseElement: function destroyBaseElement() {
      this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
    },
    getBaseElement: function getBaseElement() {
      return this.data.hd ? null : this.baseElement;
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new me(this.data, this, this.globalData), this.renderableEffectsManager = new be(this);
    },
    setMatte: function setMatte(t) {
      this.matteElement && this.matteElement.setAttribute("mask", "url(" + s() + "#" + t + ")");
    }
  }, Pe.prototype = {
    initHierarchy: function initHierarchy() {
      this.hierarchy = [], this._isParent = !1, this.checkParenting();
    },
    setHierarchy: function setHierarchy(t) {
      this.hierarchy = t;
    },
    setAsParent: function setAsParent() {
      this._isParent = !0;
    },
    checkParenting: function checkParenting() {
      void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
    }
  }, a([Ot, o({
    initElement: function initElement(t, e, i) {
      this.initFrame(), this.initBaseData(t, e, i), this.initTransform(t, e, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
    },
    hide: function hide() {
      this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
    },
    show: function show() {
      this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
    },
    renderFrame: function renderFrame() {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    },
    renderInnerContent: function renderInnerContent() {},
    prepareFrame: function prepareFrame(t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
    },
    destroy: function destroy() {
      this.innerElem = null, this.destroyBaseElement();
    }
  })], ke), a([ae, ue, _e, Pe, ne, ke], Se), Se.prototype.createContent = function () {
    var t = this.globalData.getAssetsPath(this.assetData);
    this.innerElem = B("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
  }, Se.prototype.sourceRectAtTime = function () {
    return this.sourceRect;
  }, Ae.prototype = {
    addShapeToModifiers: function addShapeToModifiers(t) {
      var e,
          i = this.shapeModifiers.length;

      for (e = 0; e < i; e += 1) {
        this.shapeModifiers[e].addShape(t);
      }
    },
    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(t) {
      for (var e = this.shapeModifiers.length; 0 < e;) {
        if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
      }

      return !1;
    },
    renderModifiers: function renderModifiers() {
      if (this.shapeModifiers.length) {
        var t,
            e = this.shapes.length;

        for (t = 0; t < e; t += 1) {
          this.shapes[t].sh.reset();
        }

        for (t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1) {
          ;
        }
      }
    },
    searchProcessedElement: function searchProcessedElement(t) {
      for (var e = this.processedElements, i = 0, s = e.length; i < s;) {
        if (e[i].elem === t) return e[i].pos;
        i += 1;
      }

      return 0;
    },
    addProcessedElement: function addProcessedElement(t, e) {
      for (var i = this.processedElements, s = i.length; s;) {
        if (i[s -= 1].elem === t) return void (i[s].pos = e);
      }

      i.push(new xe(t, e));
    },
    prepareFrame: function prepareFrame(t) {
      this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
    }
  };
  var we = {
    1: "butt",
    2: "round",
    3: "square"
  },
      De = {
    1: "miter",
    2: "round",
    3: "bevel"
  };

  function Ce(t, e, i) {
    this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = i, this.lvl = e, this._isAnimated = !!i.k;

    for (var s = 0, r = t.length; s < r;) {
      if (t[s].mProps.dynamicProperties.length) {
        this._isAnimated = !0;
        break;
      }

      s += 1;
    }
  }

  function Ee(t, e) {
    this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = B("path"), this.msElem = null;
  }

  function Te(t, e, i, s) {
    var r;
    this.elem = t, this.frameId = -1, this.dataProps = l(e.length), this.renderer = i, this.k = !1, this.dashStr = "", this.dashArray = p("float32", e.length ? e.length - 1 : 0), this.dashoffset = p("float32", 1), this.initDynamicPropertyContainer(s);
    var a,
        n = e.length || 0;

    for (r = 0; r < n; r += 1) {
      a = at.getProp(t, e[r].v, 0, 0, this), this.k = a.k || this.k, this.dataProps[r] = {
        n: e[r].n,
        p: a
      };
    }

    this.k || this.getValue(!0), this._isAnimated = this.k;
  }

  function Fe(t, e, i) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = at.getProp(t, e.o, 0, .01, this), this.w = at.getProp(t, e.w, 0, null, this), this.d = new Te(t, e.d || {}, "svg", this), this.c = at.getProp(t, e.c, 1, 255, this), this.style = i, this._isAnimated = !!this._isAnimated;
  }

  function Me(t, e, i) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = at.getProp(t, e.o, 0, .01, this), this.c = at.getProp(t, e.c, 1, 255, this), this.style = i;
  }

  function Ie(t, e, i) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = i;
  }

  function Le(t, e, i) {
    this.data = e, this.c = p("uint8c", 4 * e.p);
    var s = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
    this.o = p("float32", s), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = s, this.initDynamicPropertyContainer(i), this.prop = at.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
  }

  function Oe(t, e, i) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, i);
  }

  function Re(t, e, i) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = at.getProp(t, e.w, 0, null, this), this.d = new Te(t, e.d || {}, "svg", this), this.initGradientData(t, e, i), this._isAnimated = !!this._isAnimated;
  }

  function Ve() {
    this.it = [], this.prevViewData = [], this.gr = B("g");
  }

  function je(t, e, i) {
    this.transform = {
      mProps: t,
      op: e,
      container: i
    }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
  }

  Ce.prototype.setAsAnimated = function () {
    this._isAnimated = !0;
  }, Ee.prototype.reset = function () {
    this.d = "", this._mdf = !1;
  }, Te.prototype.getValue = function (t) {
    if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
      var e = 0,
          i = this.dataProps.length;

      for ("svg" === this.renderer && (this.dashStr = ""), e = 0; e < i; e += 1) {
        "o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
      }
    }
  }, a([nt], Te), a([nt], Fe), a([nt], Me), a([nt], Ie), Le.prototype.comparePoints = function (t, e) {
    for (var i = 0, s = this.o.length / 2; i < s;) {
      if (Math.abs(t[4 * i] - t[4 * e + 2 * i]) > .01) return !1;
      i += 1;
    }

    return !0;
  }, Le.prototype.checkCollapsable = function () {
    if (this.o.length / 2 != this.c.length / 4) return !1;
    if (this.data.k.k[0].s) for (var t = 0, e = this.data.k.k.length; t < e;) {
      if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
      t += 1;
    } else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
    return !0;
  }, Le.prototype.getValue = function (t) {
    if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
      var e,
          i,
          s,
          r = 4 * this.data.p;

      for (e = 0; e < r; e += 1) {
        i = e % 4 == 0 ? 100 : 255, s = Math.round(this.prop.v[e] * i), this.c[e] !== s && (this.c[e] = s, this._cmdf = !t);
      }

      if (this.o.length) for (r = this.prop.v.length, e = 4 * this.data.p; e < r; e += 1) {
        i = e % 2 == 0 ? 100 : 1, s = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== s && (this.o[e - 4 * this.data.p] = s, this._omdf = !t);
      }
      this._mdf = !t;
    }
  }, a([nt], Le), Oe.prototype.initGradientData = function (t, e, i) {
    this.o = at.getProp(t, e.o, 0, .01, this), this.s = at.getProp(t, e.s, 1, null, this), this.e = at.getProp(t, e.e, 1, null, this), this.h = at.getProp(t, e.h || {
      k: 0
    }, 0, .01, this), this.a = at.getProp(t, e.a || {
      k: 0
    }, 0, k, this), this.g = new Le(t, e.g, this), this.style = i, this.stops = [], this.setGradientData(i.pElem, e), this.setGradientOpacity(e, i), this._isAnimated = !!this._isAnimated;
  }, Oe.prototype.setGradientData = function (t, e) {
    var i = M(),
        r = B(1 === e.t ? "linearGradient" : "radialGradient");
    r.setAttribute("id", i), r.setAttribute("spreadMethod", "pad"), r.setAttribute("gradientUnits", "userSpaceOnUse");
    var a,
        n,
        o,
        h = [];

    for (o = 4 * e.g.p, n = 0; n < o; n += 4) {
      a = B("stop"), r.appendChild(a), h.push(a);
    }

    t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + s() + "#" + i + ")"), this.gf = r, this.cst = h;
  }, Oe.prototype.setGradientOpacity = function (t, e) {
    if (this.g._hasOpacity && !this.g._collapsable) {
      var i,
          r,
          a,
          n = B("mask"),
          o = B("path");
      n.appendChild(o);
      var h = M(),
          p = M();
      n.setAttribute("id", p);
      var l = B(1 === t.t ? "linearGradient" : "radialGradient");
      l.setAttribute("id", h), l.setAttribute("spreadMethod", "pad"), l.setAttribute("gradientUnits", "userSpaceOnUse"), a = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
      var f = this.stops;

      for (r = 4 * t.g.p; r < a; r += 2) {
        (i = B("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l.appendChild(i), f.push(i);
      }

      o.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + s() + "#" + h + ")"), "gs" === t.ty && (o.setAttribute("stroke-linecap", we[t.lc || 2]), o.setAttribute("stroke-linejoin", De[t.lj || 2]), 1 === t.lj && o.setAttribute("stroke-miterlimit", t.ml)), this.of = l, this.ms = n, this.ost = f, this.maskId = p, e.msElem = o;
    }
  }, a([nt], Oe), a([Oe, nt], Re);

  var ze = function ze(t, e, i, s) {
    if (0 === e) return "";
    var r,
        a = t.o,
        n = t.i,
        o = t.v,
        h = " M" + s.applyToPointStringified(o[0][0], o[0][1]);

    for (r = 1; r < e; r += 1) {
      h += " C" + s.applyToPointStringified(a[r - 1][0], a[r - 1][1]) + " " + s.applyToPointStringified(n[r][0], n[r][1]) + " " + s.applyToPointStringified(o[r][0], o[r][1]);
    }

    return i && e && (h += " C" + s.applyToPointStringified(a[r - 1][0], a[r - 1][1]) + " " + s.applyToPointStringified(n[0][0], n[0][1]) + " " + s.applyToPointStringified(o[0][0], o[0][1]), h += "z"), h;
  },
      Ne = function () {
    var t = new vt(),
        e = new vt();

    function i(t, e, i) {
      (i || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (i || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
    }

    function s() {}

    function r(i, s, r) {
      var a,
          n,
          o,
          h,
          p,
          l,
          f,
          c,
          u,
          m,
          d,
          g = s.styles.length,
          y = s.lvl;

      for (l = 0; l < g; l += 1) {
        if (h = s.sh._mdf || r, s.styles[l].lvl < y) {
          for (c = e.reset(), m = y - s.styles[l].lvl, d = s.transformers.length - 1; !h && m > 0;) {
            h = s.transformers[d].mProps._mdf || h, m -= 1, d -= 1;
          }

          if (h) for (m = y - s.styles[l].lvl, d = s.transformers.length - 1; m > 0;) {
            u = s.transformers[d].mProps.v.props, c.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]), m -= 1, d -= 1;
          }
        } else c = t;

        if (n = (f = s.sh.paths)._length, h) {
          for (o = "", a = 0; a < n; a += 1) {
            (p = f.shapes[a]) && p._length && (o += ze(p, p._length, p.c, c));
          }

          s.caches[l] = o;
        } else o = s.caches[l];

        s.styles[l].d += !0 === i.hd ? "" : o, s.styles[l]._mdf = h || s.styles[l]._mdf;
      }
    }

    function a(t, e, i) {
      var s = e.style;
      (e.c._mdf || i) && s.pElem.setAttribute("fill", "rgb(" + v(e.c.v[0]) + "," + v(e.c.v[1]) + "," + v(e.c.v[2]) + ")"), (e.o._mdf || i) && s.pElem.setAttribute("fill-opacity", e.o.v);
    }

    function n(t, e, i) {
      o(t, e, i), h(t, e, i);
    }

    function o(t, e, i) {
      var s,
          r,
          a,
          n,
          o,
          h = e.gf,
          p = e.g._hasOpacity,
          l = e.s.v,
          f = e.e.v;

      if (e.o._mdf || i) {
        var c = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
        e.style.pElem.setAttribute(c, e.o.v);
      }

      if (e.s._mdf || i) {
        var u = 1 === t.t ? "x1" : "cx",
            m = "x1" === u ? "y1" : "cy";
        h.setAttribute(u, l[0]), h.setAttribute(m, l[1]), p && !e.g._collapsable && (e.of.setAttribute(u, l[0]), e.of.setAttribute(m, l[1]));
      }

      if (e.g._cmdf || i) {
        s = e.cst;
        var d = e.g.c;

        for (a = s.length, r = 0; r < a; r += 1) {
          (n = s[r]).setAttribute("offset", d[4 * r] + "%"), n.setAttribute("stop-color", "rgb(" + d[4 * r + 1] + "," + d[4 * r + 2] + "," + d[4 * r + 3] + ")");
        }
      }

      if (p && (e.g._omdf || i)) {
        var g = e.g.o;

        for (a = (s = e.g._collapsable ? e.cst : e.ost).length, r = 0; r < a; r += 1) {
          n = s[r], e.g._collapsable || n.setAttribute("offset", g[2 * r] + "%"), n.setAttribute("stop-opacity", g[2 * r + 1]);
        }
      }

      if (1 === t.t) (e.e._mdf || i) && (h.setAttribute("x2", f[0]), h.setAttribute("y2", f[1]), p && !e.g._collapsable && (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));else if ((e.s._mdf || e.e._mdf || i) && (o = Math.sqrt(Math.pow(l[0] - f[0], 2) + Math.pow(l[1] - f[1], 2)), h.setAttribute("r", o), p && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || i) {
        o || (o = Math.sqrt(Math.pow(l[0] - f[0], 2) + Math.pow(l[1] - f[1], 2)));
        var y = Math.atan2(f[1] - l[1], f[0] - l[0]),
            v = e.h.v;
        v >= 1 ? v = .99 : v <= -1 && (v = -.99);

        var b = o * v,
            _ = Math.cos(y + e.a.v) * b + l[0],
            P = Math.sin(y + e.a.v) * b + l[1];

        h.setAttribute("fx", _), h.setAttribute("fy", P), p && !e.g._collapsable && (e.of.setAttribute("fx", _), e.of.setAttribute("fy", P));
      }
    }

    function h(t, e, i) {
      var s = e.style,
          r = e.d;
      r && (r._mdf || i) && r.dashStr && (s.pElem.setAttribute("stroke-dasharray", r.dashStr), s.pElem.setAttribute("stroke-dashoffset", r.dashoffset[0])), e.c && (e.c._mdf || i) && s.pElem.setAttribute("stroke", "rgb(" + v(e.c.v[0]) + "," + v(e.c.v[1]) + "," + v(e.c.v[2]) + ")"), (e.o._mdf || i) && s.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || i) && (s.pElem.setAttribute("stroke-width", e.w.v), s.msElem && s.msElem.setAttribute("stroke-width", e.w.v));
    }

    return {
      createRenderFunction: function createRenderFunction(t) {
        switch (t.ty) {
          case "fl":
            return a;

          case "gf":
            return o;

          case "gs":
            return n;

          case "st":
            return h;

          case "sh":
          case "el":
          case "rc":
          case "sr":
            return r;

          case "tr":
            return i;

          case "no":
            return s;

          default:
            return null;
        }
      }
    };
  }();

  function Be(t, e, i) {
    this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, i), this.prevViewData = [];
  }

  function Ge(t, e, i, s, r, a) {
    this.o = t, this.sw = e, this.sc = i, this.fc = s, this.m = r, this.p = a, this._mdf = {
      o: !0,
      sw: !!e,
      sc: !!i,
      fc: !!s,
      m: !0,
      p: !0
    };
  }

  function qe(t, e) {
    this._frameId = i, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
      ascent: 0,
      boxWidth: this.defaultBoxWidth,
      f: "",
      fStyle: "",
      fWeight: "",
      fc: "",
      j: "",
      justifyOffset: "",
      l: [],
      lh: 0,
      lineWidths: [],
      ls: "",
      of: "",
      s: "",
      sc: "",
      sw: 0,
      t: 0,
      tr: 0,
      sz: 0,
      ps: null,
      fillColorAnim: !1,
      strokeColorAnim: !1,
      strokeWidthAnim: !1,
      yOffset: 0,
      finalSize: 0,
      finalText: [],
      finalLineHeight: 0,
      __complete: !1
    }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
  }

  a([ae, ue, _e, Ae, Pe, ne, ke], Be), Be.prototype.initSecondaryElement = function () {}, Be.prototype.identityMatrix = new vt(), Be.prototype.buildExpressionInterface = function () {}, Be.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
  }, Be.prototype.filterUniqueShapes = function () {
    var t,
        e,
        i,
        s,
        r = this.shapes.length,
        a = this.stylesList.length,
        n = [],
        o = !1;

    for (i = 0; i < a; i += 1) {
      for (s = this.stylesList[i], o = !1, n.length = 0, t = 0; t < r; t += 1) {
        -1 !== (e = this.shapes[t]).styles.indexOf(s) && (n.push(e), o = e._isAnimated || o);
      }

      n.length > 1 && o && this.setShapesAsAnimated(n);
    }
  }, Be.prototype.setShapesAsAnimated = function (t) {
    var e,
        i = t.length;

    for (e = 0; e < i; e += 1) {
      t[e].setAsAnimated();
    }
  }, Be.prototype.createStyleElement = function (t, e) {
    var i,
        r = new Ee(t, e),
        a = r.pElem;
    return "st" === t.ty ? i = new Fe(this, t, r) : "fl" === t.ty ? i = new Me(this, t, r) : "gf" === t.ty || "gs" === t.ty ? (i = new ("gf" === t.ty ? Oe : Re)(this, t, r), this.globalData.defs.appendChild(i.gf), i.maskId && (this.globalData.defs.appendChild(i.ms), this.globalData.defs.appendChild(i.of), a.setAttribute("mask", "url(" + s() + "#" + i.maskId + ")"))) : "no" === t.ty && (i = new Ie(this, t, r)), "st" !== t.ty && "gs" !== t.ty || (a.setAttribute("stroke-linecap", we[t.lc || 2]), a.setAttribute("stroke-linejoin", De[t.lj || 2]), a.setAttribute("fill-opacity", "0"), 1 === t.lj && a.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && a.setAttribute("fill-rule", "evenodd"), t.ln && a.setAttribute("id", t.ln), t.cl && a.setAttribute("class", t.cl), t.bm && (a.style["mix-blend-mode"] = Xt(t.bm)), this.stylesList.push(r), this.addToAnimatedContents(t, i), i;
  }, Be.prototype.createGroupElement = function (t) {
    var e = new Ve();
    return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = Xt(t.bm)), e;
  }, Be.prototype.createTransformElement = function (t, e) {
    var i = Tt.getTransformProperty(this, t, this),
        s = new je(i, i.o, e);
    return this.addToAnimatedContents(t, s), s;
  }, Be.prototype.createShapeElement = function (t, e, i) {
    var s = 4;
    "rc" === t.ty ? s = 5 : "el" === t.ty ? s = 6 : "sr" === t.ty && (s = 7);
    var r = new Ce(e, i, yt.getShapeProp(this, t, s, this));
    return this.shapes.push(r), this.addShapeToModifiers(r), this.addToAnimatedContents(t, r), r;
  }, Be.prototype.addToAnimatedContents = function (t, e) {
    for (var i = 0, s = this.animatedContents.length; i < s;) {
      if (this.animatedContents[i].element === e) return;
      i += 1;
    }

    this.animatedContents.push({
      fn: Ne.createRenderFunction(t),
      element: e,
      data: t
    });
  }, Be.prototype.setElementStyles = function (t) {
    var e,
        i = t.styles,
        s = this.stylesList.length;

    for (e = 0; e < s; e += 1) {
      this.stylesList[e].closed || i.push(this.stylesList[e]);
    }
  }, Be.prototype.reloadShapes = function () {
    var t;
    this._isFirstFrame = !0;
    var e = this.itemsData.length;

    for (t = 0; t < e; t += 1) {
      this.prevViewData[t] = this.itemsData[t];
    }

    for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1) {
      this.dynamicProperties[t].getValue();
    }

    this.renderModifiers();
  }, Be.prototype.searchShapes = function (t, e, i, s, r, a, n) {
    var o,
        h,
        p,
        l,
        f,
        c,
        u = [].concat(a),
        m = t.length - 1,
        d = [],
        g = [];

    for (o = m; o >= 0; o -= 1) {
      if ((c = this.searchProcessedElement(t[o])) ? e[o] = i[c - 1] : t[o]._render = n, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) c ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], r), t[o]._render && e[o].style.pElem.parentNode !== s && s.appendChild(e[o].style.pElem), d.push(e[o].style);else if ("gr" === t[o].ty) {
        if (c) for (p = e[o].it.length, h = 0; h < p; h += 1) {
          e[o].prevViewData[h] = e[o].it[h];
        } else e[o] = this.createGroupElement(t[o]);
        this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, r + 1, u, n), t[o]._render && e[o].gr.parentNode !== s && s.appendChild(e[o].gr);
      } else "tr" === t[o].ty ? (c || (e[o] = this.createTransformElement(t[o], s)), l = e[o].transform, u.push(l)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (c || (e[o] = this.createShapeElement(t[o], u, r)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty ? (c ? (f = e[o]).closed = !1 : ((f = wt.getModifier(t[o].ty)).init(this, t[o]), e[o] = f, this.shapeModifiers.push(f)), g.push(f)) : "rp" === t[o].ty && (c ? (f = e[o]).closed = !0 : (f = wt.getModifier(t[o].ty), e[o] = f, f.init(this, t, o, e), this.shapeModifiers.push(f), n = !1), g.push(f));
      this.addProcessedElement(t[o], o + 1);
    }

    for (m = d.length, o = 0; o < m; o += 1) {
      d[o].closed = !0;
    }

    for (m = g.length, o = 0; o < m; o += 1) {
      g[o].closed = !0;
    }
  }, Be.prototype.renderInnerContent = function () {
    var t;
    this.renderModifiers();
    var e = this.stylesList.length;

    for (t = 0; t < e; t += 1) {
      this.stylesList[t].reset();
    }

    for (this.renderShape(), t = 0; t < e; t += 1) {
      (this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
    }
  }, Be.prototype.renderShape = function () {
    var t,
        e,
        i = this.animatedContents.length;

    for (t = 0; t < i; t += 1) {
      e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
    }
  }, Be.prototype.destroy = function () {
    this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
  }, Ge.prototype.update = function (t, e, i, s, r, a) {
    this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
    var n = !1;
    return this.o !== t && (this.o = t, this._mdf.o = !0, n = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, n = !0), this.sc !== i && (this.sc = i, this._mdf.sc = !0, n = !0), this.fc !== s && (this.fc = s, this._mdf.fc = !0, n = !0), this.m !== r && (this.m = r, this._mdf.m = !0, n = !0), !a.length || this.p[0] === a[0] && this.p[1] === a[1] && this.p[4] === a[4] && this.p[5] === a[5] && this.p[12] === a[12] && this.p[13] === a[13] || (this.p = a, this._mdf.p = !0, n = !0), n;
  }, qe.prototype.defaultBoxWidth = [0, 0], qe.prototype.copyData = function (t, e) {
    for (var i in e) {
      Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }

    return t;
  }, qe.prototype.setCurrentData = function (t) {
    t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
  }, qe.prototype.searchProperty = function () {
    return this.searchKeyframes();
  }, qe.prototype.searchKeyframes = function () {
    return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
  }, qe.prototype.addEffect = function (t) {
    this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
  }, qe.prototype.getValue = function (t) {
    if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
      this.currentData.t = this.data.d.k[this.keysIndex].s.t;
      var e = this.currentData,
          i = this.keysIndex;
      if (this.lock) this.setCurrentData(this.currentData);else {
        var s;
        this.lock = !0, this._mdf = !1;
        var r = this.effectsSequence.length,
            a = t || this.data.d.k[this.keysIndex].s;

        for (s = 0; s < r; s += 1) {
          a = i !== this.keysIndex ? this.effectsSequence[s](a, a.t) : this.effectsSequence[s](this.currentData, a.t);
        }

        e !== a && this.setCurrentData(a), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
  }, qe.prototype.getKeyframeValue = function () {
    for (var t = this.data.d.k, e = this.elem.comp.renderedFrame, i = 0, s = t.length; i <= s - 1 && !(i === s - 1 || t[i + 1].t > e);) {
      i += 1;
    }

    return this.keysIndex !== i && (this.keysIndex = i), this.data.d.k[this.keysIndex].s;
  }, qe.prototype.buildFinalText = function (t) {
    for (var e, i, s = [], r = 0, a = t.length, n = !1; r < a;) {
      e = t.charCodeAt(r), Lt.isCombinedCharacter(e) ? s[s.length - 1] += t.charAt(r) : e >= 55296 && e <= 56319 ? (i = t.charCodeAt(r + 1)) >= 56320 && i <= 57343 ? (n || Lt.isModifier(e, i) ? (s[s.length - 1] += t.substr(r, 2), n = !1) : s.push(t.substr(r, 2)), r += 1) : s.push(t.charAt(r)) : e > 56319 ? (i = t.charCodeAt(r + 1), Lt.isZeroWidthJoiner(e, i) ? (n = !0, s[s.length - 1] += t.substr(r, 2), r += 1) : s.push(t.charAt(r))) : Lt.isZeroWidthJoiner(e) ? (s[s.length - 1] += t.charAt(r), n = !0) : s.push(t.charAt(r)), r += 1;
    }

    return s;
  }, qe.prototype.completeTextData = function (t) {
    t.__complete = !0;
    var e,
        i,
        s,
        r,
        a,
        n,
        o,
        h = this.elem.globalData.fontManager,
        p = this.data,
        l = [],
        f = 0,
        c = p.m.g,
        u = 0,
        m = 0,
        d = 0,
        g = [],
        y = 0,
        v = 0,
        b = h.getFontByName(t.f),
        _ = 0,
        P = It(b);
    t.fWeight = P.weight, t.fStyle = P.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), i = t.finalText.length, t.finalLineHeight = t.lh;
    var k,
        S = t.tr / 1e3 * t.finalSize;
    if (t.sz) for (var x, A, w = !0, D = t.sz[0], C = t.sz[1]; w;) {
      x = 0, y = 0, i = (A = this.buildFinalText(t.t)).length, S = t.tr / 1e3 * t.finalSize;
      var E = -1;

      for (e = 0; e < i; e += 1) {
        k = A[e].charCodeAt(0), s = !1, " " === A[e] ? E = e : 13 !== k && 3 !== k || (y = 0, s = !0, x += t.finalLineHeight || 1.2 * t.finalSize), h.chars ? (o = h.getCharData(A[e], b.fStyle, b.fFamily), _ = s ? 0 : o.w * t.finalSize / 100) : _ = h.measureText(A[e], t.f, t.finalSize), y + _ > D && " " !== A[e] ? (-1 === E ? i += 1 : e = E, x += t.finalLineHeight || 1.2 * t.finalSize, A.splice(e, E === e ? 1 : 0, "\r"), E = -1, y = 0) : (y += _, y += S);
      }

      x += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && C < x ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = A, i = t.finalText.length, w = !1);
    }
    y = -S, _ = 0;
    var T,
        F = 0;

    for (e = 0; e < i; e += 1) {
      if (s = !1, 13 === (k = (T = t.finalText[e]).charCodeAt(0)) || 3 === k ? (F = 0, g.push(y), v = y > v ? y : v, y = -2 * S, r = "", s = !0, d += 1) : r = T, h.chars ? (o = h.getCharData(T, b.fStyle, h.getFontByName(t.f).fFamily), _ = s ? 0 : o.w * t.finalSize / 100) : _ = h.measureText(r, t.f, t.finalSize), " " === T ? F += _ + S : (y += _ + S + F, F = 0), l.push({
        l: _,
        an: _,
        add: u,
        n: s,
        anIndexes: [],
        val: r,
        line: d,
        animatorJustifyOffset: 0
      }), 2 == c) {
        if (u += _, "" === r || " " === r || e === i - 1) {
          for ("" !== r && " " !== r || (u -= _); m <= e;) {
            l[m].an = u, l[m].ind = f, l[m].extra = _, m += 1;
          }

          f += 1, u = 0;
        }
      } else if (3 == c) {
        if (u += _, "" === r || e === i - 1) {
          for ("" === r && (u -= _); m <= e;) {
            l[m].an = u, l[m].ind = f, l[m].extra = _, m += 1;
          }

          u = 0, f += 1;
        }
      } else l[f].ind = f, l[f].extra = 0, f += 1;
    }

    if (t.l = l, v = y > v ? y : v, g.push(y), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;else switch (t.boxWidth = v, t.j) {
      case 1:
        t.justifyOffset = -t.boxWidth;
        break;

      case 2:
        t.justifyOffset = -t.boxWidth / 2;
        break;

      default:
        t.justifyOffset = 0;
    }
    t.lineWidths = g;
    var M,
        I,
        L,
        O,
        R = p.a;
    n = R.length;
    var V = [];

    for (a = 0; a < n; a += 1) {
      for ((M = R[a]).a.sc && (t.strokeColorAnim = !0), M.a.sw && (t.strokeWidthAnim = !0), (M.a.fc || M.a.fh || M.a.fs || M.a.fb) && (t.fillColorAnim = !0), O = 0, L = M.s.b, e = 0; e < i; e += 1) {
        (I = l[e]).anIndexes[a] = O, (1 == L && "" !== I.val || 2 == L && "" !== I.val && " " !== I.val || 3 == L && (I.n || " " == I.val || e == i - 1) || 4 == L && (I.n || e == i - 1)) && (1 === M.s.rn && V.push(O), O += 1);
      }

      p.a[a].s.totalChars = O;
      var j,
          z = -1;
      if (1 === M.s.rn) for (e = 0; e < i; e += 1) {
        z != (I = l[e]).anIndexes[a] && (z = I.anIndexes[a], j = V.splice(Math.floor(Math.random() * V.length), 1)[0]), I.anIndexes[a] = j;
      }
    }

    t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
  }, qe.prototype.updateDocumentData = function (t, e) {
    e = void 0 === e ? this.keysIndex : e;
    var i = this.copyData({}, this.data.d.k[e].s);
    i = this.copyData(i, t), this.data.d.k[e].s = i, this.recalculate(e), this.elem.addDynamicProperty(this);
  }, qe.prototype.recalculate = function (t) {
    var e = this.data.d.k[t].s;
    e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
  }, qe.prototype.canResizeFont = function (t) {
    this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
  }, qe.prototype.setMinimumFontSize = function (t) {
    this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
  };

  var We = function () {
    var t = Math.max,
        e = Math.min,
        i = Math.floor;

    function s(t, e) {
      this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = at.getProp(t, e.s || {
        k: 0
      }, 0, 0, this), this.e = "e" in e ? at.getProp(t, e.e, 0, 0, this) : {
        v: 100
      }, this.o = at.getProp(t, e.o || {
        k: 0
      }, 0, 0, this), this.xe = at.getProp(t, e.xe || {
        k: 0
      }, 0, 0, this), this.ne = at.getProp(t, e.ne || {
        k: 0
      }, 0, 0, this), this.sm = at.getProp(t, e.sm || {
        k: 100
      }, 0, 0, this), this.a = at.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
    }

    return s.prototype = {
      getMult: function getMult(s) {
        this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
        var r = 0,
            a = 0,
            n = 1,
            o = 1;
        this.ne.v > 0 ? r = this.ne.v / 100 : a = -this.ne.v / 100, this.xe.v > 0 ? n = 1 - this.xe.v / 100 : o = 1 + this.xe.v / 100;
        var h = Q.getBezierEasing(r, a, n, o).get,
            p = 0,
            l = this.finalS,
            f = this.finalE,
            c = this.data.sh;
        if (2 === c) p = h(p = f === l ? s >= f ? 1 : 0 : t(0, e(.5 / (f - l) + (s - l) / (f - l), 1)));else if (3 === c) p = h(p = f === l ? s >= f ? 0 : 1 : 1 - t(0, e(.5 / (f - l) + (s - l) / (f - l), 1)));else if (4 === c) f === l ? p = 0 : (p = t(0, e(.5 / (f - l) + (s - l) / (f - l), 1))) < .5 ? p *= 2 : p = 1 - 2 * (p - .5), p = h(p);else if (5 === c) {
          if (f === l) p = 0;else {
            var u = f - l,
                m = -u / 2 + (s = e(t(0, s + .5 - l), f - l)),
                d = u / 2;
            p = Math.sqrt(1 - m * m / (d * d));
          }
          p = h(p);
        } else 6 === c ? (f === l ? p = 0 : (s = e(t(0, s + .5 - l), f - l), p = (1 + Math.cos(Math.PI + 2 * Math.PI * s / (f - l))) / 2), p = h(p)) : (s >= i(l) && (p = t(0, e(s - l < 0 ? e(f, 1) - (l - s) : f - s, 1))), p = h(p));

        if (100 !== this.sm.v) {
          var g = .01 * this.sm.v;
          0 === g && (g = 1e-8);
          var y = .5 - .5 * g;
          p < y ? p = 0 : (p = (p - y) / g) > 1 && (p = 1);
        }

        return p * this.a.v;
      },
      getValue: function getValue(t) {
        this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
        var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
            i = this.o.v / e,
            s = this.s.v / e + i,
            r = this.e.v / e + i;

        if (s > r) {
          var a = s;
          s = r, r = a;
        }

        this.finalS = s, this.finalE = r;
      }
    }, a([nt], s), {
      getTextSelectorProp: function getTextSelectorProp(t, e, i) {
        return new s(t, e, i);
      }
    };
  }();

  function $e(t, e, i) {
    var s = {
      propType: !1
    },
        r = at.getProp,
        a = e.a;
    this.a = {
      r: a.r ? r(t, a.r, 0, k, i) : s,
      rx: a.rx ? r(t, a.rx, 0, k, i) : s,
      ry: a.ry ? r(t, a.ry, 0, k, i) : s,
      sk: a.sk ? r(t, a.sk, 0, k, i) : s,
      sa: a.sa ? r(t, a.sa, 0, k, i) : s,
      s: a.s ? r(t, a.s, 1, .01, i) : s,
      a: a.a ? r(t, a.a, 1, 0, i) : s,
      o: a.o ? r(t, a.o, 0, .01, i) : s,
      p: a.p ? r(t, a.p, 1, 0, i) : s,
      sw: a.sw ? r(t, a.sw, 0, 0, i) : s,
      sc: a.sc ? r(t, a.sc, 1, 0, i) : s,
      fc: a.fc ? r(t, a.fc, 1, 0, i) : s,
      fh: a.fh ? r(t, a.fh, 0, 0, i) : s,
      fs: a.fs ? r(t, a.fs, 0, .01, i) : s,
      fb: a.fb ? r(t, a.fb, 0, .01, i) : s,
      t: a.t ? r(t, a.t, 0, 0, i) : s
    }, this.s = We.getTextSelectorProp(t, e.s, i), this.s.t = e.s.t;
  }

  function Ye(t, e, i) {
    this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = i, this._animatorsData = l(this._textData.a.length), this._pathData = {}, this._moreOptions = {
      alignment: {}
    }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(i);
  }

  function He() {}

  Ye.prototype.searchProperties = function () {
    var t,
        e,
        i = this._textData.a.length,
        s = at.getProp;

    for (t = 0; t < i; t += 1) {
      e = this._textData.a[t], this._animatorsData[t] = new $e(this._elem, e, this);
    }

    this._textData.p && "m" in this._textData.p ? (this._pathData = {
      a: s(this._elem, this._textData.p.a, 0, 0, this),
      f: s(this._elem, this._textData.p.f, 0, 0, this),
      l: s(this._elem, this._textData.p.l, 0, 0, this),
      r: s(this._elem, this._textData.p.r, 0, 0, this),
      p: s(this._elem, this._textData.p.p, 0, 0, this),
      m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
    }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = s(this._elem, this._textData.m.a, 1, 0, this);
  }, Ye.prototype.getMeasures = function (t, e) {
    if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
      this._isFirstFrame = !1;

      var i,
          s,
          r,
          a,
          n,
          o,
          h,
          p,
          l,
          f,
          c,
          u,
          m,
          d,
          g,
          y,
          v,
          b,
          _,
          P = this._moreOptions.alignment.v,
          k = this._animatorsData,
          S = this._textData,
          x = this.mHelper,
          A = this._renderType,
          w = this.renderedLetters.length,
          D = t.l;

      if (this._hasMaskedPath) {
        if (_ = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
          var C,
              E = _.v;

          for (this._pathData.r.v && (E = E.reverse()), n = {
            tLength: 0,
            segments: []
          }, a = E._length - 1, y = 0, r = 0; r < a; r += 1) {
            C = rt.buildBezierData(E.v[r], E.v[r + 1], [E.o[r][0] - E.v[r][0], E.o[r][1] - E.v[r][1]], [E.i[r + 1][0] - E.v[r + 1][0], E.i[r + 1][1] - E.v[r + 1][1]]), n.tLength += C.segmentLength, n.segments.push(C), y += C.segmentLength;
          }

          r = a, _.v.c && (C = rt.buildBezierData(E.v[r], E.v[0], [E.o[r][0] - E.v[r][0], E.o[r][1] - E.v[r][1]], [E.i[0][0] - E.v[0][0], E.i[0][1] - E.v[0][1]]), n.tLength += C.segmentLength, n.segments.push(C), y += C.segmentLength), this._pathData.pi = n;
        }

        if (n = this._pathData.pi, o = this._pathData.f.v, c = 0, f = 1, p = 0, l = !0, d = n.segments, o < 0 && _.v.c) for (n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength), f = (m = d[c = d.length - 1].points).length - 1; o < 0;) {
          o += m[f].partialLength, (f -= 1) < 0 && (f = (m = d[c -= 1].points).length - 1);
        }
        u = (m = d[c].points)[f - 1], g = (h = m[f]).partialLength;
      }

      a = D.length, i = 0, s = 0;
      var T,
          F,
          M,
          I,
          L,
          j = 1.2 * t.finalSize * .714,
          z = !0;
      M = k.length;
      var N,
          B,
          G,
          q,
          W,
          $,
          Y,
          H,
          X,
          U,
          J,
          K,
          Z = -1,
          Q = o,
          tt = c,
          et = f,
          it = -1,
          st = "",
          at = this.defaultPropsArray;

      if (2 === t.j || 1 === t.j) {
        var nt = 0,
            ot = 0,
            ht = 2 === t.j ? -.5 : -1,
            pt = 0,
            lt = !0;

        for (r = 0; r < a; r += 1) {
          if (D[r].n) {
            for (nt && (nt += ot); pt < r;) {
              D[pt].animatorJustifyOffset = nt, pt += 1;
            }

            nt = 0, lt = !0;
          } else {
            for (F = 0; F < M; F += 1) {
              (T = k[F].a).t.propType && (lt && 2 === t.j && (ot += T.t.v * ht), (L = k[F].s.getMult(D[r].anIndexes[F], S.a[F].s.totalChars)).length ? nt += T.t.v * L[0] * ht : nt += T.t.v * L * ht);
            }

            lt = !1;
          }
        }

        for (nt && (nt += ot); pt < r;) {
          D[pt].animatorJustifyOffset = nt, pt += 1;
        }
      }

      for (r = 0; r < a; r += 1) {
        if (x.reset(), q = 1, D[r].n) i = 0, s += t.yOffset, s += z ? 1 : 0, o = Q, z = !1, this._hasMaskedPath && (f = et, u = (m = d[c = tt].points)[f - 1], g = (h = m[f]).partialLength, p = 0), st = "", J = "", X = "", K = "", at = this.defaultPropsArray;else {
          if (this._hasMaskedPath) {
            if (it !== D[r].line) {
              switch (t.j) {
                case 1:
                  o += y - t.lineWidths[D[r].line];
                  break;

                case 2:
                  o += (y - t.lineWidths[D[r].line]) / 2;
              }

              it = D[r].line;
            }

            Z !== D[r].ind && (D[Z] && (o += D[Z].extra), o += D[r].an / 2, Z = D[r].ind), o += P[0] * D[r].an * .005;
            var ft = 0;

            for (F = 0; F < M; F += 1) {
              (T = k[F].a).p.propType && ((L = k[F].s.getMult(D[r].anIndexes[F], S.a[F].s.totalChars)).length ? ft += T.p.v[0] * L[0] : ft += T.p.v[0] * L), T.a.propType && ((L = k[F].s.getMult(D[r].anIndexes[F], S.a[F].s.totalChars)).length ? ft += T.a.v[0] * L[0] : ft += T.a.v[0] * L);
            }

            for (l = !0, this._pathData.a.v && (o = .5 * D[0].an + (y - this._pathData.f.v - .5 * D[0].an - .5 * D[D.length - 1].an) * Z / (a - 1), o += this._pathData.f.v); l;) {
              p + g >= o + ft || !m ? (v = (o + ft - p) / h.partialLength, B = u.point[0] + (h.point[0] - u.point[0]) * v, G = u.point[1] + (h.point[1] - u.point[1]) * v, x.translate(-P[0] * D[r].an * .005, -P[1] * j * .01), l = !1) : m && (p += h.partialLength, (f += 1) >= m.length && (f = 0, d[c += 1] ? m = d[c].points : _.v.c ? (f = 0, m = d[c = 0].points) : (p -= h.partialLength, m = null)), m && (u = h, g = (h = m[f]).partialLength));
            }

            N = D[r].an / 2 - D[r].add, x.translate(-N, 0, 0);
          } else N = D[r].an / 2 - D[r].add, x.translate(-N, 0, 0), x.translate(-P[0] * D[r].an * .005, -P[1] * j * .01, 0);

          for (F = 0; F < M; F += 1) {
            (T = k[F].a).t.propType && (L = k[F].s.getMult(D[r].anIndexes[F], S.a[F].s.totalChars), 0 === i && 0 === t.j || (this._hasMaskedPath ? L.length ? o += T.t.v * L[0] : o += T.t.v * L : L.length ? i += T.t.v * L[0] : i += T.t.v * L));
          }

          for (t.strokeWidthAnim && ($ = t.sw || 0), t.strokeColorAnim && (W = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]), t.fillColorAnim && t.fc && (Y = [t.fc[0], t.fc[1], t.fc[2]]), F = 0; F < M; F += 1) {
            (T = k[F].a).a.propType && ((L = k[F].s.getMult(D[r].anIndexes[F], S.a[F].s.totalChars)).length ? x.translate(-T.a.v[0] * L[0], -T.a.v[1] * L[1], T.a.v[2] * L[2]) : x.translate(-T.a.v[0] * L, -T.a.v[1] * L, T.a.v[2] * L));
          }

          for (F = 0; F < M; F += 1) {
            (T = k[F].a).s.propType && ((L = k[F].s.getMult(D[r].anIndexes[F], S.a[F].s.totalChars)).length ? x.scale(1 + (T.s.v[0] - 1) * L[0], 1 + (T.s.v[1] - 1) * L[1], 1) : x.scale(1 + (T.s.v[0] - 1) * L, 1 + (T.s.v[1] - 1) * L, 1));
          }

          for (F = 0; F < M; F += 1) {
            if (T = k[F].a, L = k[F].s.getMult(D[r].anIndexes[F], S.a[F].s.totalChars), T.sk.propType && (L.length ? x.skewFromAxis(-T.sk.v * L[0], T.sa.v * L[1]) : x.skewFromAxis(-T.sk.v * L, T.sa.v * L)), T.r.propType && (L.length ? x.rotateZ(-T.r.v * L[2]) : x.rotateZ(-T.r.v * L)), T.ry.propType && (L.length ? x.rotateY(T.ry.v * L[1]) : x.rotateY(T.ry.v * L)), T.rx.propType && (L.length ? x.rotateX(T.rx.v * L[0]) : x.rotateX(T.rx.v * L)), T.o.propType && (L.length ? q += (T.o.v * L[0] - q) * L[0] : q += (T.o.v * L - q) * L), t.strokeWidthAnim && T.sw.propType && (L.length ? $ += T.sw.v * L[0] : $ += T.sw.v * L), t.strokeColorAnim && T.sc.propType) for (H = 0; H < 3; H += 1) {
              L.length ? W[H] += (T.sc.v[H] - W[H]) * L[0] : W[H] += (T.sc.v[H] - W[H]) * L;
            }

            if (t.fillColorAnim && t.fc) {
              if (T.fc.propType) for (H = 0; H < 3; H += 1) {
                L.length ? Y[H] += (T.fc.v[H] - Y[H]) * L[0] : Y[H] += (T.fc.v[H] - Y[H]) * L;
              }
              T.fh.propType && (Y = L.length ? V(Y, T.fh.v * L[0]) : V(Y, T.fh.v * L)), T.fs.propType && (Y = L.length ? O(Y, T.fs.v * L[0]) : O(Y, T.fs.v * L)), T.fb.propType && (Y = L.length ? R(Y, T.fb.v * L[0]) : R(Y, T.fb.v * L));
            }
          }

          for (F = 0; F < M; F += 1) {
            (T = k[F].a).p.propType && (L = k[F].s.getMult(D[r].anIndexes[F], S.a[F].s.totalChars), this._hasMaskedPath ? L.length ? x.translate(0, T.p.v[1] * L[0], -T.p.v[2] * L[1]) : x.translate(0, T.p.v[1] * L, -T.p.v[2] * L) : L.length ? x.translate(T.p.v[0] * L[0], T.p.v[1] * L[1], -T.p.v[2] * L[2]) : x.translate(T.p.v[0] * L, T.p.v[1] * L, -T.p.v[2] * L));
          }

          if (t.strokeWidthAnim && (X = $ < 0 ? 0 : $), t.strokeColorAnim && (U = "rgb(" + Math.round(255 * W[0]) + "," + Math.round(255 * W[1]) + "," + Math.round(255 * W[2]) + ")"), t.fillColorAnim && t.fc && (J = "rgb(" + Math.round(255 * Y[0]) + "," + Math.round(255 * Y[1]) + "," + Math.round(255 * Y[2]) + ")"), this._hasMaskedPath) {
            if (x.translate(0, -t.ls), x.translate(0, P[1] * j * .01 + s, 0), this._pathData.p.v) {
              b = (h.point[1] - u.point[1]) / (h.point[0] - u.point[0]);
              var ct = 180 * Math.atan(b) / Math.PI;
              h.point[0] < u.point[0] && (ct += 180), x.rotate(-ct * Math.PI / 180);
            }

            x.translate(B, G, 0), o -= P[0] * D[r].an * .005, D[r + 1] && Z !== D[r + 1].ind && (o += D[r].an / 2, o += .001 * t.tr * t.finalSize);
          } else {
            switch (x.translate(i, s, 0), t.ps && x.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
              case 1:
                x.translate(D[r].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[D[r].line]), 0, 0);
                break;

              case 2:
                x.translate(D[r].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[D[r].line]) / 2, 0, 0);
            }

            x.translate(0, -t.ls), x.translate(N, 0, 0), x.translate(P[0] * D[r].an * .005, P[1] * j * .01, 0), i += D[r].l + .001 * t.tr * t.finalSize;
          }

          "html" === A ? st = x.toCSS() : "svg" === A ? st = x.to2dCSS() : at = [x.props[0], x.props[1], x.props[2], x.props[3], x.props[4], x.props[5], x.props[6], x.props[7], x.props[8], x.props[9], x.props[10], x.props[11], x.props[12], x.props[13], x.props[14], x.props[15]], K = q;
        }
        w <= r ? (I = new Ge(K, X, U, J, st, at), this.renderedLetters.push(I), w += 1, this.lettersChangedFlag = !0) : (I = this.renderedLetters[r], this.lettersChangedFlag = I.update(K, X, U, J, st, at) || this.lettersChangedFlag);
      }
    }
  }, Ye.prototype.getValue = function () {
    this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
  }, Ye.prototype.mHelper = new vt(), Ye.prototype.defaultPropsArray = [], a([nt], Ye), He.prototype.initElement = function (t, e, i) {
    this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, i), this.textProperty = new qe(this, t.t, this.dynamicProperties), this.textAnimator = new Ye(t.t, this.renderType, this), this.initTransform(t, e, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
  }, He.prototype.prepareFrame = function (t) {
    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
  }, He.prototype.createPathShape = function (t, e) {
    var i,
        s,
        r = e.length,
        a = "";

    for (i = 0; i < r; i += 1) {
      "sh" === e[i].ty && (s = e[i].ks.k, a += ze(s, s.i.length, !0, t));
    }

    return a;
  }, He.prototype.updateDocumentData = function (t, e) {
    this.textProperty.updateDocumentData(t, e);
  }, He.prototype.canResizeFont = function (t) {
    this.textProperty.canResizeFont(t);
  }, He.prototype.setMinimumFontSize = function (t) {
    this.textProperty.setMinimumFontSize(t);
  }, He.prototype.applyTextPropertiesToMatrix = function (t, e, i, s, r) {
    switch (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j) {
      case 1:
        e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]), 0, 0);
        break;

      case 2:
        e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]) / 2, 0, 0);
    }

    e.translate(s, r, 0);
  }, He.prototype.buildColor = function (t) {
    return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
  }, He.prototype.emptyProp = new Ge(), He.prototype.destroy = function () {};
  var Xe,
      Ue = {
    shapes: []
  };

  function Je(t, e, i) {
    this.textSpans = [], this.renderType = "svg", this.initElement(t, e, i);
  }

  function Ke(t, e, i) {
    this.initElement(t, e, i);
  }

  function Ze(t, e, i) {
    this.initFrame(), this.initBaseData(t, e, i), this.initFrame(), this.initTransform(t, e, i), this.initHierarchy();
  }

  function Qe() {}

  function ti() {}

  function ei(t, e, i) {
    this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? l(this.layers.length) : [], this.initElement(t, e, i), this.tm = t.tm ? at.getProp(this, t.tm, 0, e.frameRate, this) : {
      _placeholder: !0
    };
  }

  function ii(t, e) {
    this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = B("svg");
    var i = "";

    if (e && e.title) {
      var s = B("title"),
          r = M();
      s.setAttribute("id", r), s.textContent = e.title, this.svgElement.appendChild(s), i += r;
    }

    if (e && e.description) {
      var a = B("desc"),
          n = M();
      a.setAttribute("id", n), a.textContent = e.description, this.svgElement.appendChild(a), i += " " + n;
    }

    i && this.svgElement.setAttribute("aria-labelledby", i);
    var o = B("defs");
    this.svgElement.appendChild(o);
    var h = B("g");
    this.svgElement.appendChild(h), this.layerElement = h, this.renderConfig = {
      preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
      imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
      contentVisibility: e && e.contentVisibility || "visible",
      progressiveLoad: e && e.progressiveLoad || !1,
      hideOnTransparent: !(e && !1 === e.hideOnTransparent),
      viewBoxOnly: e && e.viewBoxOnly || !1,
      viewBoxSize: e && e.viewBoxSize || !1,
      className: e && e.className || "",
      id: e && e.id || "",
      focusable: e && e.focusable,
      filterSize: {
        width: e && e.filterSize && e.filterSize.width || "100%",
        height: e && e.filterSize && e.filterSize.height || "100%",
        x: e && e.filterSize && e.filterSize.x || "0%",
        y: e && e.filterSize && e.filterSize.y || "0%"
      },
      width: e && e.width,
      height: e && e.height
    }, this.globalData = {
      _mdf: !1,
      frameNum: -1,
      defs: o,
      renderConfig: this.renderConfig
    }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
  }

  return a([ae, ue, _e, Pe, ne, ke, He], Je), Je.prototype.createContent = function () {
    this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = B("text"));
  }, Je.prototype.buildTextContents = function (t) {
    for (var e = 0, i = t.length, s = [], r = ""; e < i;) {
      t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (s.push(r), r = "") : r += t[e], e += 1;
    }

    return s.push(r), s;
  }, Je.prototype.buildShapeData = function (t, e) {
    if (t.shapes && t.shapes.length) {
      var i = t.shapes[0];

      if (i.it) {
        var s = i.it[i.it.length - 1];
        s.s && (s.s.k[0] = e, s.s.k[1] = e);
      }
    }

    return t;
  }, Je.prototype.buildNewText = function () {
    var t, e;
    this.addDynamicProperty(this);
    var i = this.textProperty.currentData;
    this.renderedLetters = l(i ? i.l.length : 0), i.fc ? this.layerElement.setAttribute("fill", this.buildColor(i.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), i.sc && (this.layerElement.setAttribute("stroke", this.buildColor(i.sc)), this.layerElement.setAttribute("stroke-width", i.sw)), this.layerElement.setAttribute("font-size", i.finalSize);
    var s = this.globalData.fontManager.getFontByName(i.f);
    if (s.fClass) this.layerElement.setAttribute("class", s.fClass);else {
      this.layerElement.setAttribute("font-family", s.fFamily);
      var r = i.fWeight,
          a = i.fStyle;
      this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", r);
    }
    this.layerElement.setAttribute("aria-label", i.t);
    var n,
        o = i.l || [],
        h = !!this.globalData.fontManager.chars;
    e = o.length;
    var p = this.mHelper,
        f = this.data.singleShape,
        c = 0,
        u = 0,
        m = !0,
        d = .001 * i.tr * i.finalSize;

    if (!f || h || i.sz) {
      var g,
          y = this.textSpans.length;

      for (t = 0; t < e; t += 1) {
        if (this.textSpans[t] || (this.textSpans[t] = {
          span: null,
          childSpan: null,
          glyph: null
        }), !h || !f || 0 === t) {
          if (n = y > t ? this.textSpans[t].span : B(h ? "g" : "text"), y <= t) {
            if (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = n, h) {
              var v = B("g");
              n.appendChild(v), this.textSpans[t].childSpan = v;
            }

            this.textSpans[t].span = n, this.layerElement.appendChild(n);
          }

          n.style.display = "inherit";
        }

        if (p.reset(), f && (o[t].n && (c = -d, u += i.yOffset, u += m ? 1 : 0, m = !1), this.applyTextPropertiesToMatrix(i, p, o[t].line, c, u), c += o[t].l || 0, c += d), h) {
          var b;
          if (1 === (g = this.globalData.fontManager.getCharData(i.finalText[t], s.fStyle, this.globalData.fontManager.getFontByName(i.f).fFamily)).t) b = new ei(g.data, this.globalData, this);else {
            var _ = Ue;
            g.data && g.data.shapes && (_ = this.buildShapeData(g.data, i.finalSize)), b = new Be(_, this.globalData, this);
          }

          if (this.textSpans[t].glyph) {
            var P = this.textSpans[t].glyph;
            this.textSpans[t].childSpan.removeChild(P.layerElement), P.destroy();
          }

          this.textSpans[t].glyph = b, b._debug = !0, b.prepareFrame(0), b.renderFrame(), this.textSpans[t].childSpan.appendChild(b.layerElement), 1 === g.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + i.finalSize / 100 + "," + i.finalSize / 100 + ")");
        } else f && n.setAttribute("transform", "translate(" + p.props[12] + "," + p.props[13] + ")"), n.textContent = o[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
      }

      f && n && n.setAttribute("d", "");
    } else {
      var k = this.textContainer,
          S = "start";

      switch (i.j) {
        case 1:
          S = "end";
          break;

        case 2:
          S = "middle";
          break;

        default:
          S = "start";
      }

      k.setAttribute("text-anchor", S), k.setAttribute("letter-spacing", d);
      var x = this.buildTextContents(i.finalText);

      for (e = x.length, u = i.ps ? i.ps[1] + i.ascent : 0, t = 0; t < e; t += 1) {
        (n = this.textSpans[t].span || B("tspan")).textContent = x[t], n.setAttribute("x", 0), n.setAttribute("y", u), n.style.display = "inherit", k.appendChild(n), this.textSpans[t] || (this.textSpans[t] = {
          span: null,
          glyph: null
        }), this.textSpans[t].span = n, u += i.finalLineHeight;
      }

      this.layerElement.appendChild(k);
    }

    for (; t < this.textSpans.length;) {
      this.textSpans[t].span.style.display = "none", t += 1;
    }

    this._sizeChanged = !0;
  }, Je.prototype.sourceRectAtTime = function () {
    if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
      this._sizeChanged = !1;
      var t = this.layerElement.getBBox();
      this.bbox = {
        top: t.y,
        left: t.x,
        width: t.width,
        height: t.height
      };
    }

    return this.bbox;
  }, Je.prototype.getValue = function () {
    var t,
        e,
        i = this.textSpans.length;

    for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < i; t += 1) {
      (e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
    }
  }, Je.prototype.renderInnerContent = function () {
    if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
      var t, e;
      this._sizeChanged = !0;
      var i,
          s,
          r,
          a = this.textAnimator.renderedLetters,
          n = this.textProperty.currentData.l;

      for (e = n.length, t = 0; t < e; t += 1) {
        n[t].n || (i = a[t], s = this.textSpans[t].span, (r = this.textSpans[t].glyph) && r.renderFrame(), i._mdf.m && s.setAttribute("transform", i.m), i._mdf.o && s.setAttribute("opacity", i.o), i._mdf.sw && s.setAttribute("stroke-width", i.sw), i._mdf.sc && s.setAttribute("stroke", i.sc), i._mdf.fc && s.setAttribute("fill", i.fc));
      }
    }
  }, a([Se], Ke), Ke.prototype.createContent = function () {
    var t = B("rect");
    t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
  }, Ze.prototype.prepareFrame = function (t) {
    this.prepareProperties(t, !0);
  }, Ze.prototype.renderFrame = function () {}, Ze.prototype.getBaseElement = function () {
    return null;
  }, Ze.prototype.destroy = function () {}, Ze.prototype.sourceRectAtTime = function () {}, Ze.prototype.hide = function () {}, a([ae, ue, Pe, ne], Ze), a([ce], Qe), Qe.prototype.createNull = function (t) {
    return new Ze(t, this.globalData, this);
  }, Qe.prototype.createShape = function (t) {
    return new Be(t, this.globalData, this);
  }, Qe.prototype.createText = function (t) {
    return new Je(t, this.globalData, this);
  }, Qe.prototype.createImage = function (t) {
    return new Se(t, this.globalData, this);
  }, Qe.prototype.createSolid = function (t) {
    return new Ke(t, this.globalData, this);
  }, Qe.prototype.configAnimation = function (t) {
    this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
    var e = this.globalData.defs;
    this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
    var i = B("clipPath"),
        r = B("rect");
    r.setAttribute("width", t.w), r.setAttribute("height", t.h), r.setAttribute("x", 0), r.setAttribute("y", 0);
    var a = M();
    i.setAttribute("id", a), i.appendChild(r), this.layerElement.setAttribute("clip-path", "url(" + s() + "#" + a + ")"), e.appendChild(i), this.layers = t.layers, this.elements = l(t.layers.length);
  }, Qe.prototype.destroy = function () {
    var t;
    this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
    var e = this.layers ? this.layers.length : 0;

    for (t = 0; t < e; t += 1) {
      this.elements[t] && this.elements[t].destroy();
    }

    this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
  }, Qe.prototype.updateContainerSize = function () {}, Qe.prototype.buildItem = function (t) {
    var e = this.elements;

    if (!e[t] && 99 !== this.layers[t].ty) {
      e[t] = !0;
      var i = this.createItem(this.layers[t]);
      e[t] = i, j() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(i), i.initExpressions()), this.appendElementInPos(i, t), this.layers[t].tt && (this.elements[t - 1] && !0 !== this.elements[t - 1] ? i.setMatte(e[t - 1].layerId) : (this.buildItem(t - 1), this.addPendingElement(i)));
    }
  }, Qe.prototype.checkPendingElements = function () {
    for (; this.pendingElements.length;) {
      var t = this.pendingElements.pop();
      if (t.checkParenting(), t.data.tt) for (var e = 0, i = this.elements.length; e < i;) {
        if (this.elements[e] === t) {
          t.setMatte(this.elements[e - 1].layerId);
          break;
        }

        e += 1;
      }
    }
  }, Qe.prototype.renderFrame = function (t) {
    if (this.renderedFrame !== t && !this.destroyed) {
      var e;
      null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
      var i = this.layers.length;

      for (this.completeLayers || this.checkLayers(t), e = i - 1; e >= 0; e -= 1) {
        (this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
      }

      if (this.globalData._mdf) for (e = 0; e < i; e += 1) {
        (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
      }
    }
  }, Qe.prototype.appendElementInPos = function (t, e) {
    var i = t.getBaseElement();

    if (i) {
      for (var s, r = 0; r < e;) {
        this.elements[r] && !0 !== this.elements[r] && this.elements[r].getBaseElement() && (s = this.elements[r].getBaseElement()), r += 1;
      }

      s ? this.layerElement.insertBefore(i, s) : this.layerElement.appendChild(i);
    }
  }, Qe.prototype.hide = function () {
    this.layerElement.style.display = "none";
  }, Qe.prototype.show = function () {
    this.layerElement.style.display = "block";
  }, a([ae, ue, Pe, ne, ke], ti), ti.prototype.initElement = function (t, e, i) {
    this.initFrame(), this.initBaseData(t, e, i), this.initTransform(t, e, i), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
  }, ti.prototype.prepareFrame = function (t) {
    if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
      if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;else {
        var e = this.tm.v;
        e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
      }
      var i,
          s = this.elements.length;

      for (this.completeLayers || this.checkLayers(this.renderedFrame), i = s - 1; i >= 0; i -= 1) {
        (this.completeLayers || this.elements[i]) && (this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st), this.elements[i]._mdf && (this._mdf = !0));
      }
    }
  }, ti.prototype.renderInnerContent = function () {
    var t,
        e = this.layers.length;

    for (t = 0; t < e; t += 1) {
      (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }
  }, ti.prototype.setElements = function (t) {
    this.elements = t;
  }, ti.prototype.getElements = function () {
    return this.elements;
  }, ti.prototype.destroyElements = function () {
    var t,
        e = this.layers.length;

    for (t = 0; t < e; t += 1) {
      this.elements[t] && this.elements[t].destroy();
    }
  }, ti.prototype.destroy = function () {
    this.destroyElements(), this.destroyBaseElement();
  }, a([Qe, ti, _e], ei), ei.prototype.createComp = function (t) {
    return new ei(t, this.globalData, this);
  }, a([Qe], ii), ii.prototype.createComp = function (t) {
    return new ei(t, this.globalData, this);
  }, Xe = ii, X.svg = Xe, wt.registerModifier("tm", Ct), wt.registerModifier("pb", Et), wt.registerModifier("rp", Ft), wt.registerModifier("rd", Mt), _t;
}());
var Z = K.exports;

var Q = /*#__PURE__*/function (_t$Component) {
  _inherits(Q, _t$Component);

  function Q() {
    var _this;

    _classCallCheck(this, Q);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Q).apply(this, arguments)), _this.handleClickToPause = function () {
      _this.anim.isPaused ? _this.anim.play() : _this.anim.pause();
    };
    return _this;
  }

  _createClass(Q, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          t = _this$props.options,
          e = _this$props.eventListeners,
          i = t.loop,
          s = t.autoplay,
          r = t.animationData,
          a = t.rendererSettings,
          n = t.segments;
      this.options = {
        container: this.el,
        renderer: "svg",
        loop: !1 !== i,
        autoplay: !1 !== s,
        segments: !1 !== n,
        animationData: r,
        rendererSettings: a
      }, this.options = Object.assign(Object.assign({}, this.options), t), this.anim = Z.loadAnimation(this.options), this.registerEvents(e);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(t) {
      this.options.animationData !== t.options.animationData && (this.deRegisterEvents(this.props.eventListeners), this.destroy(), this.options = Object.assign(Object.assign({}, this.options), t.options), this.anim = Z.loadAnimation(this.options), this.registerEvents(t.eventListeners));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.isStopped ? this.stop() : this.props.segments ? this.playSegments() : this.play(), this.pause(), this.setSpeed(), this.setDirection();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deRegisterEvents(this.props.eventListeners), this.destroy(), this.options.animationData = null, this.anim = null;
    }
  }, {
    key: "setSpeed",
    value: function setSpeed() {
      this.anim.setSpeed(this.props.speed);
    }
  }, {
    key: "setDirection",
    value: function setDirection() {
      this.anim.setDirection(this.props.direction);
    }
  }, {
    key: "play",
    value: function play() {
      this.anim.play();
    }
  }, {
    key: "playSegments",
    value: function playSegments() {
      this.anim.playSegments(this.props.segments);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.anim.stop();
    }
  }, {
    key: "pause",
    value: function pause() {
      (this.props.isPaused && !this.anim.isPaused || !this.props.isPaused && this.anim.isPaused) && this.anim.pause();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.anim.destroy();
    }
  }, {
    key: "registerEvents",
    value: function registerEvents(t) {
      var _this2 = this;

      t.forEach(function (t) {
        _this2.anim.addEventListener(t.eventName, t.callback);
      });
    }
  }, {
    key: "deRegisterEvents",
    value: function deRegisterEvents(t) {
      var _this3 = this;

      t.forEach(function (t) {
        _this3.anim.removeEventListener(t.eventName, t.callback);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          e = _this$props2.width,
          i = _this$props2.height,
          s = _this$props2.ariaRole,
          r = _this$props2.ariaLabel,
          a = _this$props2.isClickToPauseDisabled,
          n = _this$props2.title,
          o = function o(t) {
        var e;
        return e = "number" == typeof t ? "".concat(t, "px") : t || "100%", e;
      },
          h = Object.assign({
        width: o(e),
        height: o(i),
        overflow: "hidden",
        margin: "0 auto",
        outline: "none"
      }, this.props.style),
          p = a ? function () {
        return null;
      } : this.handleClickToPause;

      return t.createElement("div", {
        ref: function ref(t) {
          _this4.el = t;
        },
        style: h,
        onClick: p,
        title: n,
        role: s,
        "aria-label": r,
        tabIndex: "0"
      });
    }
  }]);

  return Q;
}(t.Component);

Q.propTypes = {
  eventListeners: J.arrayOf(J.object),
  options: J.object.isRequired,
  height: J.oneOfType([J.string, J.number]),
  width: J.oneOfType([J.string, J.number]),
  isStopped: J.bool,
  isPaused: J.bool,
  speed: J.number,
  segments: J.arrayOf(J.number),
  direction: J.number,
  ariaRole: J.string,
  ariaLabel: J.string,
  isClickToPauseDisabled: J.bool,
  title: J.string,
  style: J.string
}, Q.defaultProps = {
  eventListeners: [],
  isStopped: !1,
  isPaused: !1,
  speed: 1,
  ariaRole: "button",
  ariaLabel: "animation",
  isClickToPauseDisabled: !1,
  title: ""
};
export { Q as Lottie };